import React, { Component } from 'react'; // v2
import MobileWalletSection from './MobileWalletSection';
import MobileUserBar from './MobileUserBar';
import Navmenu from "./navmenu";
import { withRouter } from './withRouter';
import SweetAlert from 'react-bootstrap-sweetalert';
//import Paoyingchub from './game/paoyingchub';
import jwt_decode from "jwt-decode";
import instance from "./axios-instance";
//import './build/web/igame-index-lobby-wm/style.a57427aa.css';
import { isMobile } from 'react-device-detect';

import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import md5 from 'md5';
class App extends Component {

    constructor(props) {
        super(props)
        this.state = {
            mainsetting: [],
            rewardlist: [],
            activePage: 1,
            checkboxcookie: false,
            isActive: false,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: true, // Indicates in progress state of login form
            pagecount: 1,
            username: null,
            settingwheel: "",
            settingcheckin: "",
            userid: null,
            phoneNumber: "",
            balance: 0,
            mainacc: null,
            paymentgateway: null,
            tabselect: 1,
            tabselectsec: 0,
            qrcode: null,
            stateregis: 1,
            checkboxacc: 0,
            products_page_count: 1,
            loginstate: false,
            fullname: null,
            lname: null,
            link: "",
            alert: null,
            depositstate: 0,
            stateforget: 1,
            depositamount: 0,
            stateopterror: "",
            btnisActive: true,
            otpphone: "",
            token: window.localStorage.getItem("token"),
            accnumber: null,
            accnumbertxt: null,
            withdrawamount: 0,
            rankpoint: 0,
            changepassword: false,
            linelink: "",
            errortext: "",
            trueaccount: null,
            trueaccount: null,
            datas: null,
            otpphoneforget: "",
            affpercent: 0,
            counter: 300,
            userrecomend: "",
            historylist: [],
            useradvice: [],
            cashoutlist: [],
            tblnextrank: [],
            tblrankall: [],
            maxwithdrawstatus: 0,
            tblprofile: [],
            prodetail: [],
            oldpassword: "",
            linkaff: "",
            webnamex: "",
            inviteSet: "",
            truegiftlink: "",
            proderedeem: [],
            qrcode: null,
            proderedeemlist: [],
            buttoncliam: false,
            limit: null,
            rankpic: "1.jpeg",
            rankname: null,
            rankob: null,
            cashoutSet: [],
            tblPopupMenu1: [],
            tblPopupMenu2: [],
            tblPopupMenu: null,
            termAndCondition: false,
            errorstatus: false,
            /* ── BK8 UI additions ── */
            showMore: false,
            refreshing: false,
            selectedNetwork: '',
            isGuideOpen: false,
            showMemberAction: false,
            isMenuOpen: false,
            menuOpenIndex: 0,
            showSlipModal: false,
            files: [],
            isUploading: false,
            slipImage: null,
            slipPreview: null,
            checkcredit: false,
            /* ── Slip Upload Tab ── */
            slipFiles: [],
            slipTabPreviewUrl: null,
            slipIsConfirmed: false,
            slipIsUploading: false,
        }
    }

    toggleGuideMenu = () => {
        this.setState(prev => ({ isGuideOpen: !prev.isGuideOpen }));
    }

    handleSlipUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const preview = URL.createObjectURL(file);
        this.setState({ slipImage: file, slipPreview: preview });
    }

    removeSlip = () => {
        this.setState({ slipImage: null, slipPreview: null });
        if (this._slipInput) this._slipInput.value = '';
    }

    handleFileSelected = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const previewUrl = URL.createObjectURL(file);
        // ใช้ร่วมกันทั้ง modal และ tab
        this.setState({ files: [file], slipFiles: [file], slipTabPreviewUrl: previewUrl, slipIsConfirmed: false });
    }

    uploadSlip = async (num) => {
        const { files } = this.state;
        if (!files || !files[0]) return;
        this.setState({ isUploading: true });
        try {
            const token = localStorage.getItem('auth_token') || localStorage.getItem('token');
            const formData = new FormData();
            formData.append('file', files[0]);
            if (token) formData.append('token', token);
            await instance.post('/api/v1/uploadslip', formData, {
                headers: { 'Content-Type': 'multipart/form-data', ...(token ? { Authorization: `Bearer ${token}` } : {}) }
            });
            this.setState({ isUploading: false, showSlipModal: false, slipIsConfirmed: true, files: [] });
            await Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'อัปโหลดสลิปสำเร็จ!', showConfirmButton: false, timer: 2000 });
        } catch (err) {
            this.setState({ isUploading: false });
            await Swal.fire({ toast: true, position: 'top-end', icon: 'error', title: 'อัปโหลดไม่สำเร็จ กรุณาลองใหม่', showConfirmButton: false, timer: 2000 });
        }
    }

    handleConfirmUpload = async () => {
        const { slipFiles } = this.state;
        if (!slipFiles || slipFiles.length === 0) return;
        this.setState({ slipIsUploading: true });
        try {
            const token = localStorage.getItem('auth_token') || localStorage.getItem('token');
            const formData = new FormData();
            formData.append('file', slipFiles[0]);
            if (token) formData.append('token', token);
            await instance.post('/api/v1/uploadslip', formData, {
                headers: { 'Content-Type': 'multipart/form-data', ...(token ? { Authorization: `Bearer ${token}` } : {}) }
            });
            this.setState({ slipIsConfirmed: true, slipIsUploading: false });
        } catch (err) {
            this.setState({ slipIsUploading: false });
            await Swal.fire({ toast: true, position: 'top-end', icon: 'error', title: 'อัปโหลดไม่สำเร็จ กรุณาลองใหม่', showConfirmButton: false, timer: 2000 });
        }
    }

    handleClearFile = () => {
        this.setState({ slipFiles: [], slipTabPreviewUrl: null, slipIsConfirmed: false, slipIsUploading: false });
        if (this._slipTabInput) this._slipTabInput.value = '';
    }

    recheccredit = async (e) => {
        if (e) e.preventDefault();
        const token = localStorage.getItem('auth_token') || localStorage.getItem('token');
        if (!token) return;
        try {
            const decoded = jwt_decode(token);
            this.setState({ checkcredit: true });
            await this.rechecklogin(decoded.message.playerid, token);
        } catch (err) { }
        this.setState({ checkcredit: false });
    }

    checkurl = (e, path) => {
        if (e) e.preventDefault();
        if (this.props && this.props.navigate) {
            this.props.navigate(path);
        } else {
            window.location.href = path;
        }
    }

    refreshBalance = async () => {
        const token = localStorage.getItem('auth_token');
        if (!token) return;
        try {
            const decoded = jwt_decode(token);
            this.setState({ refreshing: true });
            await this.rechecklogin(decoded.message.playerid, token);
        } catch (e) { }
        this.setState({ refreshing: false });
    }

    checktab(e, index) {
        //console.log(index == 2 &&  this.state.qrcode != null);
        if (index == 2 && this.state.tabselectsec == 1) {

        }
        else {
            if (index == 2 && this.state.qrcode != null) {
                this.setState({
                    tabselect: 0,
                    tabselectsec: 1,
                });
            }
            else {
                this.setState({
                    tabselect: index,
                    tabselectsec: 0,
                });
            }
        }
    }
    onChangexdep = event => {
        ////console.log(event.target.value);
        if (event.target !== undefined) {

            this.setState({ depositamount: event.target.value });
        }
    };

    copyText = async (text) => {
        if (!text || String(text).trim() === '') {
            await Swal.fire({ toast: true, position: 'top-end', icon: 'warning', title: 'ไม่พบเลขบัญชี', showConfirmButton: false, timer: 1800 });
            return;
        }
        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(String(text));
            } else {
                // fallback สำหรับ HTTP หรือ browser เก่า
                const el = document.createElement('textarea');
                el.value = String(text);
                el.style.position = 'fixed';
                el.style.top = '-9999px';
                el.style.left = '-9999px';
                document.body.appendChild(el);
                el.focus();
                el.select();
                document.execCommand('copy');
                document.body.removeChild(el);
            }
            await Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'คัดลอกแล้ว!', showConfirmButton: false, timer: 1500 });
        } catch (err) {
            await Swal.fire({ toast: true, position: 'top-end', icon: 'error', title: 'คัดลอกไม่สำเร็จ', showConfirmButton: false, timer: 1800 });
        }
    }

    handleClickdeposit = async (e, price) => {
        this.setState({
            depositamount: price

        });
    }

    confirmdeposit = async (e, num) => {
        e.preventDefault();
        const token = localStorage.getItem('auth_token');
        if (!token) return;

        const decoded = jwt_decode(token);
        const Username = decoded.message.playerid;
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        if (num === 0) {
            if (this.state.depositamount >= this.state.limit.min && this.state.depositamount <= this.state.limit.max) {
                await instance.post("/api/v1/getqrcode", {
                    username: Username,
                    System: Systems,
                    paymentstate: 1,
                    amount: this.state.depositamount
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then((res) => {
                    console.log("mainacc", res.data);
                    const d = res.data || {};
                    // field อยู่ได้ทั้งระดับบนสุด หรือใน tblpaymentgatewayx (apay24 / type 10)
                    const gw = d.tblpaymentgatewayx || {};
                    const st = Number(d.status || gw.status);
                    const llx = this.state.linelink;
                    const msgX = d.message || gw.message || '';

                    // ── เคส QR เก่า / reuse — เช็คก่อน ไม่ว่า success จะ true/false ──
                    const isOld = d.isOld === true || gw.isOld === true
                        || ['old', 'reuse', 'exist', 'existing'].includes(String(d.state).toLowerCase())
                        || ['old', 'reuse', 'exist', 'existing'].includes(String(gw.state).toLowerCase())
                        || /ค้างอยู่|มีรายการฝาก|ยังไม่หมดอายุ|รายการเดิม|รายการฝากเดิม/.test(msgX);
                    const oldLink = gw.link || d.link || (d.rows && d.rows.qrcode) || gw.QRcode || d.qrcode || null;
                    if (isOld && oldLink) {
                        this.setState({ qrcode: null, depositstate: 0 });
                        // ใช้ยอดเงินเก่าจากรายการเดิม (backend ส่ง pg.amount / pg.trueamount) เป็นอันดับแรก
                        const oldAmount = gw.amount || gw.trueamount || gw.Amount || d.amount || d.trueamount || this.state.depositamount || 0;
                        const amtStr = Number(oldAmount || 0).toLocaleString('en', { minimumFractionDigits: 2 });
                        Swal.fire({
                            title: '⚠ พบ QR Code เก่าค้างอยู่',
                            html: `<div style="font-size:14px;color:#333;line-height:1.7;">${msgX || 'พบรายการฝากเดิมที่ยังไม่หมดอายุ'}</div>`
                                + `<div style="background:#fff7ed;border:1px solid #fed7aa;border-radius:10px;padding:12px 16px;margin:14px auto 0;max-width:300px;">`
                                + `<div style="font-size:12.5px;color:#9a3412;">นี่คือ QR Code / รายการเดิมที่ยังไม่หมดอายุ</div>`
                                + `<div style="font-size:26px;font-weight:800;color:#ea580c;margin-top:4px;">฿ ${amtStr}</div>`
                                + `</div>`
                                + `<div style="font-size:13.5px;color:#555;margin-top:14px;">ต้องการเปิดลิงก์ชำระเงินเดิมหรือไม่?</div>`,
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: '🔗 เปิดลิงก์ชำระเงิน',
                            confirmButtonColor: '#0a5ebd',
                            cancelButtonText: '🚫 แจ้งยกเลิก',
                            cancelButtonColor: '#e74c3c'
                        }).then((r) => {
                            if (r.isConfirmed) {
                                // ตกลง → ตั้งสถานะหน้าชำระเงิน (เหมือนฝากปกติ) + เปิดลิงก์เดิม
                                this.setState({
                                    mainacc: d.mainacc,
                                    listacc: d.tblmain,
                                    qrcode: gw.QRcode || oldLink,
                                    paymentlist: { ...gw, link: oldLink, amount: oldAmount },
                                    destep: 2,
                                    counter: 300,
                                    qrcodecheck: true,
                                    tabselectsec: 1,
                                    tabselect: 0,
                                    depositstate: 1
                                });
                                window.open(oldLink, '_blank', 'noopener,noreferrer');
                                this.notify('info', 'เปิดลิงก์ชำระเงินรายการเดิม กรุณาดำเนินการชำระเงิน');
                            } else if (r.dismiss === Swal.DismissReason.cancel && llx) {
                                window.open(llx, '_blank', 'noopener,noreferrer');
                            }
                        });
                        return;
                    }

                    // ── เคส error ทั่วไป — success === false หรือ status >= 202 ──
                    if (d.success === false || gw.success === false || (st && st >= 202)) {
                        const msg = d.message || gw.message || 'ไม่สามารถสร้างรายการฝากได้ กรุณาลองใหม่อีกครั้ง';
                        this.setState({ qrcode: null, depositstate: 0 });
                        const ll = this.state.linelink;
                        const lineBtn = ll
                            ? `<a href="${ll}" target="_blank" rel="noreferrer" style="display:inline-flex;align-items:center;gap:6px;margin-top:14px;background:#06C755;color:#fff;text-decoration:none;padding:9px 18px;border-radius:8px;font-weight:700;font-size:14px;">💬 แจ้งพนักงาน (LINE)</a>`
                            : '';
                        Swal.fire({
                            title: 'ไม่สามารถสร้างรายการได้',
                            html: `<div style="font-size:14.5px;color:#333;line-height:1.7;">${msg}</div>`
                                + `<div style="font-size:13px;color:#d35400;margin-top:10px;line-height:1.6;">โปรดใช้ QR เก่าในการชำระเงิน หรือแจ้งพนักงาน</div>`
                                + lineBtn,
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'ตกลง',
                            confirmButtonColor: '#f5a623',
                            cancelButtonText: 'ยกเลิกรายการ',
                            cancelButtonColor: '#e74c3c'
                        }).then((r) => {
                            if (r.dismiss === Swal.DismissReason.cancel) {
                                Swal.fire({
                                    title: 'แจ้งยกเลิกรายการ',
                                    html: `<div style="font-size:14px;color:#333;line-height:1.7;">กรุณาติดต่อพนักงานผ่านไลน์ เพื่อยกเลิกรายการฝากที่ค้างอยู่</div>`
                                        + lineBtn,
                                    icon: 'info',
                                    confirmButtonText: 'ตกลง',
                                    confirmButtonColor: '#06C755'
                                });
                            }
                        });
                        return;
                    }
                    if (res.data?.tblpaymentgatewayx?.link) {
                        const link = res.data.tblpaymentgatewayx.link;
                        const ua = navigator.userAgent;
                        const isIOS = /iPad|iPhone|iPod/.test(ua) ||
                            (ua.includes("Mac") && "ontouchend" in document);

                        if (isIOS) {
                            window.location.href = link;
                        } else {
                            if (!isMobile) {
                                window.open(link, "_blank", "noopener,noreferrer,width=1000,height=1000");
                            } else {
                                window.open(link, "_blank");
                            }
                        }
                    }
                    this.setState({
                        mainacc: res.data.mainacc,
                        listacc: res.data.tblmain,
                        qrcode: res.data.tblpaymentgatewayx?.QRcode,
                        paymentlist: res.data.tblpaymentgatewayx,
                        destep: 2,
                        counter: 300,
                        qrcodecheck: true,
                        tabselectsec: 1,
                        tabselect: 0,
                        depositstate: 1
                    });
                    this.notify("success", "กรุณาดำเนินการภายใน 5 นาที");
                });
            } else {
                this.notify("warning", `เติมขั้นต่ำ ${this.state.limit.min} บาท สูงสุด ${this.state.limit.max} บาท`);
            }
        }
        else if (num === 7) {
            // PromptPay QR
            if (this.state.depositamount >= this.state.limit.min && this.state.depositamount <= this.state.limit.max) {
                await instance.post("/api/v1/getqrcode", {
                    username: Username,
                    System: Systems,
                    amount: this.state.depositamount
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then((res) => {
                    const d = res.data || {};
                    const gw = d.tblpaymentgatewayx || {};
                    const st = Number(d.status || gw.status);
                    if (d.success === false || gw.success === false || (st && st >= 202)) {
                        const msg = d.message || gw.message || 'ไม่สามารถสร้างรายการฝากได้ กรุณาลองใหม่อีกครั้ง';
                        this.setState({ qrcode: null, depositstate: 0 });
                        const ll = this.state.linelink;
                        const lineBtn = ll
                            ? `<a href="${ll}" target="_blank" rel="noreferrer" style="display:inline-flex;align-items:center;gap:6px;margin-top:14px;background:#06C755;color:#fff;text-decoration:none;padding:9px 18px;border-radius:8px;font-weight:700;font-size:14px;">💬 แจ้งพนักงาน (LINE)</a>`
                            : '';
                        Swal.fire({
                            title: 'ไม่สามารถสร้างรายการได้',
                            html: `<div style="font-size:14.5px;color:#333;line-height:1.7;">${msg}</div>`
                                + `<div style="font-size:13px;color:#d35400;margin-top:10px;line-height:1.6;">โปรดใช้ QR เก่าในการชำระเงิน หรือแจ้งพนักงาน</div>`
                                + lineBtn,
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'ตกลง',
                            confirmButtonColor: '#f5a623',
                            cancelButtonText: 'ยกเลิกรายการ',
                            cancelButtonColor: '#e74c3c'
                        }).then((r) => {
                            if (r.dismiss === Swal.DismissReason.cancel) {
                                Swal.fire({
                                    title: 'แจ้งยกเลิกรายการ',
                                    html: `<div style="font-size:14px;color:#333;line-height:1.7;">กรุณาติดต่อพนักงานผ่านไลน์ เพื่อยกเลิกรายการฝากที่ค้างอยู่</div>`
                                        + lineBtn,
                                    icon: 'info',
                                    confirmButtonText: 'ตกลง',
                                    confirmButtonColor: '#06C755'
                                });
                            }
                        });
                        return;
                    }
                    this.setState({
                        mainacc: res.data.mainacc,
                        paymentgateway: res.data.tblpaymentgatewayx,
                        qrcode: res.data.picture,
                        counter: 300,
                        tabselectsec: 1,
                        tabselect: 0,
                        depositstate: 1
                    });
                });
            } else {
                this.notify("warning", `เติมขั้นต่ำ ${this.state.limit.min} บาท สูงสุด ${this.state.limit.max} บาท`);
            }
        }
        else if (num === 1) {
            this.setState({ depositstate: 1 });
        }
        else if (num === 5) {
            document.getElementById("truemonney").click();
        }
        else {
            this.setState({ depositstate: 0 });
        }
    }
    checklogin() {
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            //////console.log(decoded);
            this.setState({
                userid: decoded.message.playerid,
                username: decoded.message.playerid,
                firstname: decoded.message.firstname,
                lastname: decoded.message.lastname,
                point: decoded.message.Point,
                loginstate: true,
            });
        }
        else {
            this.setState({
                loginstate: false,
            });
        }
    }
    async rechecklogin(Username, token) {

        try {
            // console.log(4);
            const search = window.location.href;
            const paramx = new URLSearchParams(search);
            // const space = search.split("/")
            const space = window.location.host
            var userhash = md5(Username);
            //  const linkaff = "https://pgline88.com/?register=" + userhash;
            const linkaff = "https://" + space + "/register?reg=" + userhash;
            instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'rechecklogin-navbar.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //  console.log(res.data);
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token)
                    this.setState({
                        rankpic: res.data.tblrank?.image,
                        rankname: res.data.tblrank?.name,
                        linkaff: linkaff,
                        rankob: res.data.tblrank,
                        rankpoint: res.data.rankpoint,
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        tblprofile: res.data.message,
                        username: res.data.message.playerid,
                        fname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                    });
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
                        icon: 'warning',
                        confirmButtonText: 'ตกลง'
                    })
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                console.log(err)
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
                        icon: 'warning',
                        confirmButtonText: 'ตกลง'
                    })
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
            //////console.log(ex);
        }

    }
    async componentDidMount() {
        // this.checklogin();
        setInterval(() =>
            this.setState({
                counter: this.state.counter - 1
            })
            , 1000);
        try {
            var token = localStorage.getItem('auth_token');
            //  //////console.log(token);
            if (token != null) {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                await this.rechecklogin(Username, token);
                this.setState({
                    userid: decoded.message.playerid,
                    username: decoded.message.playerid,
                    firstname: decoded.message.firstname,
                    lastname: decoded.message.lastname,
                    loginstate: true,
                });
            }
            else {
                this.setState({ loginstate: false });
                window.location.href = '/';
                return;
            }
            if (token != null) {
                var decoded = jwt_decode(token);
                let Username = decoded.message.playerid;
                instance.post("/api/v1/getqrcode", {
                    username: Username,
                    System: Systems,
                    amount: 50
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(async (res) => {
                    //////console.log(res.data.picture)
                    console.log(16888, res.data.mainacc)
                    this.setState({
                        mainacc: res.data.mainacc,
                        paymentgateway: res.data.tblpaymentgatewayx,
                    });
                });
            }

            await instance.post("/api/v1/gettrue", {
                userid: Username,
                System: Systems,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {
                    console.log(res);
                    this.setState({
                        trueaccount: res.data.message.tbltruewallet[0],
                    });

                }
            }).catch(async (err) => {
            });
        }
        catch (error) {
            //////console.log();
        }
        try {

            await instance.post("/api/v1/mainsetting", {
                System: Systems,
            }).then((res) => {
                if (res.data.status === 200) {
                    const datas = res.data.message;
                    // console.log( datas[7].value)
                    var min = res.data.tblcatagoryx[0].limitdeposit;
                    var max = res.data.tblcatagoryx[0].maxdeposit;
                    var maxwithdrawstatus = res.data.tblcatagoryx[0].withdrawmax
                    var limit = { min, max }
                    this.setState({
                        maxwithdrawstatus: maxwithdrawstatus,
                        linelink: datas[1].value,
                        webnamex: datas[7].value,
                        System: res.data.tblcatagoryx[0].System,
                        cashoutSet: res.data.tblcashoutsetting[0],
                        inviteSet: res.data.tblinvitedsetting[0],
                        datas: datas,
                        limit: limit,
                    });
                }
                else {
                    // this.CheckThisGoalError();
                }
            });
        }
        catch (ex) {
            console.log(ex);
        }
    }


    renderMobile() {
        const {
            accnumber, paymentgateway, firstname, mainacc, trueaccount,
            linelink, balance, username, tabselect, tabselectsec,
            qrcode, counter, depositamount, limit,
            refreshing, showMore, showMemberAction, loginstate, historylist,
            rankname, rankpoint, isGuideOpen, slipImage, slipPreview,
            slipFiles, slipTabPreviewUrl, slipIsConfirmed, slipIsUploading,
            isMenuOpen, menuOpenIndex,
            showSlipModal, files, isUploading
        } = this.state;

        const accnumberx = (accnumber != null && accnumber.length > 0) ? accnumber[0] : null;
        const amountPresets = [100, 300, 500, 1000, 3000, 5000];
        const formatAccNo = (s) => {
            if (!s) return '-';
            const str = String(s).replace(/-/g, '');
            if (str.length >= 12) return `${str.substring(0, 3)}-${str.substring(3, 9)}-${str.substring(9, 12)}`;
            if (str.length >= 10) return `${str.substring(0, 3)}-${str.substring(3, 7)}-${str.substring(7)}`;
            return str;
        };

        const bkCss = `
            /* ══ PAGE ══ */
            .bk-deposit-page{min-height:100vh;background:#f5f6f8;padding-bottom:80px;font-family:'Prompt','Noto Sans Thai',sans-serif;max-width:100vw;overflow-x:hidden;color:#1a1a1a;}

            /* ══ NAVBAR HEADER ══ */
            .mobile-navbar-header{position:sticky;top:0;z-index:150;background:#fff;box-shadow:none!important;border:none!important;border-bottom:none!important;}
            .mobile-nav{display:flex;align-items:center;justify-content:space-between;padding:0 16px;height:56px;width:100%;box-sizing:border-box;border:none!important;box-shadow:none!important;}
            .mobile-nav.header-grey{background:#fff;border:none!important;box-shadow:none!important;}
            .bk-deposit-page header{border:none!important;box-shadow:none!important;}
            .bk-deposit-page header *{border-bottom:none!important;}
            .col-left{display:flex;align-items:center;gap:12px;flex:1;min-width:0;}
            .col-right{display:flex;align-items:center;flex-shrink:0;}
            .menu-icon.beta-back{width:22px;height:22px;flex-shrink:0;}
            p.page-title{margin:0;font-size:17px;font-weight:700;color:#1a1a1a;flex:1;}
            .sb-content{position:fixed;top:0;left:-110%;width:75vw;max-width:320px;height:100vh;background:#fff;z-index:600;overflow-y:auto;padding:20px 16px;box-shadow:4px 0 16px rgba(0,0,0,0.18);transition:left .3s ease;box-sizing:border-box;}
            .sb-content.isOpen{left:0;}
            .sb-close-btn{position:absolute;top:12px;right:12px;background:none;border:none;font-size:26px;cursor:pointer;color:#666;padding:4px;line-height:1;}
            .sb-acc-info{display:flex;align-items:center;justify-content:space-between;padding:40px 0 16px;}
            .acc-info{display:flex;align-items:center;gap:10px;flex:1;min-width:0;}
            .sb-leaderboard{display:flex;flex-direction:column;align-items:flex-end;gap:4px;flex-shrink:0;}
            .deposit-progress{height:4px;background:#f3f4f6;border-radius:2px;margin:8px 0;}
            .sb-menu.margin-top{margin-top:8px;}
            .common-menu{border-top:1px solid #f3f4f6;margin-top:16px;padding-top:8px;}
            .sb-content.isOpen::before{content:'';position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.4);z-index:-1;}

            /* ══ WALLET SECTION (base — detail overrides below) ══ */
            .member-wallet-links{display:flex;align-items:center;flex-wrap:wrap;gap:0;margin-bottom:6px;}
            .member-wallet-link{font-size:11px;color:#009bd8;cursor:pointer;white-space:nowrap;}
            .member-wallet-sep{color:#ddd;margin:0 5px;font-size:11px;}
            .wallet-balance-section{display:flex;align-items:center;justify-content:space-between;padding-bottom:10px;}
            .wallet-amount-container{display:flex;align-items:baseline;gap:6px;}
            .header-right{display:flex;align-items:flex-start;gap:4px;padding-top:2px;}
            .refresh-btn{background:none;border:none;cursor:pointer;padding:4px;display:flex;align-items:center;color:#009bd8;}
            .refresh-btn svg{width:18px!important;height:18px!important;display:block!important;max-width:18px!important;}

            /* ── member-action top (ฝากเงิน/ถอนเงิน always visible) ── */
            .action-label{margin:0;font-size:11px;color:#374151;font-weight:500;text-align:center;white-space:nowrap;font-family:'Prompt','Noto Sans Thai',sans-serif;}

            /* ── top action SVG size (no !important — container width constrains it) ── */
            .member-action:not(.bottom-content) .action-box svg{width:34px;height:34px;display:block;flex-shrink:0;overflow:visible;}

            /* ── bottom-content (collapse section) ── */
            .member-action.bottom-content{display:none;flex-wrap:wrap;gap:8px;padding:8px 0 12px;}
            .member-action.bottom-content.show{display:flex!important;}
            .member-action.bottom-content .action-box{width:60px;max-width:60px;}
            .member-action.bottom-content .action-box svg{width:44px;height:44px;display:block;flex-shrink:0;overflow:visible;}
            .message-container{position:relative;display:inline-flex;align-items:center;justify-content:center;width:44px;height:44px;}
            .message-container svg{width:44px;height:44px;display:block;}
            .unread-msg{position:absolute;top:-4px;right:-4px;background:#ef4444;color:#fff;font-size:9px;font-weight:700;border-radius:50%;width:16px;height:16px;display:flex;align-items:center;justify-content:center;margin:0;}

            /* ── collapse / show-more toggle — override Bootstrap's .collapse{display:none} ── */
            .bk-deposit-page .collapse{display:flex!important;align-items:center;justify-content:center;gap:6px;padding:8px 0;cursor:pointer;font-size:13px;color:#009bd8;border-top:1px solid #f0f0f0;user-select:none;}
            .bk-deposit-page .collapse p{margin:0;font-size:13px;color:#009bd8;}
            .bk-deposit-page .collapse svg{width:8px!important;height:14px!important;pointer-events:none;}
            .slide-arrow .st0{fill:#009bd8;}

            /* ══ BANNER ══ */
            .bk-banner{margin:12px 20px 0;height:46px;overflow:hidden;border-radius:4px;background:#e8e8e8;line-height:0;}
            .bk-banner img{width:100%;height:46px;object-fit:cover;display:block;}

            /* ══ DEPOSIT TABS (BK8 style) ══ */
            .bk-dep-tabs{display:flex;margin:18px 20px 0;gap:6px;background:transparent;border:none;overflow:visible;}
            .bk-dep-tab{flex:1;padding:8px 4px;text-align:center;font-size:11px;font-weight:600;color:#fff;cursor:pointer;border:none;background:#aab5bd;font-family:inherit;line-height:1.3;border-radius:6px;min-height:48px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;transition:background .15s;}
            .bk-dep-tab.bk-dep-tab-active{background:#009bd8;color:#fff;}
            .bk-dep-tab-subtitle{font-size:10px;font-weight:400;opacity:.95;display:block;line-height:1.2;}

            /* ══ SECTION BAR ══ */
            .bk-section-bar{display:flex;align-items:center;justify-content:space-between;margin:14px 20px 8px;}
            .bk-section-title{font-size:14px;font-weight:700;color:#1a1a1a;display:flex;align-items:center;gap:5px;}
            .bk-section-hint{font-size:11px;color:#ef4444;max-width:140px;text-align:right;line-height:1.4;}

            /* ══ BANK CARD ══ */
            .bk-bank-card{background:#fff;border-radius:12px;margin:0 20px 10px;box-shadow:0 1px 6px rgba(0,0,0,0.07);overflow:hidden;border:2px solid transparent;}
            .bk-bank-card.bk-selected{border-color:#ff8a00;}
            .bk-bank-inner{padding:14px;display:flex;align-items:center;gap:12px;}
            .bk-bank-img{width:46px;height:46px;border-radius:10px;object-fit:cover;background:#f3f4f6;flex-shrink:0;}
            .bk-bank-text{flex:1;min-width:0;}
            .bk-bank-name{font-size:14px;font-weight:600;color:#1a1a1a;}
            .bk-bank-sub{font-size:12px;color:#9ca3af;margin-top:2px;}
            .bk-online-badge{font-size:10px;background:#dcfce7;color:#16a34a;border-radius:20px;padding:2px 9px;font-weight:600;white-space:nowrap;flex-shrink:0;}
            .bk-accno-row{background:#f9fafb;border-top:1px solid #f3f4f6;padding:12px 14px;display:flex;align-items:center;justify-content:space-between;}
            .bk-accno-text{font-size:18px;font-weight:700;letter-spacing:1.5px;color:#1a1a1a;}
            .bk-copy-btn{background:linear-gradient(135deg,#ff8a00,#ff5500);color:#fff;border:none;border-radius:8px;padding:8px 18px;font-size:13px;font-weight:700;cursor:pointer;white-space:nowrap;touch-action:manipulation;}

            /* ══ USER BANK CARD ══ */
            .bk-user-bank-card{background:#fff;border-radius:12px;margin:0 20px 10px;padding:12px 14px;box-shadow:0 1px 6px rgba(0,0,0,0.07);display:flex;align-items:center;gap:12px;border:1.5px solid #e5e7eb;}

            /* ══ INFO / WARN BOX ══ */
            .bk-info-box{margin:0 20px 10px;padding:10px 14px;background:#eff6ff;border-radius:10px;font-size:12px;color:#2563eb;border-left:3px solid #009bd8;line-height:1.5;}
            .bk-warn-box{margin:0 20px 10px;padding:10px 14px;background:#fffbeb;border-radius:10px;font-size:12px;color:#b45309;border-left:3px solid #f59e0b;line-height:1.5;}
            .bk-info-box svg,.bk-warn-box svg{width:14px!important;height:14px!important;flex-shrink:0;vertical-align:middle;}

            /* ══ FORM CARD ══ */
            .bk-amount-section{margin:0 20px 10px;background:#fff;border-radius:12px;padding:14px;box-shadow:0 1px 6px rgba(0,0,0,0.07);}
            .bk-form-card{background:#fff;border-radius:12px;margin:10px 20px 0;padding:14px;box-shadow:0 1px 6px rgba(0,0,0,.07);}
            .bk-form-label{font-size:13px;color:#374151;font-weight:600;margin:0 0 8px;display:block;}
            .bk-amount-label{font-size:13px;color:#374151;font-weight:600;margin-bottom:8px;}

            /* ══ INPUTS ══ */
            .bk-amount-input{width:100%;padding:0 14px;border:1.5px solid #e5e7eb;border-radius:10px;font-size:16px;color:#1a1a1a;background:#fff;margin-bottom:12px;box-sizing:border-box;outline:none;font-family:inherit;height:52px;}
            .bk-amount-input:focus{border-color:#009bd8;}
            .bk-select{width:100%;padding:0 12px;border:1.5px solid #e5e7eb;border-radius:10px;font-size:14px;color:#1a1a1a;background:#fff;font-family:inherit;outline:none;-webkit-appearance:none;appearance:none;box-sizing:border-box;height:52px;}
            .bk-select:focus{border-color:#009bd8;}

            /* ══ PRESET GRID ══ */
            .bk-preset-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin-bottom:14px;}
            .bk-preset-btn{padding:9px 0;border:1.5px solid #e5e7eb;border-radius:8px;background:#f9fafb;color:#374151;font-size:13px;font-weight:500;cursor:pointer;transition:all .15s;font-family:inherit;touch-action:manipulation;}
            .bk-preset-btn.bk-active{background:#009bd8;border-color:#009bd8;color:#fff;}

            /* ══ SLIP UPLOAD ══ */
            .bk-slip-label{display:block;font-size:13px;color:#374151;font-weight:600;margin:10px 0 8px;}
            .bk-slip-zone{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;border:2px dashed #d1d5db;border-radius:12px;padding:18px 12px;cursor:pointer;background:#fafafa;transition:border-color .2s;}
            .bk-slip-zone:hover{border-color:#009bd8;background:#f0faff;}
            .bk-slip-icon{font-size:28px;line-height:1;}
            .bk-slip-text{font-size:13px;color:#6b7280;text-align:center;margin:0;}
            .bk-slip-hint{font-size:11px;color:#9ca3af;margin:0;}
            .bk-slip-preview{position:relative;margin-top:4px;}
            .bk-slip-preview img{width:100%;max-height:200px;object-fit:contain;border-radius:10px;border:1px solid #e5e7eb;display:block;}
            .bk-slip-remove{position:absolute;top:-8px;right:-8px;background:#ef4444;color:#fff;border:none;border-radius:50%;width:24px;height:24px;font-size:14px;cursor:pointer;display:flex;align-items:center;justify-content:center;line-height:1;}

            /* ══ SLIP UPLOAD TAB ══ */
            .bk-slip-tab-card{padding:16px;}
            .bk-slip-tab-header{display:flex;align-items:center;gap:12px;padding-bottom:14px;border-bottom:1px solid #f3f4f6;margin-bottom:14px;}
            .bk-slip-tab-icon{width:44px;height:44px;border-radius:12px;background:#fff7e6;display:flex;align-items:center;justify-content:center;font-size:22px;flex-shrink:0;}
            .bk-slip-tab-title{font-size:15px;font-weight:700;color:#1a1a1a;}
            .bk-slip-tab-sub{font-size:11px;color:#9ca3af;margin-top:2px;}
            .bk-slip-tab-zone{padding:30px 20px;gap:12px;border-radius:14px;}
            .bk-slip-tab-preview{display:flex;flex-direction:column;gap:12px;}
            .bk-slip-tab-img{width:100%;max-height:280px;object-fit:contain;border-radius:12px;border:1px solid #e5e7eb;display:block;}
            .bk-slip-tab-actions{display:flex;flex-direction:column;gap:8px;}
            .bk-slip-clear-btn{width:100%;padding:12px 0;background:#f3f4f6;color:#374151;border:none;border-radius:12px;font-size:14px;font-weight:600;cursor:pointer;font-family:inherit;touch-action:manipulation;}
            .bk-slip-success{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:28px 16px;gap:8px;text-align:center;}
            .bk-slip-success-icon{font-size:44px;line-height:1;}
            .bk-slip-success-text{font-size:16px;font-weight:700;color:#16a34a;margin-top:4px;}
            .bk-slip-success-sub{font-size:12px;color:#6b7280;}
            .bk-slip-spinner{display:inline-flex;align-items:center;gap:6px;}

            /* ══ SUBMIT BUTTON ══ */
            .bk-submit-btn{width:100%;padding:14px 0;background:linear-gradient(135deg,#ff8a00,#ff5500);color:#fff;border:none;border-radius:12px;font-size:16px;font-weight:700;cursor:pointer;font-family:inherit;margin-top:4px;touch-action:manipulation;}
            .bk-submit-btn:disabled{background:#ccc;cursor:not-allowed;}

            /* ══ RECENT TRANSACTIONS ══ */
            .bk-recent{margin:12px 20px 10px;background:#fff;border-radius:12px;box-shadow:0 1px 6px rgba(0,0,0,.07);overflow:hidden;}
            .bk-recent-title{padding:12px 14px;font-size:13px;font-weight:700;color:#1a1a1a;border-bottom:1px solid #f3f4f6;}
            .bk-recent-table{width:100%;border-collapse:collapse;font-size:11px;}
            .bk-recent-table th{padding:8px;text-align:left;color:#9ca3af;font-weight:500;border-bottom:1px solid #f3f4f6;background:#fafafa;}
            .bk-recent-table td{padding:9px 8px;border-bottom:1px solid #f9fafb;color:#374151;}
            .bk-recent-table tr:last-child td{border-bottom:none;}
            .bk-status-ok{color:#16a34a;font-weight:600;}
            .bk-status-pending{color:#f59e0b;font-weight:600;}
            .bk-status-fail{color:#ef4444;font-weight:600;}
            .bk-recent-empty{padding:20px;text-align:center;color:#9ca3af;font-size:12px;}

         

            /* ══ MENU CATEGORIES CONTAINER ══ */
            .menu-categories-container{position:fixed;top:0;left:0;right:0;bottom:0;z-index:500;display:flex;justify-content:flex-end;}
            .menu-overlay{position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.45);}
            .menu-account-container{position:relative;width:82vw;max-width:320px;height:100%;background:#fff;overflow-y:auto;box-shadow:-4px 0 20px rgba(0,0,0,0.18);display:flex;flex-direction:column;padding:16px 0 40px;box-sizing:border-box;}
            .menu-account-header{border-bottom:1px solid #f0f2f5;}
            .menu-account-header-title{display:flex;align-items:center;gap:12px;padding:14px 18px;cursor:pointer;user-select:none;}
            .mc-menu-svg{width:32px;height:32px;display:flex;align-items:center;justify-content:center;flex-shrink:0;}
            .menu-account-name{flex:1;font-size:14px;font-weight:600;color:#1a1a1a;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            .dropdown-arrow{display:flex;align-items:center;transition:transform .2s;}
            .mc-arrow-open{transform:rotate(180deg);}
            .submenu-account{background:#f8fafc;border-top:1px solid #f0f2f5;}
            .submenu-account-header{padding:12px 18px 12px 62px;font-size:13px;color:#374151;cursor:pointer;font-family:'Prompt','Noto Sans Thai',sans-serif;border-bottom:1px solid #f3f4f6;}
            .submenu-account-header:last-child{border-bottom:none;}
            .mc-sub-active{color:#009bd8;font-weight:600;}
            .mc-badge{font-size:12px;color:#ef4444;font-weight:700;margin-left:4px;}

            /* ══ CHAT BUTTON ══ */
            .bk-chat-btn{position:fixed;bottom:76px;right:16px;z-index:300;width:48px;height:48px;border-radius:50%;background:linear-gradient(135deg,#ff8a00,#ff5500);display:flex;align-items:center;justify-content:center;box-shadow:0 4px 14px rgba(255,138,0,.45);cursor:pointer;border:none;}

            /* ══ ANIMATIONS ══ */
            @keyframes bk-spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
            .bk-spinning{animation:bk-spin 1s linear infinite;}
            .bk-deposit-header{z-index:150!important;}

            /* ══ SWEETALERT2 COMPACT ══ */
            .swal2-popup{width:300px !important;padding:1.2em 1.4em !important;font-family:'Prompt','Noto Sans Thai',sans-serif !important;}
            .swal2-title{font-size:1.1em !important;padding:0.4em 0 0 !important;}
            .swal2-html-container{font-size:0.85em !important;margin:0.4em 0 0 !important;}
            .swal2-icon{width:56px !important;height:56px !important;margin:0.6em auto 0.4em !important;}
            .swal2-icon .swal2-icon-content{font-size:2em !important;}
            .swal2-actions{margin:0.8em 0 0 !important;gap:8px !important;}
            .swal2-confirm,.swal2-cancel{font-size:0.9em !important;padding:0.55em 1.6em !important;border-radius:8px !important;}

            /* ══ WALLET SECTION (override to match BK8) ══ */
            .wallet-info{padding:14px 20px 12px;}
            .top-content{display:flex;align-items:stretch;justify-content:space-between;background:#ffffff;}
            .member-wallet{flex:1;min-width:0;background:#ffffff;display:flex;flex-direction:column;justify-content:space-between;}
            .header{display:flex;align-items:center;justify-content:space-between;}
            .header-left{display:flex;align-items:center;gap:6px;}
            .title{margin:0;font-size:14px;color:#374151;font-weight:500;}
            .eye-icon{width:18px;height:18px;display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;overflow:hidden;}
            .eye-icon svg{width:18px!important;height:18px!important;display:block!important;max-width:18px!important;max-height:18px!important;}
            .bottom{display:flex;align-items:center;gap:8px;padding-top:10px;}
            /* ── top action-box: label aligned top with header, icon aligned bottom with balance ── */
            .member-action:not(.bottom-content){display:flex;gap:4px;padding:0;flex-wrap:nowrap;align-items:stretch;margin-left:8px;}
            .member-action:not(.bottom-content) .action-box{display:flex;flex-direction:column;align-items:center;justify-content:space-between;cursor:pointer;width:56px;max-width:56px;overflow:hidden;padding:2px 0;}
            .member-action:not(.bottom-content) .action-label{margin:0;font-size:11px;color:#374151;font-weight:500;text-align:center;white-space:nowrap;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            .currency-label{color:#8b98a5;font-size:13px;margin:0 4px 0 0;font-weight:500;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            .member-balance{color:#006bd6;font-size:22px;font-weight:700;margin:0;letter-spacing:-0.3px;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            ._drawerTrigger_19rt2_432{background:none;border:none;cursor:pointer;padding:0;display:flex;align-items:center;}
            ._mainWalletDetails_19rt2_186{margin:0;font-size:12px;color:#009bd8;font-weight:500;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            .title{margin:0;font-size:14px;color:#374151;font-weight:500;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            .mobile-beta-refresh{cursor:pointer;display:block;width:20px;height:20px;flex-shrink:0;}
            @keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
        `;

        /* ─────── QR Result Screen ─────── */
        if (tabselectsec === 1) {
            return (
                <>
                    <style dangerouslySetInnerHTML={{ __html: bkCss }} />
                    <div className="bk-deposit-page">
                        <div className="bk-deposit-header">
                            <button className="bk-header-back" onClick={() => this.setState({ tabselectsec: 0, tabselect: 1 })}>
                                <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} fill="currentColor" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
                                </svg>
                            </button>
                            <span className="bk-header-title">สแกน QR ชำระเงิน</span>
                            <div style={{ width: 40 }} />
                        </div>
                        <div style={{ margin: 16 }}>
                            <div style={{ background: '#fff', borderRadius: 16, padding: 24, textAlign: 'center', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
                                <div style={{ padding: '10px 14px', background: '#f0fdf4', borderRadius: 10, fontSize: 13, color: '#16a34a', border: '1px solid #bbf7d0', marginBottom: 16 }}>
                                    ✓ QR Code สแกนได้เพียงครั้งเดียวเท่านั้น
                                </div>
                                {qrcode && (
                                    <div style={{ display: 'inline-block', padding: 8, border: '2px solid #e5e7eb', borderRadius: 12, marginBottom: 16 }}>
                                        <img src={qrcode} alt="QR" style={{ width: 200, height: 200, display: 'block' }} />
                                    </div>
                                )}
                                <div style={{ fontSize: 26, fontWeight: 700, color: '#1a1a1a', marginBottom: 4 }}>
                                    ฿ {Number(depositamount || 0).toLocaleString()}
                                </div>
                                <div style={{ fontSize: 15, fontWeight: 600, color: counter > 0 ? '#f59e0b' : '#ef4444', marginBottom: 6 }}>
                                    ⏱ {counter > 0 ? `${Math.floor(counter / 60)}:${String(counter % 60).padStart(2, '0')}` : 'หมดเวลา'}
                                </div>
                                <div style={{ fontSize: 12, color: '#ef4444', marginBottom: 16 }}>โปรดชำระเงินภายในเวลาที่กำหนด</div>
                                {linelink && (
                                    <div style={{ padding: '10px 14px', background: '#f0fdf4', borderRadius: 10, fontSize: 12, color: '#15803d', marginBottom: 16 }}>
                                        หากเกิดปัญหา ติดต่อ Line: <b>{linelink}</b>
                                    </div>
                                )}
                                <button
                                    className="bk-submit-btn"
                                    onClick={() => this.setState({ tabselectsec: 0, tabselect: 1 })}
                                    style={{ background: counter > 0 ? '#ef4444' : 'linear-gradient(135deg,#ff8a00,#ff5500)' }}
                                >
                                    {counter > 0 ? 'ยกเลิกรายการ' : 'ทำรายการใหม่'}
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            );
        }

        /* ─────── Main Deposit Screen ─────── */
        return (
            <>
                <style dangerouslySetInnerHTML={{ __html: bkCss }} />
                <div className="bk-deposit-page">

                    {/* ══ Mobile Navbar Header (ported from main.js) ══ */}
                    <header id="mobile-navbar-header" className="mobile-navbar-header">
                        <nav className="mobile-nav header-grey">
                            <div className="col-left">
                                {/* beta-back arrow — go back */}
                                <button
                                    type="button"
                                    onClick={() => window.location.href = '/'}
                                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center' }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        viewBox="0 0 22.67717 22.67717"
                                        className="menu-icon beta-back"
                                        width="22" height="22"
                                    >
                                        <style dangerouslySetInnerHTML={{ __html: ".beta-back .st0{fill:url(#beta-back-SVGID_1_);}" }} />
                                        <g className="beta-back">
                                            <linearGradient id="beta-back-SVGID_1_" gradientUnits="userSpaceOnUse" x1="9.094947e-13" y1="11.33858" x2="22.67717" y2="11.33858">
                                                <stop offset="0" style={{ stopColor: "rgb(9,94,189)" }} />
                                                <stop offset="1" style={{ stopColor: "rgb(4,169,194)" }} />
                                            </linearGradient>
                                            <path className="st0" d="M0.3228,12.12548l5.56403,5.54451c0.4294,0.4299,1.12705,0.4299,1.55644,0
                                                c0.4304-0.4299,0.4304-1.12705,0-1.55694l-3.68425-3.66523h17.81665c0.60825,0,1.10149-0.49279,1.10149-1.10104
                                                c0-0.60825-0.49324-1.10103-1.10149-1.10103H3.75903l3.70018-3.68171c0.4304-0.4299,0.4304-1.12659,0-1.55694
                                                C7.24404,4.79186,6.963,4.68475,6.68096,4.68475c-0.28199,0-0.56403,0.10711-0.7782,0.32234L0.3228,10.56803
                                                C-0.1076,10.99843-0.1076,11.69513,0.3228,12.12548z" />
                                        </g>
                                    </svg>
                                </button>

                                <p className="page-title">ฝาก</p>

                                {/* Sidebar content — toggled via hamburger */}
                                <div className={`sb-content ${isGuideOpen ? "isOpen" : ""}`}>
                                    <button
                                        type="button"
                                        className="sb-close-btn"
                                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ isGuideOpen: false }); }}
                                    >×</button>

                                    <div className="content-container content-1">
                                        <div className="sb-acc-info">
                                            <div className="acc-info">
                                                {/* bitcoin icon placeholder */}
                                                <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#f7931a', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 32 32" fill="white">
                                                        <path d="M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm3.7 14.2c.3-2-1.2-3.1-3.3-3.8l.7-2.7-1.7-.4-.7 2.6-1.3-.3.7-2.6-1.7-.4-.7 2.7-1.1-.3-2.3-.6-.4 1.8s1.2.3 1.2.3c.7.2.8.7.8 1l-.8 3.3c.1 0 .1 0 .2.1l-.2-.1-1.2 4.7c-.1.2-.3.5-.8.4 0 0-1.2-.3-1.2-.3l-.8 2 2.2.5 1.2.3-.7 2.7 1.7.4.7-2.7 1.3.3-.7 2.7 1.7.4.7-2.7c2.8.5 4.9.3 5.8-2.2.7-2-.1-3.1-1.5-3.9 1.1-.3 1.9-1 2.1-2.5zm-3.7 5.2c-.5 2-3.9 1-5 .7l.9-3.5c1.1.3 4.6.9 4.1 2.8zm.5-5.3c-.5 1.8-3.3 1-4.2.7l.8-3.2c.9.2 3.9.7 3.4 2.5z" />
                                                    </svg>
                                                </div>
                                                <div className="info-content" style={{ marginLeft: 10 }}>
                                                    <p className="welcome-title" style={{ margin: 0, fontSize: 11, color: '#9ca3af' }}>ยินดีต้อนรับ</p>
                                                    <p className="acc-name" style={{ margin: 0, fontSize: 14, fontWeight: 700, color: '#1a1a1a' }}>{username || '-'}</p>
                                                </div>
                                            </div>
                                            <div className="sb-leaderboard" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                <span style={{ fontSize: 11, background: '#e8f0fe', color: '#1a73e8', borderRadius: 20, padding: '2px 10px', fontWeight: 600 }}>{rankname || 'Normal'}</span>
                                                <span style={{ fontSize: 11, color: '#f59e0b', fontWeight: 600 }}>👑 {rankpoint || 0}</span>
                                            </div>
                                        </div>

                                        <div className="sb-menu margin-top">
                                            {[
                                                { label: 'สปอนเซอร์', href: '/' },
                                                { label: 'VIP', href: '/' },
                                                { label: 'ลีดเดอร์บอร์ด', href: '/' },
                                                { label: 'ดาวน์โหลด', href: '/' },
                                            ].map(item => (
                                                <div key={item.label} className="menu" style={{ display: 'flex', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f3f4f6', cursor: 'pointer', color: '#374151', fontSize: 14 }} onClick={() => this.checkurl(null, item.href)}>
                                                    <span>{item.label}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="common-menu">
                                        {[
                                            { label: 'หน้าแรก', href: '/' },
                                            { label: 'ฝากเงิน', href: '/deposit' },
                                            { label: 'ถอนเงิน', href: '/withdraw' },
                                            { label: 'โปรโมชั่น', href: '/' },
                                            { label: 'กีฬา', href: '/' },
                                            { label: 'อีสปอร์ต', href: '/' },
                                            { label: 'คาสิโนสด', href: '/' },
                                            { label: 'สล็อต', href: '/' },
                                            { label: 'ยิงปลา', href: '/' },
                                            { label: 'ล็อตเตอรี่', href: '/' },
                                            { label: 'เกมด่วน', href: '/' },
                                            { label: 'วงล้อนำโชค', href: '/' },
                                        ].map(item => (
                                            <div key={item.label} className="common-menu-item" style={{ display: 'block', padding: '10px 0', borderBottom: '1px solid #f3f4f6', cursor: 'pointer', color: item.href === '/deposit' || item.href === '/withdraw' ? '#1a73e8' : '#374151', fontSize: 14, fontWeight: item.href === '/deposit' ? 700 : 400 }} onClick={() => this.checkurl(null, item.href)}>
                                                {item.label}
                                            </div>
                                        ))}
                                    </div>

                                    <button
                                        type="button"
                                        style={{ width: '100%', marginTop: 16, padding: '10px 0', background: 'none', border: '1px solid #e5e7eb', borderRadius: 8, color: '#ef4444', fontWeight: 600, cursor: 'pointer', fontSize: 14, fontFamily: 'inherit' }}
                                        onClick={() => { localStorage.clear(); window.location.href = '/'; }}
                                    >ออกจากระบบ</button>
                                </div>
                            </div>

                            <div className="col-right">
                                {/* 3-dots → open menu-categories-container */}
                                <button
                                    type="button"
                                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px 4px', display: 'flex', alignItems: 'center' }}
                                    onClick={() => this.setState({ isMenuOpen: true, menuOpenIndex: 0 })}
                                >
                                    <svg className="he2B3fr5m1nuf12b56a4" width={27} height={5} viewBox="0 0 27 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g id="he2B3fr5m1nuf12b56a4_Layer_1" clipPath="url(#he2B3fr5m1nuf12b56a4_clip0_2835_15573)">
                                            <path d="M2.09305 4.66102C3.24901 4.66102 4.1861 3.72393 4.1861 2.56797C4.1861 1.41201 3.24901 0.474915 2.09305 0.474915C0.937091 0.474915 0 1.41201 0 2.56797C0 3.72393 0.937091 4.66102 2.09305 4.66102Z" fill="#8697A2" />
                                            <path d="M13.25 4.66102C14.406 4.66102 15.3431 3.72393 15.3431 2.56797C15.3431 1.41201 14.406 0.474915 13.25 0.474915C12.094 0.474915 11.157 1.41201 11.157 2.56797C11.157 3.72393 12.094 4.66102 13.25 4.66102Z" fill="#8697A2" />
                                            <path d="M24.407 4.66102C25.5629 4.66102 26.5 3.72393 26.5 2.56797C26.5 1.41201 25.5629 0.474915 24.407 0.474915C23.251 0.474915 22.3139 1.41201 22.3139 2.56797C22.3139 3.72393 23.251 4.66102 24.407 4.66102Z" fill="#8697A2" />
                                        </g>
                                        <defs>
                                            <clipPath id="he2B3fr5m1nuf12b56a4_clip0_2835_15573">
                                                <rect width="26.5" height="4.19509" fill="white" transform="translate(0 0.474915)" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </button>
                            </div>
                        </nav>
                    </header>

                    {/* ══ Menu Categories Container (3-dots popup) ══ */}
                    {isMenuOpen && (
                        <div className="menu-categories-container">
                            {/* Overlay backdrop */}
                            <div
                                className="menu-overlay"
                                onClick={() => this.setState({ isMenuOpen: false })}
                            />
                            <section className="menu-account-container">
                                {[
                                    {
                                        icon: (
                                            <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M13.125 11.3095C13.125 13.5543 14.8916 15.381 17.0625 15.381H19.25V17.1905C19.25 18.1884 18.4651 19 17.5 19H2.625C1.17775 19 0 17.7822 0 16.2857V2.4881C0 2.42314 0.0165078 2.3635 0.0329949 2.30392C0.0369488 2.28964 0.0409015 2.27535 0.044625 2.261C0.254625 0.980759 1.32738 0 2.625 0H14.875C15.8401 0 16.625 0.811571 16.625 1.80953V3.61905H17.5C18.4651 3.61905 19.25 4.43062 19.25 5.42857V7.23812H17.0625C14.8916 7.23812 13.125 9.06483 13.125 11.3095ZM2.625 1.80953C2.142 1.80953 1.75 2.21576 1.75 2.71429C1.75 3.21281 2.142 3.61905 2.625 3.61905H14.875V1.80953H2.625ZM17.0625 8.59533H20.3438C20.706 8.59533 21 8.89933 21 9.2739V13.3453C21 13.7199 20.706 14.0239 20.3438 14.0239H17.0625C15.6153 14.0239 14.4375 12.8061 14.4375 11.3096C14.4375 9.81309 15.6153 8.59533 17.0625 8.59533ZM16.1875 11.3096C16.1875 11.809 16.5795 12.2144 17.0625 12.2144C17.5455 12.2144 17.9375 11.809 17.9375 11.3096C17.9375 10.8102 17.5455 10.4048 17.0625 10.4048C16.5795 10.4048 16.1875 10.8102 16.1875 11.3096Z" fill="url(#mcMenuGrad1)" />
                                                <defs><linearGradient id="mcMenuGrad1" x1="0.4375" y1="19" x2="21" y2="19" gradientUnits="userSpaceOnUse"><stop offset="0.0434783" stopColor="#095EBD" /><stop offset="1" stopColor="#04A9C2" /></linearGradient></defs>
                                            </svg>
                                        ),
                                        label: 'แคชเชียร์',
                                        items: [
                                            { label: 'ฝากเงิน', href: '/deposit', active: true },
                                            { label: 'ถอน', href: '/withdraw' },
                                            { label: 'โอนเงิน', href: '/transfer' },
                                            { label: 'รายละเอียดการถอนเงิน', href: '/withdraw' },
                                        ],
                                    },
                                    {
                                        icon: (
                                            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M8.6543 3.07188C8.6543 1.40715 10.8861 0.489777 12.5425 0.204158C16.3335 -0.5087 21 0.692363 21 3.07188V17.9231C21 20.0568 17.3932 21 14.8066 21C13.487 21 12.6152 20.8433 11.6567 20.5815C11.6538 20.5807 11.6509 20.5798 11.6482 20.5789C11.6419 20.5768 11.636 20.5746 11.6291 20.5727C12.4064 19.9799 12.4946 19.8616 12.5995 19.7208C12.632 19.6773 12.666 19.6316 12.7225 19.5691C12.7253 19.5694 12.728 19.57 12.7307 19.5707C12.7335 19.5713 12.7364 19.572 12.7395 19.5723C12.8147 19.4925 12.8784 19.4049 12.942 19.3174C12.9821 19.2623 13.0222 19.2071 13.0652 19.1538C13.0772 19.1387 13.094 19.1185 13.1152 19.0931C13.2889 18.8854 13.7523 18.3311 14.1791 17.3446C14.1791 17.3342 14.1898 17.3049 14.1937 17.2955C16.5848 17.4343 18.8741 16.7608 19.7695 16.1138V14.2308C19.7695 14.7547 18.9497 15.1945 18.4733 15.4124C17.326 15.9259 15.8592 16.0849 14.5861 16.0647C14.8001 15.1569 14.8325 14.4328 14.782 13.5745C17.2253 13.5745 19.0558 12.8961 19.7695 12.3806V10.8791C19.671 10.8914 19.5727 10.9529 19.4988 11.0268C19.2773 11.2606 18.9041 11.4821 18.4734 11.679C17.3242 12.1934 15.8543 12.3519 14.5852 12.3314C14.3418 11.3846 14.1074 10.7784 13.49 9.80831C16.1995 10.1179 18.7802 9.40295 19.7695 8.68829V7.18679C19.6711 7.19906 19.5727 7.26062 19.4988 7.33445C18.4853 8.40433 15.3828 8.96569 12.7641 8.46674C12.6722 8.44837 12.5833 8.42691 12.4943 8.40551C12.4078 8.38464 12.3214 8.36384 12.2321 8.34579C11.4835 7.6501 10.7067 7.15404 9.92171 6.81752C9.91554 6.81752 9.90938 6.8145 9.90327 6.81142C9.8971 6.80833 9.89093 6.80525 9.88477 6.80525V6.80682C9.48485 6.63954 9.07305 6.51305 8.6543 6.41414V3.07188ZM16.8482 4.7353C17.6936 4.57612 18.9535 4.18207 19.5045 3.6055C19.68 3.42043 19.7695 3.24074 19.7695 3.07188C19.7695 2.53641 18.9629 2.11147 18.4728 1.894C17.3871 1.41055 16.0028 1.22573 14.8066 1.22573C13.6052 1.22573 12.2219 1.41211 11.1411 1.894C10.6711 2.10228 9.88477 2.55811 9.88477 3.07188C9.88477 3.24074 9.97428 3.42043 10.1503 3.6055C10.7393 4.22342 11.9268 4.57747 12.765 4.7353C14.0568 4.97808 15.5564 4.97808 16.8482 4.7353ZM4.13539 7.95349C5.80448 7.24559 7.77171 7.24559 9.44075 7.95349C11.8701 8.98347 13.5762 11.3773 13.5762 14.2306C13.5762 17.9737 10.5326 20.9999 6.80859 20.9999C2.96424 20.9999 0 17.9108 0 14.2306C0 11.3857 1.69804 8.98688 4.13539 7.95349ZM6.90736 13.5802C6.70543 13.5675 6.53647 13.5569 6.37361 13.394C5.79274 12.813 6.69126 11.7186 7.60705 12.8086C7.8246 13.0695 8.21271 13.1043 8.47343 12.8844C8.73357 12.6662 8.76783 12.278 8.54917 12.0178C8.21907 11.6242 7.84042 11.3541 7.42383 11.215V10.4974C7.42383 10.1572 7.14866 9.88201 6.80859 9.88201C6.46852 9.88201 6.19335 10.1572 6.19335 10.4974V11.2238C5.41249 11.5006 4.96288 12.2136 4.96288 12.9589C4.96288 13.5398 5.26664 14.0682 5.50367 14.3051C5.93005 14.7316 6.30681 14.7719 6.62727 14.806C6.86444 14.8314 7.07083 14.8534 7.24362 15.0263C7.78929 15.5721 7.02023 16.6023 6.14232 15.7552C5.8996 15.5191 5.50847 15.5263 5.27296 15.7703C5.03683 16.0143 5.04343 16.4043 5.28797 16.6399C5.56396 16.907 5.87105 17.0763 6.19339 17.1847V17.9229C6.19339 18.263 6.46856 18.5383 6.80859 18.5383C7.14866 18.5383 7.42383 18.263 7.42383 17.9229V17.1866C7.43689 17.1819 7.45067 17.1804 7.46445 17.179C7.47948 17.1773 7.49451 17.1757 7.50855 17.1699C8.72077 16.6736 9.04962 15.0924 8.11355 14.1562C7.58002 13.6224 7.20733 13.599 6.90736 13.5802Z" fill="url(#mcMenuGrad2)" />
                                                <defs><linearGradient id="mcMenuGrad2" x1="0.4375" y1="21" x2="21" y2="21" gradientUnits="userSpaceOnUse"><stop offset="0.0434783" stopColor="#095EBD" /><stop offset="1" stopColor="#04A9C2" /></linearGradient></defs>
                                            </svg>
                                        ),
                                        label: 'รางวัล',
                                        items: [
                                            { label: 'เงินคืนทันที', href: '/' },
                                            { label: 'งานประจำวัน', href: '/', badge: '1' },
                                            { label: 'แนะนำเพื่อน', href: '/' },
                                        ],
                                    },
                                    {
                                        icon: (
                                            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15.6299 14.2856L12.597 13.5272L12.3389 12.4949C13.1504 11.6914 13.7061 10.5877 13.8708 9.45565C14.3204 9.329 14.6688 8.94342 14.7289 8.45975L14.9268 6.8764C14.9688 6.54229 14.8658 6.20427 14.6442 5.95092C14.5143 5.80209 14.3505 5.68969 14.1692 5.62081L14.242 4.13009L14.5381 3.83321C14.9839 3.35899 15.3535 2.54596 14.5809 1.36637C13.9871 0.459971 12.9786 0 11.5821 0C11.0311 0 9.76285 0 8.58171 0.79325C5.20915 0.863722 4.75 2.4304 4.75 3.95835C4.75 4.31382 4.83628 5.11419 4.89328 5.5971C4.68981 5.66122 4.50537 5.77997 4.36128 5.94385C4.13565 6.19958 4.03115 6.53921 4.07312 6.87723L4.27103 8.46058C4.33594 8.97673 4.72781 9.38285 5.2234 9.47946C5.38728 10.568 5.91453 11.636 6.67927 12.4261L6.40377 13.5288L3.3709 14.2872C1.3854 14.782 0 16.5569 0 18.6041C0 18.8226 0.177345 19 0.395845 19H18.6042C18.8227 19 19.0001 18.8211 19.0001 18.6026C19 16.5569 17.6146 14.782 15.6299 14.2856Z" fill="url(#mcMenuGrad3)" />
                                                <defs><linearGradient id="mcMenuGrad3" x1="0.395835" y1="19" x2="19.0001" y2="19" gradientUnits="userSpaceOnUse"><stop offset="0.0434783" stopColor="#095EBD" /><stop offset="1" stopColor="#04A9C2" /></linearGradient></defs>
                                            </svg>
                                        ),
                                        label: 'โปรไฟล์ของฉัน',
                                        items: [
                                            { label: 'บัญชีของฉัน', href: '/profile' },
                                            { label: 'ข้อความ', href: '/profile' },
                                            { label: 'เปลี่ยนรหัสผ่าน', href: '/profile' },
                                        ],
                                    },
                                    {
                                        icon: (
                                            <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M9.6 4.49219C9.6 5.24606 10.2441 5.85938 11.0359 5.85938H16V17.8516C16 19.0362 14.9878 20 13.7436 20H2.25641C1.01223 20 0 19.0362 0 17.8516V2.14844C0 0.963787 1.01223 0 2.25641 0H9.6V4.49219ZM6.34751 14.0625H3.3641C3.02425 14.0625 2.74872 14.3249 2.74872 14.6484C2.74872 14.972 3.02425 15.2344 3.3641 15.2344H6.34751C6.68732 15.2344 6.96289 14.972 6.96289 14.6484C6.96289 14.3249 6.68732 14.0625 6.34751 14.0625ZM3.3641 10.9375C3.02425 10.9375 2.74872 11.1999 2.74872 11.5234C2.74872 11.847 3.02425 12.1094 3.3641 12.1094H12.3897C12.7296 12.1094 13.0051 11.847 13.0051 11.5234C13.0051 11.1999 12.7296 10.9375 12.3897 10.9375H3.3641ZM13.0051 8.39844C13.0051 8.07487 12.7296 7.8125 12.3897 7.8125H3.3641C3.02425 7.8125 2.74872 8.07487 2.74872 8.39844C2.74872 8.722 3.02425 8.98438 3.3641 8.98438H12.3897C12.7296 8.98438 13.0051 8.722 13.0051 8.39844ZM11.0359 4.68741C10.9228 4.68741 10.8308 4.59979 10.8308 4.4921L10.8308 0.24292C11.014 0.334014 11.185 0.449365 11.3385 0.587646L15.2943 4.15101C15.4683 4.30776 15.6131 4.48952 15.7257 4.68741H11.0359Z" fill="url(#mcMenuGrad4)" />
                                                <defs><linearGradient id="mcMenuGrad4" x1="0.333333" y1="20" x2="16" y2="20" gradientUnits="userSpaceOnUse"><stop offset="0.0434783" stopColor="#095EBD" /><stop offset="1" stopColor="#04A9C2" /></linearGradient></defs>
                                            </svg>
                                        ),
                                        label: 'ประวัติ',
                                        items: [
                                            { label: 'ประวัติการโอนเงิน', href: '/statement' },
                                        ],
                                    },
                                ].map((menu, idx) => (
                                    <div className="menu-account-header" key={idx}>
                                        <div
                                            className="menu-account-header-title"
                                            onClick={() => this.setState({ menuOpenIndex: menuOpenIndex === idx ? -1 : idx })}
                                        >
                                            <div className="mc-menu-svg">
                                                {menu.icon}
                                            </div>
                                            <span className="menu-account-name">{menu.label}</span>
                                            <div className={`dropdown-arrow${menuOpenIndex === idx ? ' mc-arrow-open' : ''}`}>
                                                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14.5444 7.10467C14.5444 7.38307 14.4409 7.66252 14.235 7.87536L9.56017 12.7069C9.30038 12.9766 8.95498 13.1228 8.5885 13.1228C8.22093 13.1228 7.87662 12.9744 7.6178 12.7058L2.94304 7.87536C2.53005 7.44963 2.53005 6.75865 2.94304 6.33181C3.35604 5.90502 4.02568 5.90502 4.43759 6.33181L8.5885 10.6219L12.7394 6.33181C13.1523 5.90502 13.821 5.90502 14.235 6.33181C14.4409 6.5447 14.5444 6.82415 14.5444 7.10467Z" fill="#61757E" />
                                                </svg>
                                            </div>
                                        </div>
                                        {menuOpenIndex === idx && (
                                            <div className="submenu-account">
                                                {menu.items.map((item, iIdx) => (
                                                    <div
                                                        key={iIdx}
                                                        className={`submenu-account-header${item.active ? ' mc-sub-active' : ''}`}
                                                        onClick={() => this.checkurl(null, item.href)}
                                                    >
                                                        <span>
                                                            {item.label}
                                                            {item.badge && <span className="mc-badge">({item.badge})</span>}
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </section>
                        </div>
                    )}

                    {/* ══ User Top Bar ══ */}
                    <MobileUserBar loginstate={loginstate} username={username} rankname={rankname} rankpoint={rankpoint} />

                    <MobileWalletSection
                        loginstate={loginstate}
                        balance={balance}
                        checkcredit={this.state.checkcredit}
                        showMemberAction={this.state.showMemberAction}
                        onRefresh={(e) => this.recheccredit(e)}
                        onToggleMemberAction={() => this.setState({ showMemberAction: !this.state.showMemberAction })}
                        onDeposit={() => this.props.navigate('/deposit')}
                        onWithdraw={() => this.props.navigate('/withdraw')}
                        onStatement={() => this.props.navigate('/statement')}
                        onMessage={() => window.location.href = '/manager/message'}
                    />

                    {/* ══ Banner ══ */}
                    <div className="bk-banner">
                        <img
                            src="https://s3.newworld.center/image/f11e9374-90db-45b4-a971-2b6d474fe100.webp"
                            alt="banner"
                            onError={e => { e.target.style.display = 'none'; }}
                        />
                    </div>

                    {/* ══ ฝาก 1 นาที Label ══ */}
                    <div style={{ margin: '10px 20px 0', display: 'flex', alignItems: 'center', gap: 8 }}>
                        <div style={{ background: 'linear-gradient(135deg,#009bd8,#0072a3)', borderRadius: 8, padding: '7px 14px', display: 'flex', alignItems: 'center', gap: 6, boxShadow: '0 2px 8px rgba(0,155,216,.3)' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width={13} height={13} fill="#fff" viewBox="0 0 16 16">
                                <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
                            </svg>
                            <span style={{ color: '#fff', fontWeight: 700, fontSize: 13 }}>ฝาก 1 นาที</span>
                        </div>
                        <span style={{ fontSize: 11, color: '#9ca3af' }}>ต้องโอนจากบัญชีที่ลงทะเบียนเท่านั้น</span>
                    </div>

                    {/* ══ Deposit Tab Switcher ══ */}
                    <div className="bk-dep-tabs">
                        <button
                            type="button"
                            className={`bk-dep-tab${tabselect === 1 ? ' bk-dep-tab-active' : ''}`}
                            onClick={(e) => this.checktab(e, 1)}
                        >
                            ฝากปกติ
                            <span className="bk-dep-tab-subtitle">⏱ 1–5 นาที</span>
                        </button>
                        <button
                            type="button"
                            className={`bk-dep-tab${tabselect === 2 ? ' bk-dep-tab-active' : ''}`}
                            onClick={(e) => this.checktab(e, 2)}
                        >
                            สแกน QR
                            <span className="bk-dep-tab-subtitle">⚡ ภายใน 5 นาที</span>
                        </button>
                        <button
                            type="button"
                            className={`bk-dep-tab${tabselect === 4 ? ' bk-dep-tab-active' : ''}`}
                            onClick={() => this.setState({ tabselect: 4, tabselectsec: 0 })}
                        >
                            อัพโหลดสลิป
                            <span className="bk-dep-tab-subtitle">📎 แนบหลักฐาน</span>
                        </button>
                    </div>

                    {/* ══ TAB 1 : ฝากปกติ (bank transfer) ══ */}
                    {tabselect === 1 && (
                        <>
                            {/* บัญชีปลายทาง — ธนาคารปกติ */}
                            {mainacc != null && mainacc.bankid !== 6 && (
                                <>
                                    <div className="bk-section-bar">
                                        <div className="bk-section-title">บัญชีรับเงิน <span style={{ fontSize: 11, color: '#ef4444', fontWeight: 400 }}>*</span></div>
                                        <span className="bk-section-hint">โอนจากบัญชีที่ลงทะเบียนเท่านั้น</span>
                                    </div>
                                    <div className="bk-bank-card bk-selected">
                                        <div className="bk-bank-inner">
                                            <img
                                                className="bk-bank-img"
                                                src={mainacc.img_path || ''}
                                                alt={mainacc.fullname_th || 'ธนาคาร'}
                                                onError={e => { e.target.src = ''; e.target.style.background = '#ddd'; }}
                                            />
                                            <div className="bk-bank-text">
                                                <div className="bk-bank-name">{mainacc.fullname_th || '-'}</div>
                                                <div className="bk-bank-sub">{mainacc.first_name_en || ''} {mainacc.last_name_en || ''}</div>
                                            </div>
                                            <span className="bk-online-badge">ออนไลน์</span>
                                        </div>
                                        <div className="bk-accno-row">
                                            <span className="bk-accno-text">{formatAccNo(mainacc.accnumber)}</span>
                                            <button
                                                className="bk-copy-btn"
                                                onClick={() => this.copyText(mainacc.accnumber)}
                                            >
                                                คัดลอก
                                            </button>
                                        </div>
                                    </div>

                                    {/* บัญชีของคุณ */}
                                    {accnumberx && (
                                        <>
                                            <div className="bk-section-bar" style={{ marginTop: 0 }}>
                                                <div className="bk-section-title" style={{ fontSize: 13, color: '#666', fontWeight: 600 }}>บัญชีของคุณ</div>
                                            </div>
                                            <div className="bk-user-bank-card">
                                                <img
                                                    className="bk-bank-img"
                                                    src={accnumberx.img_path || ''}
                                                    alt={accnumberx.fullname_th || 'ธนาคาร'}
                                                    onError={e => { e.target.src = ''; e.target.style.background = '#ddd'; }}
                                                />
                                                <div className="bk-bank-text">
                                                    <div className="bk-bank-name">{accnumberx.fullname_th || '-'}</div>
                                                    <div className="bk-bank-sub">
                                                        {firstname || username || '-'} &nbsp;|&nbsp; {formatAccNo(accnumberx.accno)}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    {/* Form: จำนวนเงิน + ธนาคารผู้ส่ง + ส่ง */}
                                    <div className="bk-form-card">
                                        <label className="bk-form-label">จำนวนเงิน (บาท)</label>
                                        <input
                                            type="number"
                                            className="bk-amount-input"
                                            placeholder={`ขั้นต่ำ ${limit ? limit.min : 100} / สูงสุด ${limit ? limit.max : 500000}`}
                                            value={depositamount || ''}
                                            onChange={this.onChangexdep}
                                            name="depositamount"
                                        />
                                        <div className="bk-preset-grid">
                                            {amountPresets.map(amt => (
                                                <button
                                                    key={amt}
                                                    className={`bk-preset-btn${Number(depositamount) === amt ? ' bk-active' : ''}`}
                                                    onClick={(e) => this.handleClickdeposit(e, amt)}
                                                >
                                                    {amt.toLocaleString()}
                                                </button>
                                            ))}
                                        </div>
                                        <label className="bk-form-label" style={{ marginTop: 10 }}>ธนาคารผู้ส่ง</label>
                                        <select className="bk-select" name="senderbank" onChange={this.onChange}>
                                            <option value="">-- เลือกธนาคาร --</option>
                                            <option value="SCB">ไทยพาณิชย์ (SCB)</option>
                                            <option value="KBANK">กสิกรไทย (KBANK)</option>
                                            <option value="BBL">กรุงเทพ (BBL)</option>
                                            <option value="KTB">กรุงไทย (KTB)</option>
                                            <option value="BAY">กรุงศรีอยุธยา (BAY)</option>
                                            <option value="GSB">ออมสิน (GSB)</option>
                                            <option value="TTB">ทหารไทยธนชาต (TTB)</option>
                                            <option value="UOB">ยูโอบี (UOB)</option>
                                        </select>
                                        {/* ── Upload Slip (only if mainacc.autoslip == 1) ── */}
                                        {mainacc && mainacc.autoslip == 1 && (
                                            <>
                                                <label className="bk-slip-label">แนบสลิปโอนเงิน</label>
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    style={{ display: 'none' }}
                                                    ref={el => this._slipInput = el}
                                                    onChange={this.handleFileSelected}
                                                />
                                                {slipPreview ? (
                                                    <div className="bk-slip-preview">
                                                        <img src={slipPreview} alt="สลิป" />
                                                        <button
                                                            type="button"
                                                            className="bk-slip-remove"
                                                            onClick={this.removeSlip}
                                                        >✕</button>
                                                    </div>
                                                ) : (
                                                    <div
                                                        className="bk-slip-zone"
                                                        onClick={() => this._slipInput && this._slipInput.click()}
                                                    >
                                                        <span className="bk-slip-icon">🖼️</span>
                                                        <p className="bk-slip-text">แตะเพื่ออัพโหลดสลิป</p>
                                                        <p className="bk-slip-hint">JPG, PNG รองรับ</p>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                        <button
                                            className="bk-submit-btn"
                                            style={{ marginTop: 14 }}
                                            onClick={(e) => this.confirmdeposit(e, 1)}
                                        >
                                            แจ้งฝากเงิน
                                        </button>
                                    </div>

                                    <div className="bk-info-box">
                                        ℹ การโอนเงินระหว่างธนาคารและเครื่องฝากเงินสด ต้องใช้ใบเสร็จรับเงินเพื่ออนุมัติการฝากที่รวดเร็วยิ่งขึ้น
                                    </div>
                                </>
                            )}

                            {mainacc != null && mainacc.bankid === 6 && (
                                <div className="bk-warn-box" style={{ marginTop: 14 }}>
                                    📲 บัญชีนี้เป็น PromptPay — กรุณาใช้แท็บ <strong>สแกน QR</strong> เพื่อฝากเงิน
                                </div>
                            )}

                            {mainacc == null && (
                                <div className="bk-warn-box" style={{ marginTop: 14 }}>⚠ ยังไม่พบข้อมูลบัญชีปลายทาง กรุณาติดต่อ admin</div>
                            )}
                        </>
                    )}

                    {/* ══ TAB 2 : สแกน QR ══ */}
                    {tabselect === 2 && (
                        <>
                            {/* ── Option A: PromptPay (mainacc.bankid === 6) ── */}
                            {mainacc != null && mainacc.bankid === 6 && (
                                <div className="bk-form-card">
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '0 0 12px', borderBottom: '1px solid #f3f4f6', marginBottom: 14 }}>
                                        <div style={{ width: 42, height: 42, borderRadius: 10, background: '#fef9c3', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, flexShrink: 0 }}>
                                            📲
                                        </div>
                                        <div>
                                            <div style={{ fontSize: 14, fontWeight: 700, color: '#1a1a1a' }}>PromptPay</div>
                                            <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>โอนผ่าน QR พร้อมเพย์</div>
                                        </div>
                                        <div style={{ marginLeft: 'auto', fontSize: 10, background: '#fef9c3', color: '#b45309', padding: '3px 8px', borderRadius: 20, fontWeight: 600 }}>
                                            ⏱ 5 นาที
                                        </div>
                                    </div>
                                    <label className="bk-form-label">จำนวนเงิน (บาท)</label>
                                    <input
                                        type="number"
                                        className="bk-amount-input"
                                        placeholder={`ขั้นต่ำ ${limit ? limit.min : 100} / สูงสุด ${limit ? limit.max : 500000}`}
                                        value={depositamount || ''}
                                        onChange={this.onChangexdep}
                                        name="depositamount"
                                    />
                                    <div className="bk-preset-grid">
                                        {amountPresets.map(amt => (
                                            <button
                                                key={amt}
                                                className={`bk-preset-btn${Number(depositamount) === amt ? ' bk-active' : ''}`}
                                                onClick={(e) => this.handleClickdeposit(e, amt)}
                                            >
                                                {amt.toLocaleString()}
                                            </button>
                                        ))}
                                    </div>
                                    <button
                                        className="bk-submit-btn"
                                        style={{ marginTop: 4 }}
                                        onClick={(e) => this.confirmdeposit(e, 7)}
                                    >
                                        สร้าง QR PromptPay
                                    </button>
                                </div>
                            )}

                            {/* ── Option B: Payment Gateway QR ── */}
                            <div className="bk-form-card">
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '0 0 12px', borderBottom: '1px solid #f3f4f6', marginBottom: 14 }}>
                                    <div style={{ width: 42, height: 42, borderRadius: 10, background: '#eff6ff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} fill="#1a73e8" viewBox="0 0 16 16">
                                            <path d="M0 .5A.5.5 0 0 1 .5 0h3a.5.5 0 0 1 0 1H1v2.5a.5.5 0 0 1-1 0v-3zm12 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V1h-2.5a.5.5 0 0 1-.5-.5zM.5 12a.5.5 0 0 1 .5.5V15h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H15v-2.5a.5.5 0 0 1 .5-.5zM3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-7zm3 .5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <div style={{ fontSize: 14, fontWeight: 700, color: '#1a1a1a' }}>Payment Gateway</div>
                                        <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>สแกน QR ชำระผ่าน Payment</div>
                                    </div>
                                    <div style={{ marginLeft: 'auto', fontSize: 10, background: '#eff6ff', color: '#1a73e8', padding: '3px 8px', borderRadius: 20, fontWeight: 600 }}>
                                        ⚡ ด่วน
                                    </div>
                                </div>
                                <label className="bk-form-label">จำนวนเงินฝาก</label>
                                <input
                                    type="number"
                                    className="bk-amount-input"
                                    placeholder={`ขั้นต่ำ ${limit ? limit.min : 200} / สูงสุด ${limit ? limit.max : 20000}`}
                                    value={depositamount || ''}
                                    onChange={this.onChangexdep}
                                    name="depositamount"
                                />
                                <div className="bk-preset-grid">
                                    {[100, 200, 300, 500, 1000, 3000].map(amt => (
                                        <button
                                            key={amt}
                                            className={`bk-preset-btn${Number(depositamount) === amt ? ' bk-active' : ''}`}
                                            onClick={(e) => this.handleClickdeposit(e, amt)}
                                        >
                                            {amt.toLocaleString()}
                                        </button>
                                    ))}
                                </div>
                                <div style={{ fontSize: 11, color: '#9ca3af', marginBottom: 10 }}>
                                    จำกัด ขั้นต่ำ/สูงสุด THB {limit ? parseFloat(limit.min).toFixed(2) : '200.00'} / THB {limit ? parseFloat(limit.max).toLocaleString('en', { minimumFractionDigits: 2 }) : '20,000.00'}
                                </div>
                                <button
                                    className="bk-submit-btn"
                                    onClick={(e) => this.confirmdeposit(e, 0)}
                                >
                                    สร้าง QR Code
                                </button>
                            </div>

                            <div className="bk-info-box">
                                ✓ QR Code สแกนได้เพียงครั้งเดียวเท่านั้น กรุณาชำระเงินภายในเวลาที่กำหนด
                            </div>
                        </>
                    )}

                    {/* ══ TAB 4 : อัพโหลดสลิป ══ */}
                    {tabselect === 4 && (
                        <div className="bk-form-card bk-slip-tab-card">
                            <div className="bk-slip-tab-header">
                                <div className="bk-slip-tab-icon">📎</div>
                                <div>
                                    <div className="bk-slip-tab-title">อัพโหลดสลิปโอนเงิน</div>
                                    <div className="bk-slip-tab-sub">แนบหลักฐานการโอนเงินเพื่อให้ทีมงานตรวจสอบ</div>
                                </div>
                            </div>

                            {/* Upload input (hidden) */}
                            <input
                                type="file"
                                accept="image/*"
                                style={{ display: 'none' }}
                                ref={el => this._slipTabInput = el}
                                onChange={this.handleFileSelected}
                            />

                            {slipIsConfirmed ? (
                                /* ── Success state ── */
                                <div className="bk-slip-success">
                                    <div className="bk-slip-success-icon">✅</div>
                                    <div className="bk-slip-success-text">อัปโหลดสลิปสำเร็จแล้ว</div>
                                    <div className="bk-slip-success-sub">ทีมงานจะตรวจสอบและเติมเงินให้คุณโดยเร็ว</div>
                                    <button
                                        type="button"
                                        className="bk-slip-clear-btn"
                                        onClick={this.handleClearFile}
                                    >
                                        ❌ เคลียร์ไฟล์ / ส่งใหม่
                                    </button>
                                </div>
                            ) : slipTabPreviewUrl ? (
                                /* ── Preview state ── */
                                <div className="bk-slip-tab-preview">
                                    <img src={slipTabPreviewUrl} alt="สลิป" className="bk-slip-tab-img" />
                                    <div className="bk-slip-tab-actions">
                                        <button
                                            type="button"
                                            className="bk-submit-btn"
                                            disabled={slipIsUploading}
                                            onClick={this.handleConfirmUpload}
                                        >
                                            {slipIsUploading ? (
                                                <span className="bk-slip-spinner">⏳ กำลังอัปโหลด...</span>
                                            ) : 'ยืนยันอัปโหลดสลิป'}
                                        </button>
                                        <button
                                            type="button"
                                            className="bk-slip-clear-btn"
                                            onClick={this.handleClearFile}
                                        >
                                            ❌ เคลียร์ไฟล์
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                /* ── Upload zone ── */
                                <div
                                    className="bk-slip-zone bk-slip-tab-zone"
                                    onClick={() => this._slipTabInput && this._slipTabInput.click()}
                                >
                                    <span className="bk-slip-icon" style={{ fontSize: 36 }}>🖼️</span>
                                    <p className="bk-slip-text" style={{ fontSize: 15, fontWeight: 600, color: '#374151' }}>แตะเพื่อเลือกสลิป</p>
                                    <p className="bk-slip-hint">รองรับ JPG, PNG — ขนาดไม่เกิน 10MB</p>
                                </div>
                            )}
                        </div>
                    )}

                    {/* ══ ธุรกรรมล่าสุด ══ */}
                    <div className="bk-recent">
                        <div className="bk-recent-title">ธุรกรรมล่าสุด</div>
                        {(!historylist || historylist.filter(x => x.type === 'DE').length === 0) ? (
                            <div className="bk-recent-empty">ยังไม่มีรายการ</div>
                        ) : (
                            <table className="bk-recent-table">
                                <thead>
                                    <tr>
                                        <th>วันที่</th>
                                        <th>จำนวน</th>
                                        <th>สถานะ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {historylist.filter(x => x.type === 'DE').slice(0, 5).map((item, i) => (
                                        <tr key={i}>
                                            <td>{item.createdate ? new Date(item.createdate).toLocaleDateString('th-TH', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }) : '-'}</td>
                                            <td style={{ fontWeight: 700, color: '#16a34a' }}>+{item.amount}</td>
                                            <td>
                                                <span className={
                                                    item.status === '1' ? 'bk-status-ok' :
                                                    item.status === '2' || item.status === '0' ? 'bk-status-pending' :
                                                    'bk-status-fail'
                                                }>
                                                    {item.status === '1' ? 'สำเร็จ' :
                                                     item.status === '2' ? 'กำลังดำเนินการ' :
                                                     item.status === '0' ? 'รอดำเนินการ' :
                                                     item.status === '4' ? 'ยกเลิก' : 'ไม่สำเร็จ'}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>


                    {/* ══ Floating Chat ══ */}
                    {linelink && (
                        <a href={`https://line.me/ti/p/${linelink}`} target="_blank" rel="noreferrer" className="bk-chat-btn">
                            <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} fill="#fff" viewBox="0 0 16 16">
                                <path d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM4.5 5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm-.5 2.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5zm.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3z" />
                            </svg>
                        </a>
                    )}

                </div>
            <Navmenu />
            </>
        );
    }

    /* ── dead code wrapped as unused method ── */
    _oldRenderMobile_UNUSED() {
        /* eslint-disable */
        const { accnumber, paymentgateway, firstname, mainacc, linelink, balance } = this.state;
        var accnumberx; if (accnumber != null) accnumberx = accnumber[0];
        const amountButtons = [100, 300, 500, 1000, 3000, 5000, 10000, 30000, 50000];
        const isQRTab = this.state.tabselect === 2;
        const isBankTab = this.state.tabselect === 1;
        if (false) {
            return (
                <div style={{ minHeight: "100vh", background: "#f0f2f5", paddingBottom: 80 }}>
                    <div style={{ background: "linear-gradient(135deg,#1a1a2e 0%,#16213e 100%)", padding: "0 16px", display: "flex", alignItems: "center", height: 56 }}>
                        <button onClick={() => this.setState({ tabselectsec: 0, tabselect: 1 })} style={{ background: "none", border: "none", color: "#fff", padding: 0, marginRight: 12, cursor: "pointer" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} fill="currentColor" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
                            </svg>
                        </button>
                        <span style={{ color: "#fff", fontSize: 16, fontWeight: 600 }}>สแกน QR ชำระเงิน</span>
                    </div>
                    {/* QR Card */}
                    <div style={{ margin: 16, background: "#fff", borderRadius: 16, padding: 24, textAlign: "center", boxShadow: "0 4px 20px rgba(0,0,0,0.08)" }}>
                        <div style={{ marginBottom: 16, padding: "10px 14px", background: "#f0fdf4", borderRadius: 10, fontSize: 13, color: "#16a34a", border: "1px solid #bbf7d0" }}>
                            ✓ QR Code สแกนได้เพียงครั้งเดียวเท่านั้น
                        </div>
                        {this.state.qrcode !== null &&
                            <div style={{ display: "inline-block", padding: 8, border: "2px solid #e5e7eb", borderRadius: 12, marginBottom: 16 }}>
                                <img src={this.state.qrcode} alt="" style={{ width: 200, height: 200, display: "block" }} />
                            </div>
                        }
                        <div style={{ fontSize: 24, fontWeight: 700, color: "#1a1a2e", marginBottom: 4 }}>
                            ฿ {Number(this.state.depositamount).toLocaleString()}
                        </div>
                        <div style={{ fontSize: 15, fontWeight: 600, color: this.state.counter > 0 ? "#f59e0b" : "#ef4444", marginBottom: 8 }}>
                            ⏱ {this.state.counter > 0 ? `${Math.floor(this.state.counter / 60)}:${String(this.state.counter % 60).padStart(2, '0')} นาที` : "หมดเวลา"}
                        </div>
                        <div style={{ fontSize: 13, color: "#ef4444", marginBottom: 16 }}>โปรดชำระเงินภายในเวลาที่กำหนด</div>
                        {linelink &&
                            <div style={{ padding: "10px 14px", background: "#f0fdf4", borderRadius: 10, fontSize: 13, color: "#15803d", marginBottom: 16 }}>
                                หากเกิดปัญหา ติดต่อ Line: <b>{linelink}</b>
                            </div>
                        }
                        <button
                            className="btn w-100"
                            style={{ background: this.state.counter > 0 ? "#ef4444" : "linear-gradient(135deg,#f97316,#ea580c)", color: "#fff", borderRadius: 10, padding: "12px 0", fontWeight: 600, fontSize: 15 }}
                            onClick={() => this.setState({ tabselectsec: 0, tabselect: 1 })}
                        >
                            {this.state.counter > 0 ? "ยกเลิกรายการ" : "ทำรายการใหม่"}
                        </button>
                    </div>
                </div>
            );
        }

        /* ── [OLD MAIN SCREEN REMOVED] ── */
        return (
            <div style={{ display: 'none' }}>

                {/* ── Header ── */}
                <div style={{ background: "linear-gradient(135deg,#1a1a2e 0%,#16213e 100%)", padding: "0 16px", display: "flex", alignItems: "center", justifyContent: "space-between", height: 56 }}>
                    <a href="/" style={{ color: "#fff", textDecoration: "none", display: "flex", alignItems: "center" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} fill="currentColor" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
                        </svg>
                    </a>
                    <span style={{ color: "#fff", fontSize: 16, fontWeight: 600 }}>ฝากเงิน</span>
                    <div style={{ width: 22 }} />
                </div>

                {/* ── Balance Card ── */}
                <div style={{ margin: "12px 12px 0", background: "#fff", borderRadius: 14, padding: "14px 16px", boxShadow: "0 2px 12px rgba(0,0,0,0.06)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div>
                        <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 2 }}>ยอดกระเป๋าคงเหลือ</div>
                        <div style={{ fontSize: 20, fontWeight: 700, color: "#111827" }}>
                            THB {balance ? Number(balance).toLocaleString('th-TH', { minimumFractionDigits: 2 }) : "0.00"}
                        </div>
                    </div>
                    <div style={{ width: 40, height: 40, borderRadius: "50%", background: "linear-gradient(135deg,#f97316,#ea580c)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="#fff" viewBox="0 0 16 16">
                            <path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1H1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
                            <path d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2H3z" />
                        </svg>
                    </div>
                </div>

                {/* ── Tab Pills (BK8 style) ── */}
                <div style={{ margin: "12px 12px 0", display: "flex", gap: 8 }}>
                    {mainacc !== null &&
                        <button
                            onClick={(e) => this.checktab(e, 1)}
                            style={{
                                flex: 1, border: "none", borderRadius: 10, padding: "10px 8px",
                                background: isBankTab ? "linear-gradient(135deg,#f97316,#ea580c)" : "#fff",
                                color: isBankTab ? "#fff" : "#6b7280",
                                fontWeight: isBankTab ? 600 : 400,
                                boxShadow: isBankTab ? "0 4px 12px rgba(249,115,22,0.35)" : "0 1px 4px rgba(0,0,0,0.08)",
                                cursor: "pointer", fontSize: 13, transition: "all 0.2s"
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1H1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
                                    <path d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2H3z" />
                                </svg>
                                <span>ฝากปกติ</span>
                            </div>
                            <div style={{ fontSize: 11, opacity: 0.85, marginTop: 2 }}>⏱ ~5 นาที</div>
                        </button>
                    }
                    {paymentgateway !== null &&
                        <button
                            onClick={(e) => this.checktab(e, 2)}
                            style={{
                                flex: 1, border: "none", borderRadius: 10, padding: "10px 8px",
                                background: isQRTab ? "linear-gradient(135deg,#f97316,#ea580c)" : "#fff",
                                color: isQRTab ? "#fff" : "#6b7280",
                                fontWeight: isQRTab ? 600 : 400,
                                boxShadow: isQRTab ? "0 4px 12px rgba(249,115,22,0.35)" : "0 1px 4px rgba(0,0,0,0.08)",
                                cursor: "pointer", fontSize: 13, transition: "all 0.2s"
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M0 .5A.5.5 0 0 1 .5 0h3a.5.5 0 0 1 0 1H1v2.5a.5.5 0 0 1-1 0v-3zm12 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V1h-2.5a.5.5 0 0 1-.5-.5zM.5 12a.5.5 0 0 1 .5.5V15h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H15v-2.5a.5.5 0 0 1 .5-.5zM3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7z" />
                                </svg>
                                <span>สแกน QR</span>
                            </div>
                            <div style={{ fontSize: 11, opacity: 0.85, marginTop: 2 }}>⏱ 1-15 นาที</div>
                        </button>
                    }
                </div>

                {/* ── Tab 1: ฝากปกติ (ธนาคาร) ── */}
                <div style={{ display: isBankTab ? "" : "none", padding: "12px 12px 0" }}>

                    {/* ตัวเลือกฝากเงิน label */}
                    <div style={{ fontSize: 12, color: "#6b7280", fontWeight: 500, marginBottom: 8, paddingLeft: 2 }}>ตัวเลือกฝากเงิน</div>

                    {/* ── บัญชีของคุณ ── */}
                    {accnumberx &&
                        <div style={{ background: "#fff", borderRadius: 12, padding: "12px 14px", marginBottom: 10, boxShadow: "0 1px 6px rgba(0,0,0,0.06)" }}>
                            <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 8, display: "flex", alignItems: "center", gap: 4 }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="#9ca3af" viewBox="0 0 16 16">
                                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                                </svg>
                                บัญชีของคุณ
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                <img src={accnumberx.img_path} alt="" style={{ width: 40, height: 40, borderRadius: "50%", border: "2px solid #f3f4f6" }} />
                                <div style={{ flex: 1 }}>
                                    <div style={{ fontWeight: 600, fontSize: 14, color: "#111827" }}>{accnumberx.fullname_th}</div>
                                    <div style={{ fontSize: 13, color: "#6b7280" }}>
                                        {firstname} | {accnumberx.accno.substring(0, 3)}-{accnumberx.accno.substring(3, 9)}-{accnumberx.accno.substring(9, 12)}
                                    </div>
                                </div>
                            </div>
                            <div style={{ marginTop: 10, padding: "7px 10px", background: "#fffbeb", borderRadius: 8, fontSize: 12, color: "#b45309", border: "1px solid #fde68a" }}>
                                ⚠ กรุณาโอนด้วยบัญชีที่ระบุเท่านั้น
                            </div>
                        </div>
                    }

                    {/* ── เลือกธนาคาร label ── */}
                    {mainacc !== null &&
                        <div style={{ fontSize: 12, color: "#6b7280", fontWeight: 500, marginBottom: 8, paddingLeft: 2, marginTop: 4 }}>เลือกธนาคาร</div>
                    }

                    {/* ── โอนเข้าบัญชี (ธนาคาร) ── */}
                    {mainacc !== null && mainacc.bankid !== 6 &&
                        <div style={{ background: "#fff", borderRadius: 12, padding: "12px 14px", marginBottom: 10, boxShadow: "0 1px 6px rgba(0,0,0,0.06)", border: "2px solid #f97316" }}>
                            <div style={{ fontSize: 11, color: "#9ca3af", marginBottom: 10 }}>โอนเข้าบัญชี (ขั้นต่ำ {this.state.limit ? this.state.limit.min : 100} บาท)</div>
                            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
                                <div style={{ width: 44, height: 44, borderRadius: 10, overflow: "hidden", border: "1px solid #f3f4f6", flexShrink: 0 }}>
                                    <img src={mainacc.img_path} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <div style={{ fontWeight: 600, fontSize: 14, color: "#111827" }}>{mainacc.fullname_th}</div>
                                    <div style={{ fontSize: 12, color: "#6b7280" }}>{mainacc.first_name_en} {mainacc.last_name_en}</div>
                                </div>
                                <div style={{ fontSize: 11, padding: "3px 8px", background: "#dcfce7", color: "#16a34a", borderRadius: 20, fontWeight: 500 }}>ออนไลน์</div>
                            </div>
                            {/* Account number copy row */}
                            <div style={{ background: "#f9fafb", borderRadius: 10, padding: "10px 12px", display: "flex", alignItems: "center", justifyContent: "space-between", border: "1px solid #e5e7eb" }}>
                                <span style={{ fontSize: 17, fontWeight: 700, letterSpacing: 1, color: "#111827" }}>
                                    {mainacc.accnumber.substring(0, 3)}-{mainacc.accnumber.substring(3, 9)}-{mainacc.accnumber.substring(9, 12)}
                                </span>
                                <button
                                    style={{ background: "linear-gradient(135deg,#f97316,#ea580c)", border: "none", borderRadius: 8, color: "#fff", fontSize: 13, padding: "6px 14px", cursor: "pointer", fontWeight: 500 }}
                                    onClick={() => { navigator.clipboard.writeText(mainacc.accnumber); }}
                                >
                                    คัดลอก
                                </button>
                            </div>
                            <div style={{ marginTop: 10, padding: "8px 10px", background: "#eff6ff", borderRadius: 8, fontSize: 12, color: "#2563eb", border: "1px solid #bfdbfe" }}>
                                ℹ การโอนเงินระหว่างธนาคารและเครื่องฝากเงินสด ต้องใช้ใบเสร็จรับเงินเพื่ออนุมัติการฝากทีรวดเร็วยิ่งขึ้น
                            </div>
                        </div>
                    }

                    {/* ── PromptPay / QR ── */}
                    {mainacc !== null && mainacc.bankid === 6 &&
                        <div style={{ background: "#fff", borderRadius: 12, padding: "14px", marginBottom: 10, boxShadow: "0 1px 6px rgba(0,0,0,0.06)", border: "2px solid #f97316" }}>
                            <div style={{ textAlign: "center", marginBottom: 14 }}>
                                <img src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/9c9ef88c-a34b-4aa6-1a42-54ff6cd9a800/public" alt="" style={{ width: 56, height: 56 }} />
                                <div style={{ fontSize: 13, color: "#6b7280", marginTop: 6 }}>QR Code มีอายุภายใน 5 นาทีเท่านั้น</div>
                            </div>
                            {/* Amount */}
                            <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 6 }}>จำนวนเงิน (บาท)</div>
                            <input
                                type="number"
                                className="form-control"
                                placeholder="กรอกจำนวนเงิน"
                                style={{ borderRadius: 10, marginBottom: 10, fontSize: 16, padding: "10px 14px", border: "1.5px solid #e5e7eb" }}
                                onChange={this.onChangexdep}
                                value={this.state.depositamount}
                            />
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginBottom: 14 }}>
                                {amountButtons.map(amt => (
                                    <button
                                        key={amt}
                                        style={{
                                            background: this.state.depositamount === amt ? "linear-gradient(135deg,#f97316,#ea580c)" : "#f9fafb",
                                            border: this.state.depositamount === amt ? "none" : "1px solid #e5e7eb",
                                            color: this.state.depositamount === amt ? "#fff" : "#374151",
                                            borderRadius: 8, fontSize: 13, padding: "8px 0", cursor: "pointer", fontWeight: 500
                                        }}
                                        onClick={(e) => this.handleClickdeposit(e, amt)}
                                    >
                                        {amt.toLocaleString()}
                                    </button>
                                ))}
                            </div>
                            <button
                                style={{ background: "linear-gradient(135deg,#f97316,#ea580c)", color: "#fff", border: "none", borderRadius: 10, width: "100%", padding: "13px 0", fontWeight: 700, fontSize: 15, cursor: "pointer" }}
                                onClick={(e) => this.confirmdeposit(e, 7)}
                            >
                                สร้าง QR Code
                            </button>
                        </div>
                    }

                    {/* ── รับโปรโมชั่นอัตโนมัติ ── */}
                    <div style={{ background: "#fff", borderRadius: 12, padding: "12px 14px", marginBottom: 10, boxShadow: "0 1px 6px rgba(0,0,0,0.06)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <div style={{ width: 32, height: 32, borderRadius: 8, background: "#fff7ed", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16 }}>🎁</div>
                            <span style={{ fontSize: 14, color: "#111827", fontWeight: 500 }}>รับโปรโมชั่นอัตโนมัติ</span>
                        </div>
                        <div className="form-check form-switch mb-0">
                            <input className="form-check-input" type="checkbox" role="switch" style={{ width: "3em", height: "1.5em" }} />
                        </div>
                    </div>
                </div>

                {/* ── Tab 2: สแกน QR (Payment Gateway) ── */}
                <div style={{ display: isQRTab ? "" : "none", padding: "12px 12px 0" }}>
                    <div style={{ background: "#fff", borderRadius: 12, padding: "14px", boxShadow: "0 1px 6px rgba(0,0,0,0.06)" }}>
                        <div style={{ textAlign: "center", marginBottom: 14 }}>
                            <img src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/9c9ef88c-a34b-4aa6-1a42-54ff6cd9a800/public" alt="" style={{ width: 56, height: 56 }} />
                            <div style={{ fontSize: 13, color: "#6b7280", marginTop: 6 }}>QR Code มีอายุภายใน 5 นาทีเท่านั้น</div>
                        </div>
                        <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 6 }}>จำนวนเงิน (บาท)</div>
                        <input
                            type="number"
                            className="form-control"
                            placeholder="กรอกจำนวนเงิน"
                            style={{ borderRadius: 10, marginBottom: 10, fontSize: 16, padding: "10px 14px", border: "1.5px solid #e5e7eb" }}
                            onChange={this.onChangexdep}
                            value={this.state.depositamount}
                        />
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginBottom: 14 }}>
                            {amountButtons.map(amt => (
                                <button
                                    key={amt}
                                    style={{
                                        background: this.state.depositamount === amt ? "linear-gradient(135deg,#f97316,#ea580c)" : "#f9fafb",
                                        border: this.state.depositamount === amt ? "none" : "1px solid #e5e7eb",
                                        color: this.state.depositamount === amt ? "#fff" : "#374151",
                                        borderRadius: 8, fontSize: 13, padding: "8px 0", cursor: "pointer", fontWeight: 500
                                    }}
                                    onClick={(e) => this.handleClickdeposit(e, amt)}
                                >
                                    {amt.toLocaleString()}
                                </button>
                            ))}
                        </div>
                        <button
                            style={{ background: "linear-gradient(135deg,#f97316,#ea580c)", color: "#fff", border: "none", borderRadius: 10, width: "100%", padding: "13px 0", fontWeight: 700, fontSize: 15, cursor: "pointer" }}
                            onClick={(e) => this.confirmdeposit(e, 0)}
                        >
                            สร้าง QR Code
                        </button>
                    </div>
                </div>

            </div>
        );
    }

    render() {
        const { loginstate, userid, username, point, accnumber, paymentgateway, firstname, mainacc, lastname, balance, proderedeemlist, linkaff, trueaccount, tblprofile } = this.state
        var accnumberx;
        if (accnumber != null) {
            accnumberx = accnumber[0];
        }
        // ใช้ renderMobile ทั้ง mobile และ desktop (desktop เดิมค้าง "ระบบกำลังดำเนินการ" ส่งค่าไม่ได้)
        return this.renderMobile();
        // eslint-disable-next-line no-unreachable
        return (
            <>
                <header id="mobile-navbar-header" className="mobile-navbar-header" style={{}}>
                    <nav className="mobile-nav header-grey ">
                        <div className="col-left" onClick={(e) => { e.stopPropagation(); window.history.back(); }}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                viewBox="0 0 22.67717 22.67717"
                                className="menu-icon beta-back"
                                width="100%"
                                height="100%"
                                id=""
                                prefix=""
                            >
                                <style
                                    dangerouslySetInnerHTML={{
                                        __html: "\n.beta-back .st0{fill:url(#beta-back-SVGID_1_);}\n  "
                                    }}
                                />
                                <g className="beta-back">
                                    <g>
                                        <linearGradient
                                            id="beta-back-SVGID_1_"
                                            gradientUnits="userSpaceOnUse"
                                            x1="9.094947e-13"
                                            y1="11.33858"
                                            x2="22.67717"
                                            y2="11.33858"
                                        >
                                            <stop offset={0} style={{ stopColor: "rgb(9, 94, 189)" }} />
                                            <stop offset={1} style={{ stopColor: "rgb(4, 169, 194)" }} />
                                        </linearGradient>
                                        <path
                                            className="st0"
                                            d="M0.3228,12.12548l5.56403,5.54451c0.4294,0.4299,1.12705,0.4299,1.55644,0
	c0.4304-0.4299,0.4304-1.12705,0-1.55694l-3.68425-3.66523h17.81665c0.60825,0,1.10149-0.49279,1.10149-1.10104
	c0-0.60825-0.49324-1.10103-1.10149-1.10103H3.75903l3.70018-3.68171c0.4304-0.4299,0.4304-1.12659,0-1.55694
	C7.24404,4.79186,6.963,4.68475,6.68096,4.68475c-0.28199,0-0.56403,0.10711-0.7782,0.32234L0.3228,10.56803
	C-0.1076,10.99843-0.1076,11.69513,0.3228,12.12548L0.3228,12.12548z"
                                        />
                                    </g>
                                </g>
                            </svg>
                            <p className="page-title">ฝาก</p>
                            <div className="sb-content ">
                                <div className="content-container content-1 ">
                                    <div className="sb-acc-info">
                                        <div className="acc-info">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                viewBox="0 0 127.559 127.574"
                                                className="beta-bitcoin"
                                                width="100%"
                                                height="100%"
                                                id=""
                                                prefix=""
                                            >
                                                <style
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            "\n.beta-bitcoin .st0{fill:#F7931A;}\n\t .beta-bitcoin .st1{fill:#FFFFFF;}\n  "
                                                    }}
                                                />
                                                <g className="beta-bitcoin">
                                                    <g>
                                                        <g>
                                                            <path
                                                                className="st0"
                                                                d="M125.6504,79.21532c-8.52025,34.17468-43.13087,54.96821-77.30534,46.44994
		c-34.16093-8.52025-54.95844-43.13286-46.4344-77.30156c8.51447-34.17847,43.12509-54.97398,77.29-46.45473
		C113.37513,10.42843,134.16866,45.04483,125.6504,79.21532z"
                                                            />
                                                            <path
                                                                className="st1"
                                                                d="M96.10387,55.09682c1.39565-9.31852-5.70014-14.32838-15.40341-17.67099l3.14828-12.62283l-7.68344-1.915
		l-3.06488,12.29038c-2.01983-0.50315-4.09505-0.97763-6.15318-1.44796l3.08392-12.37267l-7.67905-1.915l-3.14827,12.61954
		c-1.6736-0.38147-3.31504-0.75768-4.90722-1.15294l0.00854-0.03961L43.7085,28.22375l-2.04544,8.20716
		c0,0,5.70234,1.30592,5.58043,1.38712c3.11412,0.77694,3.67615,2.83617,3.58226,4.46907l-3.58642,14.38069
		c0.21579,0.05559,0.49374,0.13678,0.79927,0.2565c-0.2565-0.06303-0.53007-0.13372-0.81218-0.20091l-5.02475,20.14605
		c-0.38037,0.9446-1.34641,2.36169-3.5201,1.82506c0.07485,0.11118-5.58678-1.39565-5.58678-1.39565l-3.81512,8.79939
		l10.00047,2.49407c1.85941,0.46597,3.6825,0.95315,5.47778,1.41275l-3.18022,12.76815l7.6749,1.915l3.14827-12.63552
		c2.09665,0.57056,4.13137,1.09429,6.1232,1.59219l-3.13754,12.5714l7.68365,1.915l3.18023-12.74232
		c13.10146,2.47922,22.95661,1.47882,27.10287-10.37012c3.34261-9.54088-0.16677-15.04646-7.05946-18.63703
		C91.31439,65.22118,95.09515,61.91905,96.10387,55.09682z M78.54821,79.71413c-2.37438,9.54066-18.44028,4.38569-23.65105,3.09049
		l4.2211-16.9155C64.32685,67.18958,81.02962,69.76509,78.54821,79.71413z M80.925,54.95895
		c-2.16713,8.68054-15.5402,4.27035-19.87664,3.18897l3.82563-15.34257C69.21043,43.88672,83.18186,45.90437,80.925,54.95895z"
                                                            />
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                            <div className="info-content">
                                                <p className="welcome-title">ยินดีต้อนรับ </p>
                                                <p className="acc-name">bobo35561c</p>
                                            </div>
                                        </div>
                                        <div className="sb-leaderboard">
                                            <div className="beta-leaderboard">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="0 0 23.78551 22.50142"
                                                    className=""
                                                    width="100%"
                                                    height="100%"
                                                    id=""
                                                    prefix=""
                                                >
                                                    <style
                                                        dangerouslySetInnerHTML={{
                                                            __html: "\n.beta-leaderboard .st0{fill:#0691C0;}\n  "
                                                        }}
                                                    />
                                                    <g className="beta-leaderboard">
                                                        <g>
                                                            <g>
                                                                <g>
                                                                    <path
                                                                        className="st0"
                                                                        d="M20.26612,17.64887c1.31785,0,2.38991,1.07274,2.38991,2.39059v0.07166
      c0,1.31781-1.07206,2.3899-2.38991,2.3899H3.52006c-1.31785,0-2.3899-1.07209-2.3899-2.3899v-0.07166
      c0-1.31785,1.07206-2.39059,2.3899-2.39059H20.26612z M20.26612,21.19589c0.598,0,1.08482-0.48681,1.08482-1.08478v-0.07166
      c0-0.59865-0.48682-1.08546-1.08482-1.08546H3.52006c-0.59865,0-1.08546,0.48681-1.08546,1.08546v0.07166
      c0,0.59797,0.48681,1.08478,1.08546,1.08478H20.26612z"
                                                                    />
                                                                </g>
                                                                <path
                                                                    className="st0"
                                                                    d="M23.49642,3.76839c-0.2377-0.1694-0.55645-0.1694-0.79483,0L16.25639,8.35l-3.7432-7.95789
  c-0.00469-0.00936-0.01138-0.01738-0.01608-0.02678c-0.01138-0.02143-0.0241-0.04217-0.03751-0.06295
  c-0.01203-0.01807-0.02479-0.0348-0.03816-0.05156c-0.01406-0.01738-0.0288-0.03346-0.04488-0.04886
  c-0.01673-0.01677-0.03346-0.03281-0.05222-0.04755c-0.01539-0.01272-0.03147-0.0241-0.0482-0.03548
  c-0.02143-0.01474-0.04354-0.02815-0.06699-0.04018c-0.00867-0.0047-0.01539-0.01073-0.02475-0.01474
  c-0.00871-0.00401-0.01742-0.00603-0.02612-0.00936c-0.0241-0.01005-0.0482-0.01875-0.07299-0.02613
  c-0.0194-0.00535-0.03885-0.01073-0.05894-0.01474c-0.02277-0.00466-0.04618-0.00737-0.06963-0.01005
  c-0.02074-0.00199-0.04217-0.00333-0.06294-0.00333c-0.02277,0-0.04554,0.00134-0.0683,0.00401
  c-0.02143,0.00199-0.04286,0.0047-0.06428,0.00871c-0.02143,0.00466-0.04286,0.01005-0.06428,0.01673
  c-0.02277,0.00669-0.04419,0.01406-0.06631,0.02345c-0.01005,0.00401-0.02006,0.006-0.0301,0.0107
  c-0.01005,0.0047-0.0181,0.01138-0.02815,0.01673c-0.02074,0.01073-0.04018,0.02277-0.05959,0.03552
  c-0.01875,0.01272-0.03751,0.02609-0.05492,0.04083c-0.01605,0.01341-0.03079,0.02746-0.04618,0.04217
  c-0.01741,0.01742-0.0335,0.03483-0.04889,0.05359c-0.01272,0.01539-0.0241,0.03147-0.03548,0.04755
  c-0.01406,0.02143-0.02746,0.04351-0.03953,0.06627c-0.00466,0.00871-0.0107,0.01608-0.01539,0.02544L7.52914,8.35L1.08329,3.76839
  c-0.23838-0.1694-0.55713-0.1694-0.79486,0c-0.2377,0.1694-0.34216,0.47073-0.2605,0.75067l4.32848,13.83025
  c0.08708,0.29934,0.36095,0.49353,0.65759,0.49353c0.06363,0,0.12857-0.00871,0.19285-0.02746
  c0.36363-0.10649,0.57187-0.48681,0.46607-0.85044L1.89687,6.02904l5.50569,3.91401c0.16608,0.11784,0.37501,0.156,0.57187,0.10447
  c0.19618-0.05156,0.35958-0.1875,0.44598-0.37165l3.47269-7.38067l3.47136,7.38067
  c0.08637,0.18414,0.24977,0.32008,0.44663,0.37165c0.19621,0.05153,0.40511,0.01337,0.57119-0.10447l5.50569-3.91401
  l-3.77536,11.9359c-0.10649,0.36363,0.10244,0.74395,0.46607,0.85044c0.06429,0.01875,0.12857,0.02746,0.19217,0.02746
  c0.29732,0,0.57054-0.19419,0.65824-0.49353l4.32848-13.83025C23.83927,4.23912,23.73481,3.93779,23.49642,3.76839z"
                                                                />
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <p className="navbar-member-group-desc">&gt;100</p>
                                        </div>
                                    </div>
                                    <div className="deposit-progress">
                                        <div className="deposit-progress-group">
                                            <span
                                                className=" lazy-load-image-background opacity"
                                                style={{ color: "transparent", display: "inline-block" }}
                                            >
                                                <span style={{ display: "inline-block" }} />
                                            </span>
                                            <div className="deposit-progress-next-milestone-wrapper">
                                                <p>ระดับถัดไป</p>
                                                <p>BRONZE</p>
                                            </div>
                                        </div>
                                        <div className="progress-bar">
                                            <span style={{ width: "0%" }} />
                                        </div>
                                        <p className="progress-status">0 / 500000</p>
                                    </div>
                                    <div className="sb-menu margin-top">
                                        <div className="menu false" style={{ cursor: 'pointer' }} onClick={(e) => { this.setState({ isMenuOpen: false }); this.checkurl(e, '/'); }}>
                                            <div className="left">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="0 0 90 90"
                                                    className="icon-sb beta-sponsors Sponsors"
                                                    width="100%"
                                                    height="100%"
                                                    id=""
                                                    prefix=""
                                                >
                                                    <style
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                "\n.beta-sponsors .st0{fill:#FF6C00;}\n\t .beta-sponsors .st1{fill:url(#beta-sponsors-beta-sponsors-SVGID_1_);}\n  "
                                                        }}
                                                    />
                                                    <g className="beta-sponsors">
                                                        <g>
                                                            <g>
                                                                <path
                                                                    className="st0"
                                                                    d="M52.3,79.46c-0.91-0.06-1.6-0.86-1.53-1.76c0.06-0.91,0.86-1.6,1.76-1.53C67.14,77.2,79.87,66.15,80.9,51.54
		c0.38-5.45-0.89-10.8-3.68-15.47c-0.23-0.38-0.29-0.82-0.18-1.25c0.11-0.43,0.38-0.79,0.76-1.02c0.29-0.17,0.63-0.25,0.96-0.23
		c0.54,0.04,1.02,0.34,1.3,0.8c3.14,5.26,4.57,11.28,4.14,17.4C83.03,68.2,68.73,80.62,52.3,79.46z"
                                                                />
                                                                <path
                                                                    className="st0"
                                                                    d="M47.87,45.94c-3.38-0.08-5.92-1.9-5.92-3.46c0-0.78,0.7-1.95,1.56-1.95c1.06,0,1.9,1.81,4.35,2.09v-5.56
		c-2.54-0.95-5.42-2.04-5.42-5.61c0-3.55,2.63-5.08,5.42-5.44v-0.78c0-0.36,0.42-0.7,0.95-0.7c0.47,0,0.95,0.34,0.95,0.7v0.72
		c1.81,0.06,4.77,0.59,4.77,2.21c0,0.64-0.45,1.93-1.48,1.93c-0.78,0-1.42-0.89-3.29-1.03v4.91c2.49,0.92,5.28,2.18,5.28,5.97
		c0,3.44-2.15,5.42-5.28,5.92v0.87c0,0.36-0.48,0.7-0.95,0.7c-0.53,0-0.95-0.34-0.95-0.7C47.87,46.72,47.87,45.94,47.87,45.94z
		 M48.09,33.35v-4.22c-1.4,0.22-2.23,0.89-2.23,1.96C45.86,32.31,46.81,32.84,48.09,33.35 M49.55,37.73v4.86
		c1.23-0.25,2.09-0.98,2.09-2.29C51.64,38.93,50.75,38.26,49.55,37.73"
                                                                />
                                                                <path
                                                                    className="st0"
                                                                    d="M77.08,27.63c-0.68-2.1-2.46-3.6-4.64-3.92l-12.98-1.88l-5.8-11.76c-0.98-1.98-2.95-3.21-5.16-3.21
		c-2.2,0-4.18,1.23-5.16,3.21l-5.8,11.75l-12.97,1.88c-2.18,0.32-3.96,1.82-4.65,3.92c-0.68,2.1-0.12,4.36,1.46,5.9l9.39,9.15
		l-1.6,9.35c1.12,0.67,2.25,1.52,2.91,2.53l0,0l2.23-13.03L23.68,31.16c-0.68-0.66-0.91-1.62-0.62-2.52
		c0.29-0.9,1.05-1.54,1.98-1.67l14.69-2.13l6.57-13.31c0.42-0.85,1.26-1.37,2.2-1.37c0.94,0,1.79,0.52,2.2,1.37l6.57,13.31
		l14.69,2.13c0.93,0.14,1.69,0.78,1.98,1.68c0.29,0.89,0.05,1.86-0.62,2.51L62.69,41.53l2.51,14.63c0.12,0.72-0.07,1.44-0.53,1.99
		c-0.47,0.56-1.16,0.88-1.9,0.88c-0.39,0-0.78-0.1-1.13-0.28L48.5,51.84l-13.13,6.9c-0.28,0.15-0.6,0.2-0.91,0.23
		c0.64,1.1,1.37,2.1,2.32,2.74c0.04-0.02,0.08-0.03,0.12-0.05l11.6-6.1l11.61,6.1c0.83,0.44,1.76,0.67,2.68,0.67
		c1.69,0,3.3-0.75,4.41-2.06c1.09-1.29,1.55-2.99,1.26-4.67l-2.22-12.92l9.39-9.15C77.21,31.99,77.76,29.73,77.08,27.63z"
                                                                />
                                                                <linearGradient
                                                                    id="beta-sponsors-beta-sponsors-SVGID_1_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="61.9241"
                                                                    y1="686.1084"
                                                                    x2="5.7306"
                                                                    y2="686.1084"
                                                                    gradientTransform="matrix(1 0 0 -1 0 752)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    className="st1"
                                                                    d="M61.47,68.62c-1.07-2.37-3.85-3.91-6.71-2.82l-7.1,2.69c0.35-2.23-0.76-4.52-2.88-5.56l-8.28-4.08
		c-0.63-0.31-0.72-0.65-1.4-2.03c-2.37-5.68-8.63-8.75-14.58-7.15l-4.37,1.18c-1.01-1.4-2.6-2.21-4.31-2.2l-4.35,0.02
		c-0.97,0.01-1.76,0.8-1.75,1.77l0.13,23.62c0,0.97,0.8,1.76,1.77,1.75l4.35-0.02c2.14-0.01,3.97-1.29,4.79-3.11l18.66,9.2
		c3.46,1.71,7.58,1.68,11.02-0.06l12.57-6.37C61.46,74.21,62.64,71.22,61.47,68.62z M11.96,72.27l-2.59,0.01l-0.11-20.1l2.59-0.01
		c0.97,0,1.76,0.78,1.77,1.75l0.09,16.58C13.72,71.47,12.94,72.26,11.96,72.27z M57.43,72.3l-12.57,6.37
		c-2.46,1.25-5.4,1.26-7.87,0.04l-19.76-9.74l-0.08-14.75l4.29-1.16c4.26-1.15,8.75,1.06,10.43,5.14c0.99,2.41,1.94,3.23,3.07,3.79
		l8.28,4.08c0.87,0.43,1.23,1.49,0.8,2.36c-0.43,0.87-1.49,1.23-2.36,0.8l-8.06-3.98c-0.87-0.43-1.93-0.07-2.36,0.8
		c-0.43,0.87-0.07,1.93,0.8,2.36l9.12,4.5c1.31,0.65,2.84,0.72,4.21,0.2L56,69.09c0.97-0.37,1.92,0.17,2.26,0.99
		C58.62,70.93,58.22,71.9,57.43,72.3z"
                                                                />
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                                <p className="sb-name">สปอนเซอร์</p>
                                            </div>
                                            <div className="right">
                                                <button type="button" className="icon-arrow">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        viewBox="0 0 11.323 20.626"
                                                        className=""
                                                        width="100%"
                                                        height="100%"
                                                        id=""
                                                        prefix=""
                                                    >
                                                        <g className="slide-arrow">
                                                            <path
                                                                className="st0"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                d="M10.06726,20.62599c-0.33301,0-0.64746-0.12988-0.88379-0.36719l-8.64453-8.64453  c-0.34863-0.34668-0.53906-0.80859-0.53906-1.30176c0-0.49121,0.19141-0.95215,0.54004-1.29883l8.64355-8.64551  c0.23633-0.2373,0.55078-0.36816,0.88477-0.36816c0.33496,0,0.64941,0.13086,0.88672,0.36816s0.36816,0.55273,0.36816,0.88867  c-0.00098,0.33398-0.13086,0.64844-0.36719,0.88477l-8.17188,8.1709l8.1709,8.1709c0.48926,0.48926,0.48926,1.28516-0.00098,1.77637  C10.71863,20.49611,10.4032,20.62599,10.06726,20.62599z"
                                                            />
                                                        </g>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="menu false" style={{ cursor: 'pointer' }} onClick={(e) => this.checkurl(e, '/profile')}>
                                            <div className="left">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="0 0 90 90"
                                                    className="icon-sb beta-vip Vip"
                                                    width="100%"
                                                    height="100%"
                                                    id=""
                                                    prefix=""
                                                >
                                                    <style
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                "\n.beta-vip .st1{fill:url(#beta-vip-beta-vip-SVGID_1_);}\n\t .beta-vip .st2{fill:#F89B1C;}\n  "
                                                        }}
                                                    />
                                                    <g className="beta-vip">
                                                        <g>
                                                            <g>
                                                                <g>
                                                                    <path
                                                                        className="st2"
                                                                        d="M28.49,36.62c0.32-0.9,0.9-1.35,1.75-1.35c0.53,0,0.97,0.17,1.34,0.51c0.37,0.34,0.55,0.77,0.55,1.29
			c0,0.3-0.06,0.59-0.17,0.89l-7.67,20.79c-0.23,0.64-0.47,1.07-0.73,1.31c-0.26,0.24-0.62,0.36-1.07,0.36
			c-0.57,0-0.98-0.1-1.23-0.31c-0.25-0.2-0.5-0.66-0.75-1.36l-7.67-20.79c-0.14-0.27-0.2-0.57-0.2-0.89c0-0.52,0.18-0.95,0.54-1.29
			c0.36-0.34,0.8-0.51,1.33-0.51c0.86,0,1.44,0.46,1.73,1.37l6.16,17.49L28.49,36.62z"
                                                                    />
                                                                    <path
                                                                        className="st2"
                                                                        d="M37.84,60.41c-0.5,0-0.94-0.17-1.31-0.51c-0.37-0.34-0.55-0.78-0.55-1.33V37.13c0-0.52,0.18-0.96,0.55-1.33
			c0.37-0.36,0.82-0.54,1.34-0.54c0.53,0,0.96,0.18,1.31,0.54c0.34,0.36,0.52,0.81,0.52,1.33v21.44c0,0.52-0.18,0.96-0.53,1.31
			C38.81,60.24,38.37,60.41,37.84,60.41z"
                                                                    />
                                                                    <path
                                                                        className="st2"
                                                                        d="M48.9,58.57c0,0.5-0.17,0.93-0.52,1.29c-0.34,0.36-0.78,0.54-1.31,0.54c-0.53,0-0.97-0.18-1.34-0.54
			c-0.37-0.36-0.55-0.81-0.55-1.33V37.48c0-0.59,0.19-1.06,0.56-1.41c0.37-0.35,0.89-0.53,1.55-0.53h5.96
			c2.36,0,4.31,0.74,5.86,2.21c1.54,1.48,2.32,3.36,2.32,5.66c0,2.3-0.75,4.17-2.24,5.62c-1.5,1.45-3.42,2.18-5.78,2.18H48.9
			L48.9,58.57L48.9,58.57z M48.9,47.94h4.24c1.28,0,2.36-0.43,3.25-1.29c0.89-0.86,1.33-1.93,1.33-3.2c0-1.25-0.45-2.33-1.33-3.24
			c-0.89-0.91-1.97-1.36-3.25-1.36H48.9V47.94z"
                                                                    />
                                                                </g>
                                                                <linearGradient
                                                                    id="beta-vip-beta-vip-SVGID_1_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="77.3673"
                                                                    y1="476.506"
                                                                    x2="15.0891"
                                                                    y2="476.506"
                                                                    gradientTransform="matrix(1 0 0 -1 0 532)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(0, 168, 193)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(39, 96, 172)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    className="st1"
                                                                    d="M42.24,85.3c-10.29,0-20.04-4.28-26.73-11.75c-0.56-0.62-0.56-1.57,0.01-2.19c0.57-0.62,1.51-0.71,2.18-0.21
		c5.65,4.18,12.42,6.39,19.59,6.39c17.87,0,31.87-13.01,31.87-29.61c0-7.14-2.69-14.07-7.57-19.51c-0.56-0.62-0.56-1.57,0.01-2.19
		c0.57-0.62,1.51-0.71,2.18-0.21c8.64,6.39,13.6,16.02,13.6,26.42C77.37,70.86,61.94,85.3,42.24,85.3z M31.93,80.41
		c3.28,1.06,6.76,1.62,10.31,1.62c17.87,0,31.87-13.01,31.87-29.61c0-4.16-0.89-8.19-2.56-11.89c0.57,2.41,0.87,4.88,0.87,7.38
		c0,18.43-15.43,32.87-35.13,32.87C35.47,80.8,33.69,80.67,31.93,80.41z"
                                                                />
                                                                <path
                                                                    className="st2"
                                                                    d="M58.23,24.77c-0.3,0-0.6-0.08-0.87-0.25c-9.02-5.65-20.62-7.15-30.87-4.08c-0.54,0.17-1.14,0.03-1.56-0.35
		c-0.42-0.38-0.62-0.96-0.51-1.52l1.95-10.27c0.09-0.5,0.42-0.93,0.87-1.16c0.46-0.23,0.99-0.23,1.45-0.01l6.2,3.04l6.4-5.13
		c0.64-0.51,1.57-0.47,2.15,0.1l5.64,5.45l10.45-3.07c0.53-0.16,1.1-0.03,1.52,0.32c0.42,0.36,0.63,0.9,0.56,1.45l-1.77,14.05
		c-0.07,0.55-0.42,1.03-0.92,1.27C58.7,24.72,58.46,24.77,58.23,24.77z M37.42,15.59c6.88,0,13.57,1.69,19.49,4.9l1.15-9.13L49.1,14
		c-0.56,0.17-1.17,0.02-1.59-0.39l-5.3-5.11l-6.09,4.88c-0.49,0.39-1.17,0.47-1.74,0.19l-5.21-2.55l-1.07,5.62
		C31.14,15.94,34.27,15.59,37.42,15.59z"
                                                                />
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                                <p className="sb-name">vip</p>
                                            </div>
                                            <div className="right">
                                                <button type="button" className="icon-arrow">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        viewBox="0 0 11.323 20.626"
                                                        className=""
                                                        width="100%"
                                                        height="100%"
                                                        id=""
                                                        prefix=""
                                                    >
                                                        <g className="slide-arrow">
                                                            <path
                                                                className="st0"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                d="M10.06726,20.62599c-0.33301,0-0.64746-0.12988-0.88379-0.36719l-8.64453-8.64453  c-0.34863-0.34668-0.53906-0.80859-0.53906-1.30176c0-0.49121,0.19141-0.95215,0.54004-1.29883l8.64355-8.64551  c0.23633-0.2373,0.55078-0.36816,0.88477-0.36816c0.33496,0,0.64941,0.13086,0.88672,0.36816s0.36816,0.55273,0.36816,0.88867  c-0.00098,0.33398-0.13086,0.64844-0.36719,0.88477l-8.17188,8.1709l8.1709,8.1709c0.48926,0.48926,0.48926,1.28516-0.00098,1.77637  C10.71863,20.49611,10.4032,20.62599,10.06726,20.62599z"
                                                            />
                                                        </g>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="menu false" style={{ cursor: 'pointer' }} onClick={(e) => this.checkurl(e, '/profile')}>
                                            <div className="left">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="0 0 90 90"
                                                    className="icon-sb beta-leaderboard Leaderboard"
                                                    width="100%"
                                                    height="100%"
                                                    id=""
                                                    prefix=""
                                                >
                                                    <style
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                "\n.beta-leaderboard .st1{fill:url(#beta-leaderboard-beta-leaderboard-SVGID_1_);}\n\t .beta-leaderboard .st13{fill:#E44433;}\n  "
                                                        }}
                                                    />
                                                    <g className="beta-leaderboard">
                                                        <g>
                                                            <g>
                                                                <path
                                                                    className="st13"
                                                                    d="M77.93,23.76c-0.67-0.48-1.58-0.48-2.26,0l-18.29,13L46.76,14.18c-0.01-0.03-0.03-0.05-0.05-0.08
		c-0.03-0.06-0.07-0.12-0.11-0.18c-0.03-0.05-0.07-0.1-0.11-0.15c-0.04-0.05-0.08-0.09-0.13-0.14c-0.05-0.05-0.09-0.09-0.15-0.13
		c-0.04-0.04-0.09-0.07-0.14-0.1c-0.06-0.04-0.12-0.08-0.19-0.11c-0.02-0.01-0.04-0.03-0.07-0.04c-0.02-0.01-0.05-0.02-0.07-0.03
		c-0.07-0.03-0.14-0.05-0.21-0.07c-0.06-0.02-0.11-0.03-0.17-0.04c-0.06-0.01-0.13-0.02-0.2-0.03c-0.06-0.01-0.12-0.01-0.18-0.01
		c-0.06,0-0.13,0-0.19,0.01c-0.06,0.01-0.12,0.01-0.18,0.02c-0.06,0.01-0.12,0.03-0.18,0.05c-0.06,0.02-0.13,0.04-0.19,0.07
		c-0.03,0.01-0.06,0.02-0.09,0.03c-0.03,0.01-0.05,0.03-0.08,0.05c-0.06,0.03-0.11,0.06-0.17,0.1c-0.05,0.04-0.11,0.07-0.16,0.12
		c-0.05,0.04-0.09,0.08-0.13,0.12c-0.05,0.05-0.1,0.1-0.14,0.15c-0.04,0.04-0.07,0.09-0.1,0.13c-0.04,0.06-0.08,0.12-0.11,0.19
		c-0.01,0.02-0.03,0.05-0.04,0.07L32.62,36.77l-18.29-13c-0.68-0.48-1.58-0.48-2.26,0c-0.67,0.48-0.97,1.34-0.74,2.13l12.28,39.25
		c0.25,0.85,1.02,1.4,1.87,1.4c0.18,0,0.36-0.02,0.55-0.08c1.03-0.3,1.62-1.38,1.32-2.41L16.63,30.18l15.63,11.11
		c0.47,0.33,1.06,0.44,1.62,0.3c0.56-0.15,1.02-0.53,1.27-1.05L45,19.58l9.85,20.95c0.25,0.52,0.71,0.91,1.27,1.05
		c0.56,0.15,1.15,0.04,1.62-0.3l15.63-11.11L62.65,64.06c-0.3,1.03,0.29,2.11,1.32,2.41c0.18,0.05,0.36,0.08,0.55,0.08
		c0.84,0,1.62-0.55,1.87-1.4l12.28-39.25C78.91,25.1,78.61,24.25,77.93,23.76z"
                                                                />
                                                                <g>
                                                                    <linearGradient
                                                                        id="beta-leaderboard-beta-leaderboard-SVGID_1_"
                                                                        gradientUnits="userSpaceOnUse"
                                                                        x1="75.5473"
                                                                        y1="-418.0441"
                                                                        x2="14.4546"
                                                                        y2="-418.0441"
                                                                        gradientTransform="matrix(1 0 0 -1 0 -348)"
                                                                    >
                                                                        <stop
                                                                            offset={0}
                                                                            style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                        />
                                                                        <stop
                                                                            offset={1}
                                                                            style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                        />
                                                                    </linearGradient>
                                                                    <path
                                                                        className="st1"
                                                                        d="M68.76,63.16c3.74,0,6.78,3.04,6.78,6.78v0.2c0,3.74-3.04,6.78-6.78,6.78H21.24c-3.74,0-6.78-3.04-6.78-6.78
			v-0.2c0-3.74,3.04-6.78,6.78-6.78H68.76z M68.76,73.23c1.7,0,3.08-1.38,3.08-3.08v-0.2c0-1.7-1.38-3.08-3.08-3.08H21.24
			c-1.7,0-3.08,1.38-3.08,3.08v0.2c0,1.7,1.38,3.08,3.08,3.08H68.76z"
                                                                    />
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                                <p className="sb-name">ลีดเดอร์บอร์ด</p>
                                            </div>
                                            <div className="right">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="0 0 32 24.4"
                                                    className="icon-status beta-win-icon"
                                                    width="100%"
                                                    height="100%"
                                                    id=""
                                                    prefix=""
                                                >
                                                    <style
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                "\n.beta-win-icon .st0{fill:#0277D6;}\n\t .beta-win-icon .st1{fill:#F8951D;}\n\t .beta-win-icon .st2{enable-background:new    ;}\n\t .beta-win-icon .st3{fill:#FFFFFF;}\n  "
                                                        }}
                                                    />
                                                    <g className="beta-win-icon">
                                                        <g>
                                                            <g>
                                                                <g>
                                                                    <g>
                                                                        <path
                                                                            className="st0"
                                                                            d="M0,14c0-2.5,1.6-4.5,3.6-4.5h24.8c2,0,3.6,2,3.6,4.5v5.9c0,2.5-1.6,4.5-3.6,4.5H3.6c-2,0-3.6-2-3.6-4.5L0,14
				L0,14z"
                                                                        />
                                                                    </g>
                                                                    <polygon
                                                                        className="st1"
                                                                        points="25.4,2.6 20.3,4.9 16,0 11.7,4.9 6.6,2.6 6.6,7.7 9.1,7.7 14.1,7.7 17.9,7.7 22.9,7.7 25.4,7.7 		"
                                                                    />
                                                                    <g className="st2">
                                                                        <path
                                                                            className="st3"
                                                                            d="M16,12.8h1.1l-2.7,8.5h-1l-2-7l-0.1,0l-2,7h-1l-2.7-8.5h1.1l2.1,6.8l0,0l1.9-6.8H12l1.9,6.8h0L16,12.8z"
                                                                        />
                                                                        <path
                                                                            className="st3"
                                                                            d="M18.7,14.4c-0.2,0-0.4-0.1-0.5-0.2S18,13.9,18,13.7c0-0.2,0.1-0.4,0.2-0.5s0.3-0.2,0.5-0.2
				c0.2,0,0.4,0.1,0.5,0.2s0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5S18.9,14.4,18.7,14.4z M18.2,21.3v-5.8h1v5.8H18.2z"
                                                                        />
                                                                        <path
                                                                            className="st3"
                                                                            d="M24.2,15.4c0.6,0,1.2,0.2,1.5,0.6s0.6,1,0.6,1.8v3.5h-1v-3.2c0-1.2-0.5-1.8-1.4-1.8c-0.6,0-1,0.2-1.3,0.6
				s-0.5,0.9-0.5,1.5v2.9h-1v-5.8h1v1h0C22.6,15.8,23.3,15.4,24.2,15.4z"
                                                                        />
                                                                    </g>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                                <button type="button" className="icon-arrow">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        viewBox="0 0 11.323 20.626"
                                                        className=""
                                                        width="100%"
                                                        height="100%"
                                                        id=""
                                                        prefix=""
                                                    >
                                                        <g className="slide-arrow">
                                                            <path
                                                                className="st0"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                d="M10.06726,20.62599c-0.33301,0-0.64746-0.12988-0.88379-0.36719l-8.64453-8.64453  c-0.34863-0.34668-0.53906-0.80859-0.53906-1.30176c0-0.49121,0.19141-0.95215,0.54004-1.29883l8.64355-8.64551  c0.23633-0.2373,0.55078-0.36816,0.88477-0.36816c0.33496,0,0.64941,0.13086,0.88672,0.36816s0.36816,0.55273,0.36816,0.88867  c-0.00098,0.33398-0.13086,0.64844-0.36719,0.88477l-8.17188,8.1709l8.1709,8.1709c0.48926,0.48926,0.48926,1.28516-0.00098,1.77637  C10.71863,20.49611,10.4032,20.62599,10.06726,20.62599z"
                                                            />
                                                        </g>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="menu false" style={{ cursor: 'pointer' }} onClick={(e) => { this.setState({ isMenuOpen: false }); this.checkurl(e, '/'); }}>
                                            <div className="left">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="0 0 90 90"
                                                    className="icon-sb beta-download Download"
                                                    width="100%"
                                                    height="100%"
                                                    id=""
                                                    prefix=""
                                                >
                                                    <style
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                "\n.beta-download .st1{fill:url(#beta-download-beta-download-SVGID_1_);}\n\t .beta-download .st6{fill:#00B322;}\n  "
                                                        }}
                                                    />
                                                    <g className="beta-download">
                                                        <g>
                                                            <g>
                                                                <path
                                                                    className="st6"
                                                                    d="M46.85,54.79l11.89-11.93c0.92-0.92,0.92-2.42,0-3.34c-0.92-0.92-2.42-0.92-3.34,0l-7.86,7.9V12.19
		c0-1.3-1.06-2.36-2.36-2.36c-1.3,0-2.36,1.06-2.36,2.36v35.24l-7.89-7.93c-0.92-0.92-2.42-0.92-3.34,0
		c-0.46,0.46-0.69,1.06-0.69,1.67c0,0.6,0.23,1.21,0.69,1.67l11.92,11.96C44.43,55.72,45.93,55.72,46.85,54.79L46.85,54.79z"
                                                                />
                                                                <linearGradient
                                                                    id="beta-download-beta-download-SVGID_1_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="80.5825"
                                                                    y1="38.427"
                                                                    x2="9.7806"
                                                                    y2="38.427"
                                                                    gradientTransform="matrix(1 0 0 -1 0 92)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    className="st1"
                                                                    d="M80.51,56.89L68.75,28.44c-0.15-0.53-0.52-0.95-1-1.18l-0.18-0.08c-0.25-0.11-0.5-0.16-0.76-0.16H53.88
		c-1.02,0-1.83,0.81-1.83,1.83c0,1.02,0.81,1.83,1.83,1.83h11.69l10.78,24.9H62.11c-1.02,0-1.83,0.81-1.83,1.83v1.65
		c0,2.43-1.97,4.4-4.4,4.4H33.91c-2.43,0-4.4-1.97-4.4-4.4v-1.65c0-1.02-0.81-1.83-1.83-1.83H14l10.81-24.94h11.63
		c1.02,0,1.83-0.82,1.83-1.83c0-1.02-0.81-1.83-1.83-1.83H23.56c-0.26,0-0.52,0.05-0.76,0.16l-0.18,0.08
		c-0.49,0.23-0.87,0.65-1,1.18L9.85,56.85c-0.04,0.16-0.07,0.32-0.07,0.49v9.62c0,7.28,5.93,13.21,13.21,13.21h44.38
		c7.29,0,13.21-5.93,13.21-13.21v-9.58C80.58,57.21,80.57,57.04,80.51,56.89L80.51,56.89z M76.92,66.96c0,5.26-4.29,9.55-9.55,9.55
		H22.99c-5.26,0-9.55-4.29-9.55-9.55v-7.72h12.44c0.09,4.35,3.68,7.87,8.06,7.87h21.96c4.38,0,7.96-3.51,8.06-7.87h12.98v7.72H76.92
		z"
                                                                />
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                                <p className="sb-name">ดาวน์โหลด</p>
                                            </div>
                                            <div className="right">
                                                <button type="button" className="icon-arrow">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        viewBox="0 0 11.323 20.626"
                                                        className=""
                                                        width="100%"
                                                        height="100%"
                                                        id=""
                                                        prefix=""
                                                    >
                                                        <g className="slide-arrow">
                                                            <path
                                                                className="st0"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                d="M10.06726,20.62599c-0.33301,0-0.64746-0.12988-0.88379-0.36719l-8.64453-8.64453  c-0.34863-0.34668-0.53906-0.80859-0.53906-1.30176c0-0.49121,0.19141-0.95215,0.54004-1.29883l8.64355-8.64551  c0.23633-0.2373,0.55078-0.36816,0.88477-0.36816c0.33496,0,0.64941,0.13086,0.88672,0.36816s0.36816,0.55273,0.36816,0.88867  c-0.00098,0.33398-0.13086,0.64844-0.36719,0.88477l-8.17188,8.1709l8.1709,8.1709c0.48926,0.48926,0.48926,1.28516-0.00098,1.77637  C10.71863,20.49611,10.4032,20.62599,10.06726,20.62599z"
                                                            />
                                                        </g>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="common-menu">
                                        <div className="menu " style={{ cursor: 'pointer' }} onClick={(e) => { this.setState({ isMenuOpen: false }); this.checkurl(e, '/'); }}>
                                            <div className="icon-sb">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="0 0 90 90"
                                                    className="beta-home Home"
                                                    width="100%"
                                                    height="100%"
                                                    id=""
                                                    prefix=""
                                                >
                                                    <style
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                "\n.beta-home .st0{fill:url(#beta-home-beta-home-SVGID_1_);}\n  "
                                                        }}
                                                    />
                                                    <g className="beta-home">
                                                        <g>
                                                            <g>
                                                                <linearGradient
                                                                    id="beta-home-beta-home-SVGID_1_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="82.4022"
                                                                    y1="992.5104"
                                                                    x2="8.7535"
                                                                    y2="985.1804"
                                                                    gradientTransform="matrix(1 0 0 -1 0 1042)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    className="st0"
                                                                    d="M17.19,80.27c-1.11,0-2.01-0.9-2.01-2.01v-27.9c0-0.61,0.27-1.18,0.75-1.56l27.97-25.02
		c0.35-0.29,0.8-0.45,1.26-0.45c0.46,0,0.9,0.16,1.26,0.45L74.38,48.8c0.47,0.38,0.75,0.95,0.75,1.56l0,27.82l0,0.12
		c0,1.07-0.9,1.97-2.01,1.97H17.19z M19.19,51.32v24.94h51.92V51.32l-25.96-23.4L19.19,51.32z"
                                                                />
                                                                <linearGradient
                                                                    id="beta-home-beta-home-SVGID_00000145046575731348593450000006592621334771588764_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="79.9884"
                                                                    y1="1016.7638"
                                                                    x2="6.3396"
                                                                    y2="1009.4338"
                                                                    gradientTransform="matrix(1 0 0 -1 0 1042)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M45.15,9.73c-0.46,0-0.9,0.16-1.26,0.44
		L8.75,40.66C8.33,41,8.07,41.47,8.01,42.01c-0.06,0.53,0.09,1.06,0.43,1.47c0.38,0.48,0.95,0.75,1.57,0.75
		c0.46,0,0.89-0.15,1.25-0.44l33.58-29.23l0.32-0.25l0.32,0.25l33.27,29.21c0.36,0.29,0.79,0.44,1.25,0.44
		c0.61,0,1.18-0.27,1.57-0.75c0.69-0.86,0.55-2.13-0.31-2.82L46.41,10.17C46.05,9.88,45.61,9.73,45.15,9.73z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-home-beta-home-SVGID_00000145046575731348593450000006592621334771588764_")'
                                                                    }}
                                                                />
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <p className="sb-name">หน้าแรก</p>
                                        </div>
                                        <div className="menu middle" style={{ cursor: 'pointer' }} onClick={(e) => { this.setState({ isMenuOpen: false }); this.checkurl(e, '/'); }}>
                                            <div className="icon-sb">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="0 0 34.01575 34.01575"
                                                    className="beta-region beta-thailand"
                                                    width="100%"
                                                    height="100%"
                                                    id=""
                                                    prefix=""
                                                >
                                                    <style
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                "\n.beta-thailand .st0{fill:#FFFFFF;}\n\t .beta-thailand .st1{fill:#CE4451;}\n\t .beta-thailand .st2{fill:#4161A9;}\n  "
                                                        }}
                                                    />
                                                    <g className="beta-thailand">
                                                        <g>
                                                            <g>
                                                                <g>
                                                                    <path
                                                                        className="st0"
                                                                        d="M34.01575,16.82357v0.08361c0,0.14587,0,0.29175-0.00358,0.43762v0.08005
			c0,0.13556,0,0.26755-0.01041,0.40311c0,0.04519-0.01038,0.09037-0.01038,0.12488
			c-0.00716,0.0523-0.01074,0.10069-0.01396,0.14943c0,0.02099-0.00358,0.04163-0.00358,0.06618v0.0032
			c-0.04546,0.72973-0.12958,1.44558-0.2656,2.144c-0.12958,0.65679-0.29743,1.30291-0.50006,1.92839
			c-0.02434,0.08326-0.05226,0.16331-0.08374,0.24656c-0.00716,0.04163-0.01756,0.0765-0.0351,0.11812
			c-0.10488,0.31986-0.22372,0.6326-0.35294,0.94498c-0.0945,0.22237-0.19222,0.44154-0.29388,0.66035
			c-0.93318,2.00132-2.24758,3.7906-3.85191,5.27069c-1.57677,1.46301-3.43633,2.62325-5.48488,3.40528
			c-0.7023,0.27076-1.42966,0.49313-2.17419,0.67031c-1.04164,0.24692-2.12193,0.39635-3.22621,0.43798
			c-0.2273,0.01032-0.46176,0.01743-0.69583,0.01743c-1.35272,0-2.66354-0.15975-3.92567-0.45541
			c-0.69905-0.16331-1.38062-0.36824-2.04495-0.62193c-0.20262-0.06938-0.40522-0.14587-0.60102-0.23269
			c-0.14676-0.06262-0.29385-0.12488-0.43346-0.19106c-1.69528-0.75748-3.23339-1.78927-4.57929-3.02992
			c-1.60469-1.48009-2.91873-3.26936-3.84869-5.27069c-0.19222-0.40311-0.36368-0.82366-0.52795-1.2474
			c-0.0419-0.11812-0.08736-0.23625-0.12208-0.35793c-0.01432-0.04163-0.02468-0.07649-0.03508-0.11812
			c-0.02434-0.0797-0.05262-0.16331-0.08054-0.24656c-0.20258-0.62548-0.37048-1.2716-0.49968-1.92839
			c-0.14676-0.73649-0.2377-1.49397-0.27958-2.26532c-0.01432-0.20849-0.02468-0.41343-0.02468-0.62548v-0.08005
			C0,17.19893,0,17.05306,0,16.90718v-0.07294c0-0.00356,0-0.00356,0-0.01067c0-0.04519,0-0.10425,0.00682-0.15263v-0.11812
			c0-0.02099,0-0.04163,0-0.06262c0-0.04874,0-0.09749,0.00716-0.14587h33.99136c0.00682,0.04839,0.00682,0.09713,0.00682,0.14587
			c0,0.01743,0,0.04163,0,0.06262v0.11812C34.01575,16.72644,34.01575,16.77163,34.01575,16.82357z"
                                                                    />
                                                                </g>
                                                                <g>
                                                                    <path
                                                                        className="st0"
                                                                        d="M34.01575,16.82357v0.08361c0,0.14587,0,0.29175-0.00358,0.43762v0.08005
			c0,0.13556,0,0.26755-0.01041,0.40311c0,0.04519-0.01038,0.09037-0.01038,0.12488
			c-0.00716,0.0523-0.01074,0.10069-0.01396,0.14943c0,0.02099-0.00358,0.04163-0.00358,0.06618v0.0032
			c-0.04546,0.72973-0.12958,1.44558-0.2656,2.144H0.31108c-0.14676-0.73649-0.2377-1.49397-0.27958-2.26532
			c-0.01432-0.20849-0.02468-0.41343-0.02468-0.62548v-0.08005C0,17.19893,0,17.05306,0,16.90718v-0.07294
			c0-0.00356,0-0.00356,0-0.01067c0-0.04519,0-0.10425,0.00682-0.15263v-0.11812c0-0.02099,0-0.04163,0-0.06262
			c0-0.04874,0-0.09749,0.00716-0.14587c0-0.06618,0.0032-0.1288,0.0032-0.19462c0-0.01743,0-0.03131,0.00358-0.0523
			c0.01074-0.21525,0.0247-0.43086,0.04188-0.64612c0.00358-0.03131,0.00358-0.06618,0.01074-0.09393
			c0.02076-0.21881,0.04188-0.44118,0.07338-0.65999c0.00358-0.04519,0.0104-0.08361,0.01756-0.12168
			c0.02074-0.17718,0.04866-0.35081,0.08016-0.52479c0.04188-0.22913,0.07696-0.4515,0.12958-0.67387
			c0.04868-0.21881,0.09772-0.43442,0.15356-0.64967c0.00358-0.02775,0.01396-0.0523,0.01754-0.0765
			c0.04188-0.14943,0.08054-0.29531,0.12242-0.44118c0.0383-0.12524,0.0698-0.25012,0.11526-0.3718
			c0.1013-0.32662,0.20976-0.64967,0.33576-0.95921c0.04546-0.12488,0.08736-0.23945,0.13602-0.35437
			c0.00358-0.01032,0.01074-0.02064,0.01432-0.03131c0.05226-0.132,0.11168-0.264,0.16752-0.396
			c0.10166-0.22237,0.20978-0.45506,0.31822-0.67387c0.95072-1.91451,2.25473-3.62053,3.82757-5.03124
			C6.88626,3.21066,8.37534,2.23437,10.0044,1.5082c0.08016-0.04519,0.17108-0.08361,0.2552-0.11812
			c0.25844-0.11136,0.51724-0.21561,0.77928-0.31986C12.89518,0.37892,14.90866,0,17.0095,0
			c0.23408,0,0.46853,0.00356,0.69583,0.01743c1.89428,0.06938,3.71231,0.45861,5.40041,1.10153
			c1.98555,0.76068,3.79285,1.87964,5.33812,3.27292c1.56926,1.41747,2.86969,3.12349,3.82041,5.03124
			c0.01396,0.03131,0.03508,0.05906,0.04904,0.09037c0.15034,0.3195,0.30068,0.64256,0.4299,0.97949
			c0.00358,0.01067,0.01074,0.02099,0.01396,0.03131c0.05262,0.11492,0.0945,0.22949,0.13996,0.35437
			c0.54516,1.40751,0.90168,2.90823,1.04522,4.46838c0.02076,0.24336,0.0383,0.48992,0.05226,0.73329v0.01708
			c0.00716,0.08361,0.01074,0.16331,0.01074,0.24692c0.00682,0.04839,0.00682,0.09713,0.00682,0.14587
			c0,0.01743,0,0.04163,0,0.06262v0.11812C34.01575,16.72644,34.01575,16.77163,34.01575,16.82357z"
                                                                    />
                                                                </g>
                                                                <g>
                                                                    <path
                                                                        className="st1"
                                                                        d="M28.44386,4.39188H5.58225C6.88626,3.21066,8.37534,2.23437,10.0044,1.5082
			c0.08016-0.04519,0.17108-0.08361,0.2552-0.11812c0.25844-0.11136,0.51724-0.21561,0.77928-0.31986
			C12.89518,0.37892,14.90866,0,17.0095,0c0.23408,0,0.46853,0.00356,0.69583,0.01743
			c1.89428,0.06938,3.71231,0.45861,5.40041,1.10153C25.09129,1.87964,26.89858,2.99861,28.44386,4.39188z"
                                                                    />
                                                                </g>
                                                                <g>
                                                                    <path
                                                                        className="st1"
                                                                        d="M10.0044,32.51467c-1.69528-0.75748-3.23339-1.78927-4.57929-3.02992h23.16552
			c-1.57677,1.46301-3.43633,2.62325-5.48488,3.40528c-0.7023,0.27076-1.42966,0.49313-2.17419,0.67031
			c-1.04164,0.24692-2.12193,0.39635-3.22621,0.43798c-0.2273,0.01032-0.46176,0.01743-0.69583,0.01743
			c-1.35272,0-2.66354-0.15975-3.92567-0.45541c-0.69905-0.16331-1.38062-0.36824-2.04495-0.62193
			c-0.20262-0.06938-0.40522-0.14587-0.60102-0.23269C10.29109,32.64311,10.144,32.58084,10.0044,32.51467z"
                                                                    />
                                                                </g>
                                                                <g>
                                                                    <path
                                                                        className="st2"
                                                                        d="M34.01575,16.82357v0.08361c0,0.14587,0,0.29175-0.00358,0.43762v0.08005
			c0,0.13556,0,0.26755-0.01041,0.40311c0,0.04519-0.01038,0.09037-0.01038,0.12488
			c-0.00716,0.0523-0.01074,0.10069-0.01396,0.14943c0,0.02099-0.00358,0.04163-0.00358,0.06618v0.0032
			c-0.04546,0.72973-0.12958,1.44558-0.2656,2.144c-0.12958,0.65679-0.29743,1.30291-0.50006,1.92839
			c-0.02434,0.08326-0.05226,0.16331-0.08374,0.24656c-0.00716,0.04163-0.01756,0.0765-0.0351,0.11812
			c-0.10488,0.31986-0.22372,0.6326-0.35294,0.94498c-0.0945,0.22237-0.19222,0.44154-0.29388,0.66035H1.57642
			c-0.19222-0.40311-0.36368-0.82366-0.52795-1.2474c-0.0419-0.11812-0.08736-0.23625-0.12208-0.35793
			c-0.01432-0.04163-0.02468-0.07649-0.03508-0.11812c-0.02434-0.0797-0.05262-0.16331-0.08054-0.24656
			c-0.20258-0.62548-0.37048-1.2716-0.49968-1.92839c-0.14676-0.73649-0.2377-1.49397-0.27958-2.26532
			c-0.01432-0.20849-0.02468-0.41343-0.02468-0.62548v-0.08005C0,17.19893,0,17.05306,0,16.90718v-0.07294
			c0-0.00356,0-0.00356,0-0.01067c0-0.04519,0-0.10425,0.00682-0.15263v-0.11812c0-0.02099,0-0.04163,0-0.06262
			c0-0.04874,0-0.09749,0.00716-0.14587c0-0.06618,0.0032-0.1288,0.0032-0.19462c0-0.01743,0-0.03131,0.00358-0.0523
			c0.01074-0.21525,0.0247-0.43086,0.04188-0.64612c0.00358-0.03131,0.00358-0.06618,0.01074-0.09393
			c0.02076-0.21881,0.04188-0.44118,0.07338-0.65999c0.00358-0.04519,0.0104-0.08361,0.01756-0.12168
			c0.02074-0.17718,0.04866-0.35081,0.08016-0.52479c0.04188-0.22913,0.07696-0.4515,0.12958-0.67387
			c0.04868-0.21881,0.09772-0.43442,0.15356-0.64967c0.00358-0.02775,0.01396-0.0523,0.01754-0.0765
			c0.04188-0.14943,0.08054-0.29531,0.12242-0.44118c0.0383-0.12524,0.0698-0.25012,0.11526-0.3718
			c0.1013-0.32662,0.20976-0.64967,0.33576-0.95921c0.04546-0.12488,0.08736-0.23945,0.13602-0.35437
			c0.00358-0.01032,0.01074-0.02064,0.01432-0.03131c0.05226-0.132,0.11168-0.264,0.16752-0.396
			c0.10166-0.22237,0.20978-0.45506,0.31822-0.67387h30.5096c0.01396,0.03131,0.03508,0.05906,0.04904,0.09037
			c0.15034,0.3195,0.30068,0.64256,0.4299,0.97949c0.00358,0.01067,0.01074,0.02099,0.01396,0.03131
			c0.05262,0.11492,0.0945,0.22949,0.13996,0.35437c0.54516,1.40751,0.90168,2.90823,1.04522,4.46838
			c0.02076,0.24336,0.0383,0.48992,0.05226,0.73329v0.01708c0.00716,0.08361,0.01074,0.16331,0.01074,0.24692
			c0.00682,0.04839,0.00682,0.09713,0.00682,0.14587c0,0.01743,0,0.04163,0,0.06262v0.11812
			C34.01575,16.72644,34.01575,16.77163,34.01575,16.82357z"
                                                                    />
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <p className="sb-name">ภาษา</p>
                                        </div>
                                        <div className="menu " style={{ cursor: 'pointer' }} onClick={(e) => { this.setState({ isMenuOpen: false }); this.checkurl(e, '/'); }}>
                                            <div className="icon-sb">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="0 0 90 90"
                                                    className="beta-promo Promotion"
                                                    width="100%"
                                                    height="100%"
                                                    id=""
                                                    prefix=""
                                                >
                                                    <style
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                "\n.beta-promo .st0{fill:url(#beta-promo-beta-promo-SVGID_1_);}\n  "
                                                        }}
                                                    />
                                                    <g className="beta-promo">
                                                        <g>
                                                            <g>
                                                                <g>
                                                                    <linearGradient
                                                                        id="beta-promo-beta-promo-SVGID_1_"
                                                                        gradientUnits="userSpaceOnUse"
                                                                        x1="85.0145"
                                                                        y1="-899.5892"
                                                                        x2="5.6019"
                                                                        y2="-906.9904"
                                                                        gradientTransform="matrix(1 0 0 -1 0 -858)"
                                                                    >
                                                                        <stop
                                                                            offset={0}
                                                                            style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                        />
                                                                        <stop
                                                                            offset={1}
                                                                            style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                        />
                                                                    </linearGradient>
                                                                    <path
                                                                        className="st0"
                                                                        d="M56.52,27.4c-0.12-0.44-0.39-0.8-0.78-1.03c-0.25-0.14-0.54-0.22-0.83-0.22c-0.6,0-1.16,0.32-1.46,0.84
			L33.17,62.02c-0.22,0.39-0.28,0.84-0.17,1.27c0.12,0.44,0.4,0.8,0.78,1.02c0.25,0.15,0.54,0.23,0.85,0.23
			c0.6,0,1.15-0.32,1.45-0.84l20.27-35.04C56.57,28.27,56.63,27.82,56.52,27.4z"
                                                                    />
                                                                    <linearGradient
                                                                        id="beta-promo-beta-promo-SVGID_00000160898495340036526090000001845233154539599039_"
                                                                        gradientUnits="userSpaceOnUse"
                                                                        x1="84.0098"
                                                                        y1="-888.8083"
                                                                        x2="4.5971"
                                                                        y2="-896.2095"
                                                                        gradientTransform="matrix(1 0 0 -1 0 -858)"
                                                                    >
                                                                        <stop
                                                                            offset={0}
                                                                            style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                        />
                                                                        <stop
                                                                            offset={1}
                                                                            style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                        />
                                                                    </linearGradient>
                                                                    <path
                                                                        d="M42.79,35.43c0-4.62-3.76-8.38-8.37-8.38
			s-8.37,3.76-8.37,8.38c0,4.62,3.76,8.37,8.37,8.37S42.79,40.05,42.79,35.43z M34.42,30.69c2.62,0,4.74,2.13,4.74,4.74
			c0,2.61-2.13,4.74-4.74,4.74c-2.62,0-4.74-2.13-4.74-4.74C29.67,32.82,31.8,30.69,34.42,30.69z"
                                                                        style={{
                                                                            fill:
                                                                                'url("#beta-promo-beta-promo-SVGID_00000160898495340036526090000001845233154539599039_")'
                                                                        }}
                                                                    />
                                                                    <linearGradient
                                                                        id="beta-promo-beta-promo-SVGID_00000166650581553527387410000009165962717144524718_"
                                                                        gradientUnits="userSpaceOnUse"
                                                                        x1="86.0191"
                                                                        y1="-910.3682"
                                                                        x2="6.6065"
                                                                        y2="-917.7693"
                                                                        gradientTransform="matrix(1 0 0 -1 0 -858)"
                                                                    >
                                                                        <stop
                                                                            offset={0}
                                                                            style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                        />
                                                                        <stop
                                                                            offset={1}
                                                                            style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                        />
                                                                    </linearGradient>
                                                                    <path
                                                                        d="M55.1,46.88c-4.62,0-8.37,3.76-8.37,8.37
			s3.76,8.37,8.37,8.37s8.37-3.76,8.37-8.37S59.72,46.88,55.1,46.88z M55.1,59.99c-2.62,0-4.74-2.13-4.74-4.74s2.13-4.74,4.74-4.74
			c2.62,0,4.74,2.13,4.74,4.74S57.71,59.99,55.1,59.99z"
                                                                        style={{
                                                                            fill:
                                                                                'url("#beta-promo-beta-promo-SVGID_00000166650581553527387410000009165962717144524718_")'
                                                                        }}
                                                                    />
                                                                </g>
                                                                <linearGradient
                                                                    id="beta-promo-beta-promo-SVGID_00000093868165271692865040000011500806311678253703_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="84.9849"
                                                                    y1="-899.2714"
                                                                    x2="5.5723"
                                                                    y2="-906.6726"
                                                                    gradientTransform="matrix(1 0 0 -1 0 -858)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M54.61,83.08c-1.72,0-3.44-0.43-5.1-0.85
		c-1.67-0.42-3.16-0.79-4.51-0.79c-1.36,0-2.85,0.37-4.41,0.77c-1.7,0.42-3.45,0.86-5.2,0.86c-0.95,0-1.81-0.13-2.63-0.39
		c-2.7-0.87-4.55-3.11-6.19-5.08c-1.01-1.23-1.96-2.37-2.99-3.11c-1.03-0.75-2.38-1.29-3.82-1.87c-2.46-0.99-5.17-2.07-6.81-4.33
		c-1.63-2.25-1.83-5.12-2-7.65c-0.11-1.6-0.21-3.12-0.62-4.38c-0.38-1.18-1.16-2.41-1.99-3.71C6.95,50.37,5.38,47.89,5.38,45
		s1.57-5.37,2.95-7.55c0.83-1.3,1.61-2.53,2-3.72c0.41-1.27,0.51-2.77,0.62-4.36c0.17-2.54,0.37-5.42,2-7.66
		c1.65-2.26,4.33-3.33,6.7-4.28c1.49-0.6,2.89-1.15,3.93-1.92c1.03-0.75,2.01-1.93,2.95-3.07c1.66-2,3.53-4.25,6.23-5.13
		c0.82-0.27,1.68-0.39,2.63-0.39c1.74,0,3.48,0.44,5.15,0.86c1.6,0.4,3.09,0.78,4.46,0.78c1.36,0,2.84-0.37,4.41-0.77
		c1.69-0.42,3.44-0.86,5.2-0.86c0.95,0,1.81,0.13,2.63,0.39c2.71,0.87,4.56,3.11,6.19,5.09c1.03,1.24,1.97,2.37,2.99,3.11
		c1.06,0.77,2.44,1.32,3.91,1.91c2.38,0.95,5.07,2.03,6.71,4.29c1.64,2.25,1.83,5.12,2,7.66c0.11,1.6,0.21,3.1,0.62,4.37
		c0.38,1.19,1.17,2.41,1.99,3.71c1.39,2.2,2.95,4.67,2.95,7.55c0,2.89-1.56,5.36-2.94,7.53c-0.84,1.31-1.62,2.55-2.01,3.73
		c-0.41,1.27-0.51,2.77-0.62,4.36c-0.18,2.56-0.37,5.43-2,7.67c-1.65,2.26-4.33,3.33-6.7,4.28c-1.48,0.59-2.87,1.14-3.93,1.92
		c-1.02,0.74-1.96,1.87-2.94,3.06c-1.67,2.01-3.53,4.26-6.24,5.14C56.43,82.95,55.57,83.08,54.61,83.08z M45,77.64
		c1.84,0,3.62,0.45,5.34,0.88c1.54,0.39,2.99,0.75,4.27,0.75c0.55,0,1.03-0.07,1.46-0.21c1.65-0.53,3.01-2.17,4.45-3.9
		c1.13-1.36,2.27-2.74,3.67-3.75c1.43-1.04,3.09-1.7,4.7-2.34c2.1-0.84,4.09-1.63,5.09-3.01c0.99-1.35,1.13-3.45,1.28-5.66
		c0.12-1.76,0.24-3.59,0.8-5.29c0.53-1.63,1.48-3.12,2.39-4.56c1.23-1.94,2.37-3.74,2.37-5.53c0-1.78-1.14-3.58-2.34-5.48
		c-0.93-1.47-1.88-2.97-2.42-4.61c-0.55-1.7-0.67-3.51-0.79-5.25c-0.15-2.24-0.29-4.35-1.28-5.7c-1-1.38-2.96-2.16-5.03-2.99
		c-1.64-0.65-3.32-1.33-4.76-2.37c-1.4-1.03-2.54-2.4-3.65-3.73c-1.46-1.76-2.81-3.39-4.47-3.93c-0.43-0.14-0.91-0.21-1.46-0.21
		c-1.25,0-2.67,0.35-4.17,0.73c-1.8,0.45-3.61,0.91-5.44,0.91c-1.83,0-3.61-0.45-5.33-0.88c-1.59-0.4-3.03-0.76-4.28-0.76
		c-0.55,0-1.03,0.07-1.46,0.21c-1.66,0.54-3.01,2.17-4.45,3.9c-1.11,1.35-2.26,2.73-3.67,3.75c-1.42,1.03-3.08,1.7-4.69,2.34
		c-2.12,0.85-4.1,1.63-5.1,3.01c-0.99,1.35-1.13,3.45-1.28,5.66c-0.12,1.77-0.24,3.6-0.8,5.3c-0.53,1.63-1.47,3.12-2.38,4.55
		C10.34,41.39,9.19,43.2,9.19,45c0,1.79,1.14,3.59,2.35,5.5c0.92,1.45,1.88,2.95,2.41,4.59c0.55,1.69,0.67,3.49,0.79,5.23
		c0.15,2.26,0.29,4.36,1.28,5.73c1.01,1.38,2.97,2.17,5.04,2.99c1.64,0.66,3.32,1.33,4.75,2.36c1.4,1.02,2.53,2.39,3.63,3.7
		c1.47,1.77,2.83,3.42,4.49,3.96c0.42,0.14,0.9,0.21,1.46,0.21c1.28,0,2.71-0.36,4.23-0.74C41.38,78.09,43.17,77.64,45,77.64z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-promo-beta-promo-SVGID_00000093868165271692865040000011500806311678253703_")'
                                                                    }}
                                                                />
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <p className="sb-name">โปรโมชั่น</p>
                                        </div>
                                        <div className="menu " style={{ cursor: 'pointer' }} onClick={(e) => { this.setState({ isMenuOpen: false }); this.checkurl(e, '/'); }}>
                                            <div className="icon-sb">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="0 0 90 90"
                                                    className="beta-sports Sports"
                                                    width="100%"
                                                    height="100%"
                                                    id=""
                                                    prefix=""
                                                >
                                                    <style
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                "\n.beta-sports .st0{fill:url(#beta-sports-beta-sports-SVGID_1_);}\n  "
                                                        }}
                                                    />
                                                    <g className="beta-sports">
                                                        <g>
                                                            <g>
                                                                <g>
                                                                    <linearGradient
                                                                        id="beta-sports-beta-sports-SVGID_1_"
                                                                        gradientUnits="userSpaceOnUse"
                                                                        x1="74.0142"
                                                                        y1="-505.2905"
                                                                        x2="7.0961"
                                                                        y2="-505.604"
                                                                        gradientTransform="matrix(1.0958 0 0 1.0958 -9.580000e-02 599.4172)"
                                                                    >
                                                                        <stop
                                                                            offset={0}
                                                                            style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                        />
                                                                        <stop
                                                                            offset={1}
                                                                            style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                        />
                                                                    </linearGradient>
                                                                    <path
                                                                        className="st0"
                                                                        d="M44.8,82.6c-20.4,0-37-16.6-37-37s16.6-37,37-37s37,16.6,37,37C81.8,65.9,65.2,82.6,44.8,82.6z M44.8,12
			c-18.5,0-33.5,15-33.5,33.5s15,33.5,33.5,33.5s33.5-15,33.5-33.5S63.2,12,44.8,12z"
                                                                    />
                                                                    <linearGradient
                                                                        id="beta-sports-beta-sports-SVGID_00000160890710492574802160000014303154398513720998_"
                                                                        gradientUnits="userSpaceOnUse"
                                                                        x1="103.7158"
                                                                        y1="44.2283"
                                                                        x2="-15.8948"
                                                                        y2="43.6679"
                                                                    >
                                                                        <stop
                                                                            offset={0}
                                                                            style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                        />
                                                                        <stop
                                                                            offset={1}
                                                                            style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                        />
                                                                    </linearGradient>
                                                                    <path
                                                                        d="M56.2,57.7l4.1-12.5
			c0.1-0.5,0.2-0.9,0.2-1.4l9.8-2.4l-0.7-2.8l-9.8,2.4c-0.3-0.6-0.8-1.1-1.3-1.5l-10.6-7.7c-0.5-0.3-1-0.6-1.5-0.7V20.4h-2.9v10.8
			c-0.5,0.2-1,0.4-1.5,0.7l-10.6,7.7c-0.6,0.4-1,0.9-1.4,1.5l-10-2.5l-0.7,2.8l10,2.5c0,0.4,0.1,0.9,0.2,1.3l4.1,12.5
			c0.1,0.4,0.3,0.7,0.5,1.1l-5.5,6.9l2.3,1.8l5.4-6.8c0.7,0.3,1.4,0.5,2.1,0.5l13.1,0c0.8,0,1.6-0.2,2.3-0.5l5.4,6.8l2.3-1.8l-5.6-7
			C55.9,58.3,56.1,58,56.2,57.7z M38.3,58.4c-1,0-1.9-0.6-2.2-1.6l-4.1-12.5c-0.3-0.9,0-2,0.8-2.6l10.6-7.7c0.4-0.3,0.9-0.4,1.3-0.4
			s1,0.2,1.4,0.4l10.6,7.7c0.8,0.6,1.1,1.6,0.8,2.6l-4.1,12.5c-0.3,0.9-1.2,1.6-2.2,1.6H38.3z"
                                                                        style={{
                                                                            fill:
                                                                                'url("#beta-sports-beta-sports-SVGID_00000160890710492574802160000014303154398513720998_")'
                                                                        }}
                                                                    />
                                                                </g>
                                                            </g>
                                                            <g>
                                                                <g>
                                                                    <g>
                                                                        <defs>
                                                                            <circle
                                                                                id="beta-sports-beta-sports-SVGID_00000056399560493944308780000017463597159669684149_"
                                                                                cx="44.3"
                                                                                cy="45.8"
                                                                                r="35.7"
                                                                            />
                                                                        </defs>
                                                                        <clipPath id="beta-sports-beta-sports-SVGID_00000180334252422099486360000006289708053516378549_">
                                                                            <use
                                                                                xlinkHref="#beta-sports-beta-sports-SVGID_00000056399560493944308780000017463597159669684149_"
                                                                                style={{ overflow: "visible" }}
                                                                            />
                                                                        </clipPath>
                                                                        <linearGradient
                                                                            id="beta-sports-beta-sports-SVGID_00000137107859320121715610000004377850367273915030_"
                                                                            gradientUnits="userSpaceOnUse"
                                                                            x1="74.1841"
                                                                            y1="-541.5801"
                                                                            x2="7.266"
                                                                            y2="-541.8936"
                                                                            gradientTransform="matrix(1.0958 0 0 1.0958 -9.580000e-02 599.4172)"
                                                                        >
                                                                            <stop
                                                                                offset={0}
                                                                                style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                            />
                                                                            <stop
                                                                                offset={1}
                                                                                style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                            />
                                                                        </linearGradient>
                                                                        <path
                                                                            d="
				M51.4-9.3c2.2,0,4.1,1.4,4.8,3.5l4.1,12.5c0.7,2.1-0.1,4.4-1.8,5.6L47.8,20c-0.9,0.6-1.9,1-3,1c-1.1,0-2.1-0.3-3-1l-10.6-7.7
				c-1.8-1.3-2.5-3.6-1.8-5.6l4.1-12.5c0.7-2.1,2.6-3.5,4.8-3.5H51.4z M44.9,18.2c0.5,0,0.9-0.2,1.3-0.4L56.8,10
				c0.8-0.6,1.1-1.6,0.8-2.6L53.6-5c-0.3-0.9-1.2-1.6-2.2-1.6H38.3c-1,0-1.9,0.6-2.2,1.6L32.1,7.5c-0.3,0.9,0,2,0.8,2.6l10.6,7.7
				C43.9,18,44.4,18.2,44.9,18.2z"
                                                                            style={{
                                                                                clipPath:
                                                                                    'url("#beta-sports-beta-sports-SVGID_00000180334252422099486360000006289708053516378549_")',
                                                                                fill:
                                                                                    'url("#beta-sports-beta-sports-SVGID_00000137107859320121715610000004377850367273915030_")'
                                                                            }}
                                                                        />
                                                                    </g>
                                                                </g>
                                                                <g>
                                                                    <g>
                                                                        <defs>
                                                                            <circle
                                                                                id="beta-sports-beta-sports-SVGID_00000080910969394666267920000007315653112342220189_"
                                                                                cx="44.3"
                                                                                cy="45.8"
                                                                                r="35.7"
                                                                            />
                                                                        </defs>
                                                                        <clipPath id="beta-sports-beta-sports-SVGID_00000077319441481836938540000002547883050333965469_">
                                                                            <use
                                                                                xlinkHref="#beta-sports-beta-sports-SVGID_00000080910969394666267920000007315653112342220189_"
                                                                                style={{ overflow: "visible" }}
                                                                            />
                                                                        </clipPath>
                                                                        <linearGradient
                                                                            id="beta-sports-beta-sports-SVGID_00000183950184926703255610000013586712917518715553_"
                                                                            gradientUnits="userSpaceOnUse"
                                                                            x1="73.8698"
                                                                            y1="-474.4522"
                                                                            x2="6.9517"
                                                                            y2="-474.7656"
                                                                            gradientTransform="matrix(1.0958 0 0 1.0958 -9.580000e-02 599.4172)"
                                                                        >
                                                                            <stop
                                                                                offset={0}
                                                                                style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                            />
                                                                            <stop
                                                                                offset={1}
                                                                                style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                            />
                                                                        </linearGradient>
                                                                        <path
                                                                            d="
				M84.2,80.3c0.7,2.1-0.1,4.4-1.8,5.6l-10.6,7.7c-1.8,1.3-4.2,1.3-5.9,0l-10.6-7.7c-0.9-0.6-1.5-1.5-1.8-2.5c-0.3-1-0.3-2.1,0-3.1
				l4-12.5c0.7-2.1,2.6-3.5,4.8-3.5l13.1,0c2.2,0,4.1,1.4,4.8,3.5L84.2,80.3z M56,82.6c0.2,0.5,0.4,0.9,0.8,1.1l10.6,7.7
				c0.8,0.6,1.9,0.6,2.7,0l10.6-7.7c0.8-0.6,1.1-1.6,0.8-2.6l-4-12.4c-0.3-0.9-1.2-1.6-2.2-1.6l-13.1,0c-1,0-1.9,0.6-2.2,1.6
				l-4,12.5C55.9,81.6,55.9,82.1,56,82.6z"
                                                                            style={{
                                                                                clipPath:
                                                                                    'url("#beta-sports-beta-sports-SVGID_00000077319441481836938540000002547883050333965469_")',
                                                                                fill:
                                                                                    'url("#beta-sports-beta-sports-SVGID_00000183950184926703255610000013586712917518715553_")'
                                                                            }}
                                                                        />
                                                                    </g>
                                                                </g>
                                                                <g>
                                                                    <g>
                                                                        <defs>
                                                                            <circle
                                                                                id="beta-sports-beta-sports-SVGID_00000067944996995358601680000004970381321037245837_"
                                                                                cx="44.3"
                                                                                cy="45.8"
                                                                                r="35.7"
                                                                            />
                                                                        </defs>
                                                                        <clipPath id="beta-sports-beta-sports-SVGID_00000175314409169257314020000017348495973767527556_">
                                                                            <use
                                                                                xlinkHref="#beta-sports-beta-sports-SVGID_00000067944996995358601680000004970381321037245837_"
                                                                                style={{ overflow: "visible" }}
                                                                            />
                                                                        </clipPath>
                                                                        <linearGradient
                                                                            id="beta-sports-beta-sports-SVGID_00000109019705127218535360000014438251403997678226_"
                                                                            gradientUnits="userSpaceOnUse"
                                                                            x1="73.8692"
                                                                            y1="-474.3319"
                                                                            x2="6.9511"
                                                                            y2="-474.6454"
                                                                            gradientTransform="matrix(1.0958 0 0 1.0958 -9.580000e-02 599.4172)"
                                                                        >
                                                                            <stop
                                                                                offset={0}
                                                                                style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                            />
                                                                            <stop
                                                                                offset={1}
                                                                                style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                            />
                                                                        </linearGradient>
                                                                        <path
                                                                            d="
				M36.8,80.2c0.7,2.1-0.1,4.4-1.8,5.6l-10.6,7.7c-1.8,1.3-4.2,1.3-5.9,0L7.9,85.8C7,85.2,6.4,84.3,6,83.3c-0.3-1-0.3-2.1,0-3.1
				l4-12.5c0.7-2.1,2.6-3.5,4.8-3.5l13.1,0c2.2,0,4.1,1.4,4.8,3.5L36.8,80.2z M8.7,82.5c0.2,0.5,0.4,0.9,0.8,1.1l10.6,7.7
				c0.8,0.6,1.9,0.6,2.7,0l10.6-7.7c0.8-0.6,1.1-1.6,0.8-2.6l-4-12.4C29.9,67.6,29,67,28,67l-13.1,0c-1,0-1.9,0.6-2.2,1.6L8.7,81
				C8.5,81.5,8.5,82,8.7,82.5z"
                                                                            style={{
                                                                                clipPath:
                                                                                    'url("#beta-sports-beta-sports-SVGID_00000175314409169257314020000017348495973767527556_")',
                                                                                fill:
                                                                                    'url("#beta-sports-beta-sports-SVGID_00000109019705127218535360000014438251403997678226_")'
                                                                            }}
                                                                        />
                                                                    </g>
                                                                </g>
                                                                <g>
                                                                    <g>
                                                                        <defs>
                                                                            <circle
                                                                                id="beta-sports-beta-sports-SVGID_00000136393137334160480400000011652711557331968185_"
                                                                                cx="44.3"
                                                                                cy="45.8"
                                                                                r="35.7"
                                                                            />
                                                                        </defs>
                                                                        <clipPath id="beta-sports-beta-sports-SVGID_00000158002206498174502790000013984341383085452688_">
                                                                            <use
                                                                                xlinkHref="#beta-sports-beta-sports-SVGID_00000136393137334160480400000011652711557331968185_"
                                                                                style={{ overflow: "visible" }}
                                                                            />
                                                                        </clipPath>
                                                                        <linearGradient
                                                                            id="beta-sports-beta-sports-SVGID_00000065068256041310082160000018384959851046193543_"
                                                                            gradientUnits="userSpaceOnUse"
                                                                            x1="74.0523"
                                                                            y1="-513.4147"
                                                                            x2="7.1342"
                                                                            y2="-513.7281"
                                                                            gradientTransform="matrix(1.0958 0 0 1.0958 -9.580000e-02 599.4172)"
                                                                        >
                                                                            <stop
                                                                                offset={0}
                                                                                style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                            />
                                                                            <stop
                                                                                offset={1}
                                                                                style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                            />
                                                                        </linearGradient>
                                                                        <path
                                                                            d="
				M-5.6,24.8c0.7-2.1,2.6-3.5,4.8-3.5l13.1,0c2.2,0,4.1,1.4,4.8,3.5l4,12.5c0.3,1,0.3,2.1,0,3.1c-0.3,1-1,1.9-1.8,2.5L8.8,50.6
				c-1.8,1.3-4.2,1.3-5.9,0l-10.6-7.7c-1.8-1.3-2.5-3.6-1.8-5.6L-5.6,24.8z M18.6,38.2l-4-12.5c-0.3-0.9-1.2-1.6-2.2-1.6l-13.1,0
				c-1,0-1.9,0.6-2.2,1.6l-4,12.4c-0.3,0.9,0,2,0.8,2.6l10.6,7.7c0.8,0.6,1.9,0.6,2.7,0l10.6-7.7c0.4-0.3,0.7-0.7,0.8-1.1
				C18.7,39.1,18.7,38.6,18.6,38.2z"
                                                                            style={{
                                                                                clipPath:
                                                                                    'url("#beta-sports-beta-sports-SVGID_00000158002206498174502790000013984341383085452688_")',
                                                                                fill:
                                                                                    'url("#beta-sports-beta-sports-SVGID_00000065068256041310082160000018384959851046193543_")'
                                                                            }}
                                                                        />
                                                                    </g>
                                                                </g>
                                                                <g>
                                                                    <g>
                                                                        <defs>
                                                                            <circle
                                                                                id="beta-sports-beta-sports-SVGID_00000183229110689331639040000005032271361672820877_"
                                                                                cx="44.3"
                                                                                cy="45.8"
                                                                                r="35.7"
                                                                            />
                                                                        </defs>
                                                                        <clipPath id="beta-sports-beta-sports-SVGID_00000102522778040943839530000017736194351024043454_">
                                                                            <use
                                                                                xlinkHref="#beta-sports-beta-sports-SVGID_00000183229110689331639040000005032271361672820877_"
                                                                                style={{ overflow: "visible" }}
                                                                            />
                                                                        </clipPath>
                                                                        <linearGradient
                                                                            id="beta-sports-beta-sports-SVGID_00000173871557042342933190000015408589195369931442_"
                                                                            gradientUnits="userSpaceOnUse"
                                                                            x1="74.0537"
                                                                            y1="-513.7354"
                                                                            x2="7.1356"
                                                                            y2="-514.0489"
                                                                            gradientTransform="matrix(1.0958 0 0 1.0958 -9.580000e-02 599.4172)"
                                                                        >
                                                                            <stop
                                                                                offset={0}
                                                                                style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                            />
                                                                            <stop
                                                                                offset={1}
                                                                                style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                            />
                                                                        </linearGradient>
                                                                        <path
                                                                            d="
				M99.3,37.3c0.7,2.1-0.1,4.4-1.8,5.6l-10.6,7.7c-1.8,1.3-4.2,1.3-5.9,0l-10.6-7.7c-0.9-0.6-1.5-1.5-1.8-2.5c-0.3-1-0.3-2.1,0-3.1
				l4-12.5c0.7-2.1,2.6-3.5,4.8-3.5l13.1,0c2.2,0,4.1,1.4,4.8,3.5L99.3,37.3z M71.1,39.6c0.2,0.5,0.4,0.9,0.8,1.1l10.6,7.7
				c0.8,0.6,1.9,0.6,2.7,0l10.6-7.7c0.8-0.6,1.1-1.6,0.8-2.6l-4-12.4c-0.3-0.9-1.2-1.6-2.2-1.6l-13.1,0c-1,0-1.9,0.6-2.2,1.6
				l-4,12.5C70.9,38.6,70.9,39.1,71.1,39.6z"
                                                                            style={{
                                                                                clipPath:
                                                                                    'url("#beta-sports-beta-sports-SVGID_00000102522778040943839530000017736194351024043454_")',
                                                                                fill:
                                                                                    'url("#beta-sports-beta-sports-SVGID_00000173871557042342933190000015408589195369931442_")'
                                                                            }}
                                                                        />
                                                                    </g>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <p className="sb-name">กีฬา</p>
                                        </div>
                                        <div className="menu middle" style={{ cursor: 'pointer' }} onClick={(e) => { this.setState({ isMenuOpen: false }); this.checkurl(e, '/'); }}>
                                            <div className="icon-sb">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="0 0 90 90"
                                                    className="beta-esports Esports"
                                                    width="100%"
                                                    height="100%"
                                                    id=""
                                                    prefix=""
                                                >
                                                    <style
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                "\n.beta-esports .st0{fill:url(#beta-esports-beta-esports-SVGID_1_);}\n  "
                                                        }}
                                                    />
                                                    <g className="beta-esports">
                                                        <g>
                                                            <g>
                                                                <linearGradient
                                                                    id="beta-esports-beta-esports-SVGID_00000149381585859429982900000015643622737578267784_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="89.7949"
                                                                    y1="426.7579"
                                                                    x2="1.1698"
                                                                    y2="424.9492"
                                                                    gradientTransform="matrix(1 0 0 -1 0 472)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M9.73,75.24c-0.79,0-1.56-0.1-2.31-0.29
		c-2.31-0.66-4.09-2.34-5.3-4.97C0.87,67,0.36,62.87,0.58,57.34c0.22-4.94,1.08-10.66,2.44-16.1c1.2-5.04,2.98-9.85,5-13.54
		c4.25-7.52,8.98-10.88,15.34-10.88c3.37,0,6.93,0.9,10.71,1.85l1.08,0.27c3.01,0.73,6.12,1.49,9.37,1.79l1.12,0
		c3.24-0.31,6.34-1.06,9.34-1.78l0.9-0.22c3.65-0.96,7.43-1.96,10.94-1.96c6.34,0,11.07,3.34,15.33,10.82
		c1.86,3.41,3.54,7.97,5,13.54c1.36,5.44,2.23,11.15,2.44,16.1c0.22,5.64-0.29,9.78-1.55,12.64c-1.12,2.66-2.9,4.37-5.3,5.08
		c-0.68,0.18-1.4,0.27-2.15,0.27c-1.5,0-3.16-0.35-4.93-1.04c-3.99-1.64-8.77-5.04-14.21-10.1c-3.25-3.14-9.37-5.02-16.37-5.02
		c-7.01,0-13.13,1.87-16.37,5.02c-5.44,5.06-10.21,8.46-14.21,10.1C12.88,74.88,11.27,75.24,9.73,75.24z M45.08,55.06
		c7.99,0,15.12,2.36,19.07,6.31c4.84,4.6,9.31,7.8,12.91,9.24c1.26,0.47,2.39,0.71,3.35,0.71c0.45,0,0.87-0.05,1.24-0.15
		c1.16-0.35,2.04-1.27,2.7-2.81c1.04-2.43,1.44-6,1.23-10.91c-0.2-4.5-1.01-9.81-2.33-15.35c-1.28-5.13-2.86-9.36-4.67-12.57
		c-3.32-5.98-7.14-8.64-12.4-8.64c-2.85,0-5.88,0.76-9.09,1.55c-4,1.03-7.36,1.85-11.23,2.17h-1.66c-3.77-0.33-7.15-1.15-10.87-2.11
		c-3.12-0.82-6.33-1.67-9.3-1.67c-5.25,0-9.08,2.68-12.42,8.69c-1.76,3.12-3.33,7.34-4.67,12.57c-1.27,4.88-2.1,10.33-2.34,15.35
		c-0.21,4.84,0.16,8.43,1.12,10.69c0.66,1.54,1.54,2.46,2.7,2.81c0.38,0.14,0.78,0.21,1.26,0.21c0.89,0,1.95-0.24,3.33-0.76
		c3.37-1.28,7.59-4.3,12.91-9.23C30.03,57.33,37.2,55.06,45.08,55.06z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-esports-beta-esports-SVGID_00000149381585859429982900000015643622737578267784_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-esports-beta-esports-SVGID_00000163066480414734687710000001688156450678714258_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="89.6731"
                                                                    y1="432.7257"
                                                                    x2="1.048"
                                                                    y2="430.9171"
                                                                    gradientTransform="matrix(1 0 0 -1 0 472)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M26.28,50.24c-1.2,0-2.18-0.98-2.18-2.19
		V33.08c0-1.2,0.98-2.18,2.18-2.18c1.2,0,2.18,0.98,2.18,2.18v14.97C28.46,49.26,27.48,50.24,26.28,50.24z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-esports-beta-esports-SVGID_00000163066480414734687710000001688156450678714258_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-esports-beta-esports-SVGID_00000137840059427623816060000003736562625662171302_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="89.6731"
                                                                    y1="432.7257"
                                                                    x2="1.048"
                                                                    y2="430.917"
                                                                    gradientTransform="matrix(1 0 0 -1 0 472)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M16.6,40.57c0-1.2,0.98-2.18,2.19-2.18
		h14.97c1.2,0,2.18,0.98,2.18,2.18c0,1.2-0.98,2.18-2.18,2.18H18.79C17.58,42.75,16.6,41.77,16.6,40.57z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-esports-beta-esports-SVGID_00000137840059427623816060000003736562625662171302_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-esports-beta-esports-SVGID_00000163070230211146896980000002834487441989678986_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="89.6919"
                                                                    y1="431.8054"
                                                                    x2="1.0667"
                                                                    y2="429.9967"
                                                                    gradientTransform="matrix(1 0 0 -1 0 472)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M71.37,44.2c-2,0-3.63-1.63-3.63-3.63
		c0-2,1.63-3.63,3.63-3.63c2,0,3.63,1.63,3.63,3.63S73.37,44.2,71.37,44.2z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-esports-beta-esports-SVGID_00000163070230211146896980000002834487441989678986_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-esports-beta-esports-SVGID_00000090261166783585004200000009936672188430910351_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="89.6852"
                                                                    y1="432.131"
                                                                    x2="1.0601"
                                                                    y2="430.3223"
                                                                    gradientTransform="matrix(1 0 0 -1 0 472)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M55.41,44.2c-2,0-3.63-1.63-3.63-3.63
		c0-2,1.63-3.63,3.63-3.63c2,0,3.63,1.63,3.63,3.63S57.41,44.2,55.41,44.2z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-esports-beta-esports-SVGID_00000090261166783585004200000009936672188430910351_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-esports-beta-esports-SVGID_00000103255323833855547790000008716290423947260842_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="89.8513"
                                                                    y1="423.9903"
                                                                    x2="1.2263"
                                                                    y2="422.1816"
                                                                    gradientTransform="matrix(1 0 0 -1 0 472)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M59.76,48.55c0-2,1.63-3.63,3.63-3.63
		c2,0,3.63,1.63,3.63,3.63c0,2-1.63,3.63-3.63,3.63C61.39,52.18,59.76,50.55,59.76,48.55z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-esports-beta-esports-SVGID_00000103255323833855547790000008716290423947260842_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-esports-beta-esports-SVGID_00000127723343920522589220000003956642823217321381_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="89.5257"
                                                                    y1="439.9453"
                                                                    x2="0.9006"
                                                                    y2="438.1366"
                                                                    gradientTransform="matrix(1 0 0 -1 0 472)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M59.76,32.59c0-2,1.63-3.63,3.63-3.63
		c2,0,3.63,1.63,3.63,3.63s-1.63,3.63-3.63,3.63C61.39,36.22,59.76,34.59,59.76,32.59z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-esports-beta-esports-SVGID_00000127723343920522589220000003956642823217321381_")'
                                                                    }}
                                                                />
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <p className="sb-name">อี สปอร์ต</p>
                                        </div>
                                        <div className="menu " style={{ cursor: 'pointer' }} onClick={(e) => { this.setState({ isMenuOpen: false }); this.checkurl(e, '/'); }}>
                                            <div className="icon-sb">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="0 0 90 90"
                                                    className="beta-casino Casino"
                                                    width="100%"
                                                    height="100%"
                                                    id=""
                                                    prefix=""
                                                >
                                                    <style
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                "\n.beta-casino .st0{fill:url(#beta-casino-beta-casino-SVGID_1_);}\n  "
                                                        }}
                                                    />
                                                    <g className="beta-casino">
                                                        <g>
                                                            <g>
                                                                <linearGradient
                                                                    id="beta-casino-beta-casino-SVGID_1_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="80.3471"
                                                                    y1="234.4905"
                                                                    x2="10.6459"
                                                                    y2="231.8524"
                                                                    gradientTransform="matrix(1 0 0 -1 0 282)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    className="st0"
                                                                    d="M35.64,65.64l-1.17-1.06c-0.33-0.3-8.1-7.35-10.5-9.81l-0.41-0.42c-2.36-2.39-5.6-5.67-5.6-11.93
		c0-5.14,4.06-9.32,9.06-9.32c4.06,0,7.01,2.1,8.62,3.64c1.62-1.54,4.57-3.64,8.63-3.64c4.99,0,9.06,4.18,9.06,9.32
		c0,6.26-3.23,9.54-5.6,11.93l-0.41,0.42c-2.4,2.46-10.17,9.51-10.5,9.81L35.64,65.64z M27.01,36.58c-3.07,0-5.58,2.62-5.58,5.84
		c0,4.83,2.34,7.2,4.59,9.49l0.42,0.43c1.79,1.83,6.87,6.49,9.19,8.6c2.31-2.11,7.39-6.77,9.18-8.6l0.42-0.43
		c2.26-2.29,4.59-4.66,4.59-9.49c0-3.22-2.5-5.84-5.58-5.84c-4.44,0-7.19,3.73-7.21,3.77l-1.43,1.97l-1.41-1.98
		C34.19,40.31,31.45,36.58,27.01,36.58z"
                                                                />
                                                                <linearGradient
                                                                    id="beta-casino-beta-casino-SVGID_00000014630911890647158010000006093618624355137459_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="80.3418"
                                                                    y1="234.6295"
                                                                    x2="10.6406"
                                                                    y2="231.9914"
                                                                    gradientTransform="matrix(1 0 0 -1 0 282)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M52.89,14.14H18.38
		c-4.46,0-8.1,3.63-8.1,8.1v53.65c0,4.47,3.63,8.1,8.1,8.1h34.51c4.46,0,8.1-3.63,8.1-8.1V22.24
		C60.99,17.77,57.36,14.14,52.89,14.14z M57.21,75.89c0,2.38-1.94,4.32-4.32,4.32H18.38c-2.33,0-4.32-1.89-4.32-3.44l0-54.54
		c0-2.38,1.94-4.32,4.32-4.32h34.51c2.33,0,4.32,1.89,4.32,3.44L57.21,75.89z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-casino-beta-casino-SVGID_00000014630911890647158010000006093618624355137459_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-casino-beta-casino-SVGID_00000072969730258161233240000007446169866367244168_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="80.1578"
                                                                    y1="239.4894"
                                                                    x2="10.4567"
                                                                    y2="236.8513"
                                                                    gradientTransform="matrix(1 0 0 -1 0 282)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M73.11,12.52L39.19,6.15
		c-4.39-0.82-8.63,2.08-9.45,6.47l-0.6,3.22h3.85l0.47-2.52c0.44-2.34,2.7-3.89,5.04-3.45l33.92,6.37c2.29,0.43,3.9,2.65,3.61,4.17
		l-10.07,53.6c-0.44,2.34-2.7,3.89-5.04,3.45l-2.64-0.5v3.84l1.94,0.37c4.39,0.82,8.63-2.08,9.45-6.47l9.91-52.73
		C80.4,17.59,77.5,13.35,73.11,12.52z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-casino-beta-casino-SVGID_00000072969730258161233240000007446169866367244168_")'
                                                                    }}
                                                                />
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <p className="sb-name">คาสิโนสด</p>
                                        </div>
                                        <div className="menu " style={{ cursor: 'pointer' }} onClick={(e) => { this.setState({ isMenuOpen: false }); this.checkurl(e, '/'); }}>
                                            <div className="icon-star-container">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="-217.66559 292.71454 90 90"
                                                    className="star-border-icon icon-border-star"
                                                    width="100%"
                                                    height="100%"
                                                    id=""
                                                    prefix=""
                                                >
                                                    <style
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                "\n.star-border-icon .st0{fill:#E0092C;}\n                .star-border-icon .st1{fill:#FFFFFF;}\n  "
                                                        }}
                                                    />
                                                    <g className="star-border-icon">
                                                        <g>
                                                            <circle
                                                                className="st0"
                                                                cx="-172.66559"
                                                                cy="337.71454"
                                                                r={40}
                                                            />
                                                            <path
                                                                className="st1"
                                                                d="M-189.01041,344.95557l-2.23663,13.04053c-0.30492,1.77597,0.42516,3.57132,1.88342,4.63092
		c1.45827,1.05914,3.39093,1.19928,4.98602,0.36032l11.71153-6.15689l11.71153,6.15689
		c0.69267,0.36407,1.44926,0.54352,2.20255,0.54352c0.98148,0,1.95869-0.3049,2.78348-0.9043
		c1.45825-1.05914,2.18832-2.85452,1.88342-4.63095l-2.23663-13.04053l9.4749-9.23581
		c1.29065-1.25797,1.75513-3.13953,1.19833-4.85345s-2.03873-2.96292-3.82225-3.22238l-13.09357-1.90283l-5.85576-11.86493
		c-0.79779-1.61591-2.44354-2.63907-4.24553-2.63907s-3.44821,1.02316-4.24553,2.63907l-5.85576,11.86493l-13.09357,1.90283
		c-1.78352,0.259-3.26498,1.50845-3.82225,3.22238c-0.55679,1.71393-0.09233,3.59549,1.19833,4.85345L-189.01041,344.95557z
		 M-178.94273,334.75436c1.54205-0.22394,2.87532-1.19266,3.56468-2.58984l2.71199-5.49451l2.71198,5.49451
		c0.68983,1.39719,2.02263,2.36591,3.5647,2.58984l6.06361,0.8811l-4.38756,4.27676
		c-1.11595,1.08755-1.6254,2.65472-1.36168,4.19061l1.03593,6.03851l-5.42349-2.85071
		c-0.68983-0.36267-1.44643-0.54401-2.20302-0.54401s-1.51366,0.18134-2.20302,0.54401l-5.42349,2.85071l1.03593-6.03851
		c0.26372-1.53589-0.24573-3.10306-1.36168-4.19061l-4.38756-4.27676L-178.94273,334.75436z"
                                                            />
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <div className="icon-sb">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="0 0 90 90"
                                                    className="beta-slots Slots"
                                                    width="100%"
                                                    height="100%"
                                                    id=""
                                                    prefix=""
                                                >
                                                    <style
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                "\n.beta-slots .st0{fill:url(#beta-slots-beta-slots-SVGID_1_);}\n  "
                                                        }}
                                                    />
                                                    <g className="beta-slots">
                                                        <g>
                                                            <g>
                                                                <linearGradient
                                                                    id="beta-slots-beta-slots-SVGID_1_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="88.507"
                                                                    y1="44.552"
                                                                    x2="1.4801"
                                                                    y2="40.5721"
                                                                    gradientTransform="matrix(1 0 0 -1 0 92)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    className="st0"
                                                                    d="M71.64,58.76c0-0.98,0.79-1.77,1.77-1.77h5.33c2.33,0,2.74-0.38,2.74-2.56V36.81c0-0.98,0.79-1.77,1.77-1.77
		s1.77,0.79,1.77,1.77v17.62c0,5.46-3.58,6.09-6.27,6.09H73.4C72.43,60.52,71.64,59.73,71.64,58.76z"
                                                                />
                                                                <linearGradient
                                                                    id="beta-slots-beta-slots-SVGID_00000169517958620629952200000015665964861490616505_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="87.7756"
                                                                    y1="60.5463"
                                                                    x2="0.7487"
                                                                    y2="56.5664"
                                                                    gradientTransform="matrix(1 0 0 -1 0 92)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M83.34,26.13c-3.05,0-5.53,2.48-5.53,5.53
		c0,3.05,2.48,5.53,5.53,5.53c3.05,0,5.53-2.48,5.53-5.53C88.87,28.6,86.39,26.13,83.34,26.13z M83.34,34.05
		c-1.32,0-2.39-1.07-2.39-2.39c0-1.32,1.07-2.39,2.39-2.39c1.32,0,2.39,1.07,2.39,2.39C85.73,32.98,84.66,34.05,83.34,34.05z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-slots-beta-slots-SVGID_00000169517958620629952200000015665964861490616505_")'
                                                                    }}
                                                                />
                                                                <g>
                                                                    <linearGradient
                                                                        id="beta-slots-beta-slots-SVGID_00000173850770542799234630000001081627009180235910_"
                                                                        gradientUnits="userSpaceOnUse"
                                                                        x1="88.7716"
                                                                        y1="38.7656"
                                                                        x2="1.7447"
                                                                        y2="34.7857"
                                                                        gradientTransform="matrix(1 0 0 -1 0 92)"
                                                                    >
                                                                        <stop
                                                                            offset={0}
                                                                            style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                        />
                                                                        <stop
                                                                            offset={1}
                                                                            style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                        />
                                                                    </linearGradient>
                                                                    <path
                                                                        d="M11.16,71.1c-0.71,0-1.29-0.58-1.29-1.29
			V43.19c0-0.71,0.58-1.29,1.29-1.29h12.31c0.71,0,1.29,0.58,1.29,1.29v26.63c0,0.71-0.58,1.29-1.29,1.29H11.16z M22.18,68.53V44.48
			h-9.73v24.05H22.18z"
                                                                        style={{
                                                                            fill:
                                                                                'url("#beta-slots-beta-slots-SVGID_00000173850770542799234630000001081627009180235910_")'
                                                                        }}
                                                                    />
                                                                    <linearGradient
                                                                        id="beta-slots-beta-slots-SVGID_00000017485461892262755300000018430666423654382235_"
                                                                        gradientUnits="userSpaceOnUse"
                                                                        x1="88.8572"
                                                                        y1="36.8936"
                                                                        x2="1.8304"
                                                                        y2="32.9137"
                                                                        gradientTransform="matrix(1 0 0 -1 0 92)"
                                                                    >
                                                                        <stop
                                                                            offset={0}
                                                                            style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                        />
                                                                        <stop
                                                                            offset={1}
                                                                            style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                        />
                                                                    </linearGradient>
                                                                    <path
                                                                        d="M52.18,71.1c-0.71,0-1.29-0.58-1.29-1.29
			V43.19c0-0.71,0.58-1.29,1.29-1.29H64.5c0.71,0,1.29,0.58,1.29,1.29v26.63c0,0.71-0.58,1.29-1.29,1.29H52.18z M63.21,68.53V44.48
			h-9.73v24.05H63.21z"
                                                                        style={{
                                                                            fill:
                                                                                'url("#beta-slots-beta-slots-SVGID_00000017485461892262755300000018430666423654382235_")'
                                                                        }}
                                                                    />
                                                                    <linearGradient
                                                                        id="beta-slots-beta-slots-SVGID_00000088835878093914337310000015013027109431268520_"
                                                                        gradientUnits="userSpaceOnUse"
                                                                        x1="88.8145"
                                                                        y1="37.8296"
                                                                        x2="1.7876"
                                                                        y2="33.8497"
                                                                        gradientTransform="matrix(1 0 0 -1 0 92)"
                                                                    >
                                                                        <stop
                                                                            offset={0}
                                                                            style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                        />
                                                                        <stop
                                                                            offset={1}
                                                                            style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                        />
                                                                    </linearGradient>
                                                                    <path
                                                                        d="M31.67,71.1c-0.71,0-1.29-0.58-1.29-1.29
			V43.19c0-0.71,0.58-1.29,1.29-1.29h12.31c0.71,0,1.29,0.58,1.29,1.29v26.63c0,0.71-0.58,1.29-1.29,1.29H31.67z M42.69,68.53V44.48
			h-9.73v24.05H42.69z"
                                                                        style={{
                                                                            fill:
                                                                                'url("#beta-slots-beta-slots-SVGID_00000088835878093914337310000015013027109431268520_")'
                                                                        }}
                                                                    />
                                                                </g>
                                                                <linearGradient
                                                                    id="beta-slots-beta-slots-SVGID_00000118376699708902960880000003829782955986228670_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="88.8145"
                                                                    y1="37.8297"
                                                                    x2="1.7876"
                                                                    y2="33.8498"
                                                                    gradientTransform="matrix(1 0 0 -1 0 92)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M66.78,32.83H8.87
		c-4.27,0-7.74,3.47-7.74,7.74v31.87c0,4.27,3.47,7.74,7.74,7.74h57.92c4.27,0,7.74-3.47,7.74-7.74V40.57
		C74.52,36.3,71.05,32.83,66.78,32.83z M70.91,72.43c0,2.28-1.85,4.13-4.13,4.13H8.87c-2.22,0-4.13-1.81-4.13-3.28l0-32.71
		c0-2.28,1.85-4.13,4.13-4.13h57.92c2.22,0,4.13,1.81,4.13,3.28L70.91,72.43z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-slots-beta-slots-SVGID_00000118376699708902960880000003829782955986228670_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-slots-beta-slots-SVGID_00000083799526354324608230000002627638455071495296_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="86.9004"
                                                                    y1="79.684"
                                                                    x2="-0.1281"
                                                                    y2="75.704"
                                                                    gradientTransform="matrix(1 0 0 -1 0 92)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M37.89,19.29c-0.81,0-1.47-0.66-1.47-1.46
		v-6.53c0-0.81,0.66-1.47,1.47-1.47c0.81,0,1.46,0.66,1.46,1.47v6.53C39.36,18.63,38.7,19.29,37.89,19.29z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-slots-beta-slots-SVGID_00000083799526354324608230000002627638455071495296_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-slots-beta-slots-SVGID_00000094614397226565652770000005965467049322747299_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="87.1884"
                                                                    y1="73.387"
                                                                    x2="0.1615"
                                                                    y2="69.4071"
                                                                    gradientTransform="matrix(1 0 0 -1 0 92)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M19.55,24.79c-0.39,0-0.76-0.15-1.04-0.43
		l-3.04-3.1c-0.28-0.28-0.43-0.64-0.43-1.04c0-0.39,0.15-0.76,0.43-1.04c0.28-0.28,0.64-0.43,1.04-0.43c0.39,0,0.76,0.15,1.04,0.43
		l3.04,3.1c0.28,0.27,0.43,0.64,0.43,1.04c0,0.39-0.15,0.76-0.43,1.04C20.31,24.64,19.94,24.79,19.55,24.79z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-slots-beta-slots-SVGID_00000094614397226565652770000005965467049322747299_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-slots-beta-slots-SVGID_00000046314199686022797410000007711550502111852201_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="87.2713"
                                                                    y1="71.5739"
                                                                    x2="0.2444"
                                                                    y2="67.5941"
                                                                    gradientTransform="matrix(1 0 0 -1 0 92)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M56.23,24.79c0.39,0,0.76-0.15,1.04-0.43
		l3.04-3.1c0.28-0.28,0.43-0.64,0.43-1.04c0-0.39-0.15-0.76-0.43-1.04c-0.28-0.28-0.64-0.43-1.04-0.43c-0.39,0-0.76,0.15-1.04,0.43
		l-3.04,3.1c-0.28,0.27-0.43,0.64-0.43,1.04c0,0.39,0.15,0.76,0.43,1.04C55.47,24.64,55.84,24.79,56.23,24.79z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-slots-beta-slots-SVGID_00000046314199686022797410000007711550502111852201_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-slots-beta-slots-SVGID_00000092422750877843829720000012627139923115244699_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="86.9605"
                                                                    y1="78.3695"
                                                                    x2="-0.0664"
                                                                    y2="74.3896"
                                                                    gradientTransform="matrix(1 0 0 -1 0 92)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M28.55,20.78c-0.57,0-1.09-0.33-1.33-0.84
		l-2.79-5.9c-0.17-0.35-0.19-0.75-0.06-1.12c0.13-0.37,0.4-0.66,0.76-0.83c0.19-0.09,0.4-0.14,0.62-0.14c0.57,0,1.09,0.33,1.33,0.84
		l2.79,5.9c0.17,0.35,0.19,0.75,0.06,1.12c-0.13,0.37-0.4,0.66-0.75,0.83C28.98,20.74,28.77,20.78,28.55,20.78z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-slots-beta-slots-SVGID_00000092422750877843829720000012627139923115244699_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-slots-beta-slots-SVGID_00000161631842688056995690000006590157662493396363_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="87.0045"
                                                                    y1="77.4081"
                                                                    x2="-0.0224"
                                                                    y2="73.4282"
                                                                    gradientTransform="matrix(1 0 0 -1 0 92)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M46.82,20.78c-0.22,0-0.43-0.05-0.62-0.14
		c-0.73-0.34-1.04-1.22-0.7-1.95l2.79-5.9c0.24-0.51,0.76-0.84,1.33-0.84c0.22,0,0.43,0.05,0.63,0.14c0.35,0.17,0.62,0.46,0.75,0.83
		c0.13,0.37,0.11,0.77-0.06,1.12l-2.79,5.9C47.9,20.45,47.38,20.78,46.82,20.78z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-slots-beta-slots-SVGID_00000161631842688056995690000006590157662493396363_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-slots-beta-slots-SVGID_00000111186739555141609810000006829536037106863234_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="87.6157"
                                                                    y1="64.0427"
                                                                    x2="0.5888"
                                                                    y2="60.0628"
                                                                    gradientTransform="matrix(1 0 0 -1 0 92)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M63.51,35.51H12.28l1.8-2.25
		c4.66-5.82,13.79-9.44,23.82-9.44s19.16,3.62,23.82,9.44L63.51,35.51z M18.44,32.74h38.9c-4.52-3.85-11.66-6.15-19.45-6.15
		S22.96,28.9,18.44,32.74z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-slots-beta-slots-SVGID_00000111186739555141609810000006829536037106863234_")'
                                                                    }}
                                                                />
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <p className="sb-name">สล็อต</p>
                                        </div>
                                        <div className="menu middle" style={{ cursor: 'pointer' }} onClick={(e) => { this.setState({ isMenuOpen: false }); this.checkurl(e, '/'); }}>
                                            <div className="icon-star-container">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="-217.66559 292.71454 90 90"
                                                    className="star-border-icon icon-border-star"
                                                    width="100%"
                                                    height="100%"
                                                    id=""
                                                    prefix=""
                                                >
                                                    <style
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                "\n.star-border-icon .st0{fill:#E0092C;}\n                .star-border-icon .st1{fill:#FFFFFF;}\n  "
                                                        }}
                                                    />
                                                    <g className="star-border-icon">
                                                        <g>
                                                            <circle
                                                                className="st0"
                                                                cx="-172.66559"
                                                                cy="337.71454"
                                                                r={40}
                                                            />
                                                            <path
                                                                className="st1"
                                                                d="M-189.01041,344.95557l-2.23663,13.04053c-0.30492,1.77597,0.42516,3.57132,1.88342,4.63092
		c1.45827,1.05914,3.39093,1.19928,4.98602,0.36032l11.71153-6.15689l11.71153,6.15689
		c0.69267,0.36407,1.44926,0.54352,2.20255,0.54352c0.98148,0,1.95869-0.3049,2.78348-0.9043
		c1.45825-1.05914,2.18832-2.85452,1.88342-4.63095l-2.23663-13.04053l9.4749-9.23581
		c1.29065-1.25797,1.75513-3.13953,1.19833-4.85345s-2.03873-2.96292-3.82225-3.22238l-13.09357-1.90283l-5.85576-11.86493
		c-0.79779-1.61591-2.44354-2.63907-4.24553-2.63907s-3.44821,1.02316-4.24553,2.63907l-5.85576,11.86493l-13.09357,1.90283
		c-1.78352,0.259-3.26498,1.50845-3.82225,3.22238c-0.55679,1.71393-0.09233,3.59549,1.19833,4.85345L-189.01041,344.95557z
		 M-178.94273,334.75436c1.54205-0.22394,2.87532-1.19266,3.56468-2.58984l2.71199-5.49451l2.71198,5.49451
		c0.68983,1.39719,2.02263,2.36591,3.5647,2.58984l6.06361,0.8811l-4.38756,4.27676
		c-1.11595,1.08755-1.6254,2.65472-1.36168,4.19061l1.03593,6.03851l-5.42349-2.85071
		c-0.68983-0.36267-1.44643-0.54401-2.20302-0.54401s-1.51366,0.18134-2.20302,0.54401l-5.42349,2.85071l1.03593-6.03851
		c0.26372-1.53589-0.24573-3.10306-1.36168-4.19061l-4.38756-4.27676L-178.94273,334.75436z"
                                                            />
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <div className="icon-sb">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="0 0 90 90"
                                                    className="beta-fishing Fishing"
                                                    width="100%"
                                                    height="100%"
                                                    id=""
                                                    prefix=""
                                                >
                                                    <style
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                "\n.beta-fishing .st0{fill:url(#beta-fishing-beta-fishing-SVGID_1_);}\n  "
                                                        }}
                                                    />
                                                    <g className="beta-fishing">
                                                        <g>
                                                            <g>
                                                                <linearGradient
                                                                    id="beta-fishing-beta-fishing-SVGID_1_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="87.4743"
                                                                    y1="-331.437"
                                                                    x2="1.383"
                                                                    y2="-334.4339"
                                                                    gradientTransform="matrix(1 0 0 -1 0 -288)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    className="st0"
                                                                    d="M42.97,73.91c-1.85,0-3.81-0.11-5.84-0.34c-0.94-0.11-1.65-0.9-1.65-1.84V60.85l-0.25-0.13
		c-0.36-0.19-0.86-0.43-1.47-0.72c-1.86-0.9-4.67-2.25-8.14-4.29l-0.43-0.25c-1.63-0.96-4.36-2.56-6.3-4.01l-0.37-0.27l-0.28,0.36
		c-0.18,0.24-0.36,0.47-0.56,0.71c-3.67,4.4-8.53,6.73-14.06,6.73c-0.85,0-1.59-0.58-1.79-1.4c-0.08-0.3-1.78-7.37,2.65-12.27
		L4.77,45l-0.28-0.31c-4.43-4.9-2.73-11.97-2.65-12.27c0.2-0.83,0.95-1.4,1.79-1.4c5.53,0,10.39,2.33,14.06,6.73
		c0.83,0.99,1.59,2.08,2.26,3.24l0.33,0.57l0.43-0.5c1.38-1.64,3.67-4.11,6.7-6.59c2.2-1.8,4.53-3.38,6.91-4.7l0.24-0.13V18.28
		c0-0.95,0.71-1.74,1.65-1.84c2.09-0.23,4.11-0.35,6.03-0.35c15.32,0,21.38,7.29,23.28,10.43l0.1,0.16l0.18,0.05
		c5.65,1.59,10.63,4.21,14.78,7.77c5.51,4.72,7.73,9.55,7.82,9.75c0.21,0.48,0.21,1.03,0,1.5c-0.09,0.2-2.28,5.01-7.82,9.75
		c-4.1,3.51-8.99,6.11-14.55,7.71l-0.18,0.05l-0.09,0.17C64.38,65.89,58.69,73.91,42.97,73.91z M39.19,70.04l0.43,0.03
		c1.14,0.08,2.27,0.13,3.35,0.13c8.51,0,13.5-2.56,16.18-4.71l1.25-1.01l-1.8,0.2c-0.4,0.05-0.83,0.09-1.26,0.13l-0.51,0.04
		c-0.32,0.03-0.65,0.05-0.97,0.07l-0.53,0.03c-0.34,0.02-0.69,0.03-1.04,0.04l-0.46,0.02c-0.5,0.01-1,0.02-1.51,0.02
		c-0.27,0-0.54,0-0.82-0.01c-3.95-0.09-7.89-0.85-11.7-2.27l-0.62-0.23C39.19,62.54,39.19,70.04,39.19,70.04z M52.33,28.66
		c-0.31,0-0.62,0.01-0.93,0.02l-0.92,0.04l-0.91,0.07l-0.4,0.04l-0.5,0.05l-1.02,0.14l-0.33,0.05l-0.91,0.16l-0.25,0.05
		C30.04,32.46,20.5,48,20.5,48l0.3,0.23c1.35,1.05,4.4,3.02,7.26,4.68c3.98,2.32,6.93,3.68,8.69,4.49c0.46,0.21,0.85,0.39,1.16,0.54
		c0.11,0.04,0.16,0.06,0.22,0.09c3.99,1.91,8.14,3,12.33,3.25l1.02,0.04c0.28,0.01,0.57,0.01,0.85,0.01c0.45,0,0.89-0.01,1.34-0.02
		l0.3-0.01c0.45-0.01,0.89-0.03,1.32-0.06c0.49-0.03,0.9-0.06,1.3-0.09l0.29-0.02c0.41-0.04,0.81-0.08,1.2-0.12l0.36-0.04
		c0.28-0.03,0.56-0.07,0.83-0.11c0.23-0.03,0.46-0.07,0.69-0.1c0.23-0.04,0.46-0.07,0.69-0.11c0.25-0.04,0.49-0.09,0.74-0.13
		c14.92-2.89,21.44-12.43,23.09-15.28L84.62,45l-0.13-0.23c-0.89-1.55-2.93-4.6-6.5-7.62c-3.95-3.33-8.63-5.72-13.91-7.09l-0.1-0.02
		c-3.18-0.81-6.53-1.26-10.04-1.37l-0.2-0.01C53.27,28.66,52.8,28.66,52.33,28.66z M5.17,35.29c-0.11,2.09,0.2,5.94,3.53,8.16
		C9.22,43.8,9.52,44.38,9.52,45c0,0.62-0.31,1.2-0.82,1.54c-3.33,2.22-3.64,6.07-3.53,8.16l0.02,0.5l0.5-0.07
		c7.63-1.06,11.15-7.89,12.05-9.96L17.82,45l-0.08-0.18c-0.88-2.07-4.37-8.9-12.05-9.95l-0.5-0.07L5.17,35.29z M42.28,19.8
		c-1.15,0-2.36,0.04-3.58,0.14l-0.43,0.03v7.87l0.64-0.25c3.84-1.53,7.81-2.41,11.8-2.59c0.3-0.01,0.55-0.02,0.8-0.03
		c0.28-0.01,0.55-0.01,0.83-0.01c0.48,0,0.96,0.01,1.43,0.02l0.48,0.02c0.31,0.01,0.62,0.02,0.93,0.04l0.59,0.03
		c0.26,0.01,0.51,0.03,0.76,0.05l0.68,0.06l1.15,0.11l1.67,0.19l-1.34-1.02c-0.19-0.14-0.38-0.29-0.58-0.43
		C54.1,21.22,48.78,19.8,42.28,19.8z"
                                                                />
                                                                <linearGradient
                                                                    id="beta-fishing-beta-fishing-SVGID_00000179646454866750413840000005661850431240055449_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="87.4973"
                                                                    y1="-332.1"
                                                                    x2="1.4061"
                                                                    y2="-335.0969"
                                                                    gradientTransform="matrix(1 0 0 -1 0 -288)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M61.68,33.57c-0.3,0-0.6,0.07-0.87,0.22
		c-4.17,2.2-6.75,6.5-6.75,11.21c0,4.71,2.59,9.01,6.75,11.21c0.27,0.14,0.56,0.22,0.87,0.22c0.69,0,1.32-0.38,1.64-0.99
		c0.48-0.9,0.13-2.03-0.77-2.51c-2.95-1.56-4.78-4.6-4.78-7.93c0-3.33,1.83-6.38,4.78-7.94c0.9-0.48,1.25-1.6,0.77-2.5
		C63,33.95,62.37,33.57,61.68,33.57z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-fishing-beta-fishing-SVGID_00000179646454866750413840000005661850431240055449_")'
                                                                    }}
                                                                />
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <p className="sb-name">ยิงปลา</p>
                                        </div>
                                        <div className="menu " style={{ cursor: 'pointer' }} onClick={(e) => { this.setState({ isMenuOpen: false }); this.checkurl(e, '/'); }}>
                                            <div className="icon-sb">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="0 0 90 90"
                                                    className="beta-lottery Lottery"
                                                    width="100%"
                                                    height="100%"
                                                    id=""
                                                    prefix=""
                                                >
                                                    <style
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                "\n.beta-lottery .st0{fill:url(#beta-lottery-beta-lottery-SVGID_1_);}\n  "
                                                        }}
                                                    />
                                                    <g className="beta-lottery">
                                                        <g>
                                                            <g>
                                                                <linearGradient
                                                                    id="beta-lottery-beta-lottery-SVGID_1_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="81.6684"
                                                                    y1="-545.5282"
                                                                    x2="6.8557"
                                                                    y2="-543.5278"
                                                                    gradientTransform="matrix(1 0 0 -1 0 -478)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    className="st0"
                                                                    d="M55.71,66.73c0,2.07-1.68,3.74-3.74,3.74c-2.07,0-3.74-1.68-3.74-3.74c0-2.07,1.68-3.74,3.74-3.74
		C54.04,62.99,55.71,64.67,55.71,66.73z"
                                                                />
                                                                <linearGradient
                                                                    id="beta-lottery-beta-lottery-SVGID_00000048482826439958193200000008887290879379960226_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="82.0221"
                                                                    y1="-532.2986"
                                                                    x2="7.2094"
                                                                    y2="-530.2983"
                                                                    gradientTransform="matrix(1 0 0 -1 0 -478)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M73.83,53.98c0,2.07-1.68,3.74-3.74,3.74
		c-2.07,0-3.74-1.68-3.74-3.74c0-2.07,1.68-3.74,3.74-3.74C72.16,50.24,73.83,51.91,73.83,53.98z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-lottery-beta-lottery-SVGID_00000048482826439958193200000008887290879379960226_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-lottery-beta-lottery-SVGID_00000053524131805163110080000003248410569237322373_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="82.4977"
                                                                    y1="-514.5124"
                                                                    x2="7.685"
                                                                    y2="-512.512"
                                                                    gradientTransform="matrix(1 0 0 -1 0 -478)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M29.64,35c0,2.07-1.68,3.74-3.74,3.74
		c-2.07,0-3.74-1.68-3.74-3.74c0-2.07,1.68-3.74,3.74-3.74C27.97,31.25,29.64,32.93,29.64,35z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-lottery-beta-lottery-SVGID_00000053524131805163110080000003248410569237322373_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-lottery-beta-lottery-SVGID_00000023964601972657153550000003841365058239215796_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="82.0519"
                                                                    y1="-531.1874"
                                                                    x2="7.2391"
                                                                    y2="-529.1871"
                                                                    gradientTransform="matrix(1 0 0 -1 0 -478)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M24.63,51.55c0,2.07-1.68,3.74-3.74,3.74
		c-2.07,0-3.74-1.68-3.74-3.74c0-2.07,1.68-3.74,3.74-3.74C22.95,47.81,24.63,49.48,24.63,51.55z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-lottery-beta-lottery-SVGID_00000023964601972657153550000003841365058239215796_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-lottery-beta-lottery-SVGID_00000156578227470561760000000017065998931139289263_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="82.2012"
                                                                    y1="-525.5999"
                                                                    x2="7.3885"
                                                                    y2="-523.5996"
                                                                    gradientTransform="matrix(1 0 0 -1 0 -478)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M64.25,47.02c0,2.07-1.68,3.74-3.74,3.74
		c-2.07,0-3.74-1.68-3.74-3.74c0-2.07,1.68-3.74,3.74-3.74C62.58,43.28,64.25,44.95,64.25,47.02z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-lottery-beta-lottery-SVGID_00000156578227470561760000000017065998931139289263_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-lottery-beta-lottery-SVGID_00000132066250688214534330000015097999761497121215_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="81.8848"
                                                                    y1="-537.4346"
                                                                    x2="7.0721"
                                                                    y2="-535.4343"
                                                                    gradientTransform="matrix(1 0 0 -1 0 -478)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M45.27,58.36c0,2.07-1.68,3.74-3.74,3.74
		c-2.07,0-3.74-1.68-3.74-3.74c0-2.07,1.68-3.74,3.74-3.74C43.59,54.61,45.27,56.29,45.27,58.36z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-lottery-beta-lottery-SVGID_00000132066250688214534330000015097999761497121215_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-lottery-beta-lottery-SVGID_00000081606552114926102900000001694534242136757673_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="82.3225"
                                                                    y1="-521.0648"
                                                                    x2="7.5098"
                                                                    y2="-519.0645"
                                                                    gradientTransform="matrix(1 0 0 -1 0 -478)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M75.41,42.78c0,2.07-1.68,3.74-3.74,3.74
		c-2.07,0-3.74-1.68-3.74-3.74c0-2.07,1.68-3.74,3.74-3.74C73.73,39.04,75.41,40.71,75.41,42.78z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-lottery-beta-lottery-SVGID_00000081606552114926102900000001694534242136757673_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-lottery-beta-lottery-SVGID_00000035498259613798394730000004176824981660093346_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="82.9128"
                                                                    y1="-498.9898"
                                                                    x2="8.1"
                                                                    y2="-496.9895"
                                                                    gradientTransform="matrix(1 0 0 -1 0 -478)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M59.46,20.26c0,2.07-1.68,3.74-3.74,3.74
		c-2.07,0-3.74-1.68-3.74-3.74c0-2.07,1.68-3.74,3.74-3.74C57.78,16.52,59.46,18.2,59.46,20.26z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-lottery-beta-lottery-SVGID_00000035498259613798394730000004176824981660093346_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-lottery-beta-lottery-SVGID_00000059307330503801824540000008813884520079550350_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="82.3883"
                                                                    y1="-518.6057"
                                                                    x2="7.5756"
                                                                    y2="-516.6053"
                                                                    gradientTransform="matrix(1 0 0 -1 0 -478)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M45,46.91c-4.03,0-7.31-3.28-7.31-7.31
		c0-4.03,3.28-7.31,7.31-7.31s7.31,3.28,7.31,7.31C52.31,43.64,49.03,46.91,45,46.91z M45,35.43c-2.3,0-4.17,1.87-4.17,4.17
		s1.87,4.17,4.17,4.17s4.17-1.87,4.17-4.17S47.3,35.43,45,35.43z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-lottery-beta-lottery-SVGID_00000059307330503801824540000008813884520079550350_")'
                                                                    }}
                                                                />
                                                                <g>
                                                                    <g>
                                                                        <linearGradient
                                                                            id="beta-lottery-beta-lottery-SVGID_00000069390598560889844870000006724200367987270823_"
                                                                            gradientUnits="userSpaceOnUse"
                                                                            x1="81.8745"
                                                                            y1="-537.823"
                                                                            x2="7.0617"
                                                                            y2="-535.8227"
                                                                            gradientTransform="matrix(1 0 0 -1 0 -478)"
                                                                        >
                                                                            <stop
                                                                                offset={0}
                                                                                style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                            />
                                                                            <stop
                                                                                offset={1}
                                                                                style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                            />
                                                                        </linearGradient>
                                                                        <path
                                                                            d="M14.77,78.23c-0.3,0-0.6-0.09-0.87-0.26
				c-0.72-0.48-0.92-1.45-0.43-2.17l24.36-36.62c0.48-0.73,1.45-0.92,2.17-0.44c0.72,0.48,0.92,1.45,0.43,2.17L16.07,77.53
				C15.77,77.99,15.27,78.23,14.77,78.23z"
                                                                            style={{
                                                                                fill:
                                                                                    'url("#beta-lottery-beta-lottery-SVGID_00000069390598560889844870000006724200367987270823_")'
                                                                            }}
                                                                        />
                                                                        <linearGradient
                                                                            id="beta-lottery-beta-lottery-SVGID_00000119112780881541077990000016346508484161247150_"
                                                                            gradientUnits="userSpaceOnUse"
                                                                            x1="81.8118"
                                                                            y1="-540.1638"
                                                                            x2="6.9991"
                                                                            y2="-538.1635"
                                                                            gradientTransform="matrix(1 0 0 -1 0 -478)"
                                                                        >
                                                                            <stop
                                                                                offset={0}
                                                                                style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                            />
                                                                            <stop
                                                                                offset={1}
                                                                                style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                            />
                                                                        </linearGradient>
                                                                        <path
                                                                            d="M22.32,78.23
				c-0.29,0-0.59-0.08-0.86-0.25c-0.73-0.47-0.93-1.44-0.46-2.17l20.65-31.63c0.47-0.72,1.45-0.92,2.17-0.45
				c0.73,0.47,0.93,1.44,0.46,2.17L23.63,77.52C23.33,77.98,22.83,78.23,22.32,78.23z"
                                                                            style={{
                                                                                fill:
                                                                                    'url("#beta-lottery-beta-lottery-SVGID_00000119112780881541077990000016346508484161247150_")'
                                                                            }}
                                                                        />
                                                                        <linearGradient
                                                                            id="beta-lottery-beta-lottery-SVGID_00000174581883619670280130000008588797701268654758_"
                                                                            gradientUnits="userSpaceOnUse"
                                                                            x1="81.2865"
                                                                            y1="-559.8113"
                                                                            x2="6.4738"
                                                                            y2="-557.811"
                                                                            gradientTransform="matrix(1 0 0 -1 0 -478)"
                                                                        >
                                                                            <stop
                                                                                offset={0}
                                                                                style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                            />
                                                                            <stop
                                                                                offset={1}
                                                                                style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                            />
                                                                        </linearGradient>
                                                                        <path
                                                                            d="M24.18,85.16H12.5
				c-2.77,0-5.03-2.26-5.03-5.03c0-2.77,2.26-5.03,5.03-5.03h11.68c2.77,0,5.03,2.26,5.03,5.03C29.21,82.9,26.95,85.16,24.18,85.16z
				 M12.5,78.23c-1.04,0-1.89,0.85-1.89,1.89c0,1.05,0.85,1.9,1.89,1.9h11.68c1.04,0,1.89-0.85,1.89-1.9c0-1.04-0.85-1.89-1.89-1.89
				H12.5z"
                                                                            style={{
                                                                                fill:
                                                                                    'url("#beta-lottery-beta-lottery-SVGID_00000174581883619670280130000008588797701268654758_")'
                                                                            }}
                                                                        />
                                                                    </g>
                                                                    <g>
                                                                        <linearGradient
                                                                            id="beta-lottery-beta-lottery-SVGID_00000085236944793413419670000017056059005411063697_"
                                                                            gradientUnits="userSpaceOnUse"
                                                                            x1="81.9002"
                                                                            y1="-536.858"
                                                                            x2="7.0875"
                                                                            y2="-534.8577"
                                                                            gradientTransform="matrix(1 0 0 -1 0 -478)"
                                                                        >
                                                                            <stop
                                                                                offset={0}
                                                                                style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                            />
                                                                            <stop
                                                                                offset={1}
                                                                                style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                            />
                                                                        </linearGradient>
                                                                        <path
                                                                            d="M75.23,78.23c-0.5,0-1-0.24-1.3-0.7
				L49.57,40.91c-0.48-0.72-0.28-1.69,0.43-2.17c0.72-0.48,1.7-0.29,2.17,0.44L76.54,75.8c0.48,0.72,0.28,1.7-0.43,2.17
				C75.83,78.15,75.53,78.23,75.23,78.23z"
                                                                            style={{
                                                                                fill:
                                                                                    'url("#beta-lottery-beta-lottery-SVGID_00000085236944793413419670000017056059005411063697_")'
                                                                            }}
                                                                        />
                                                                        <linearGradient
                                                                            id="beta-lottery-beta-lottery-SVGID_00000129910757956017329580000017900895015019016891_"
                                                                            gradientUnits="userSpaceOnUse"
                                                                            x1="81.8295"
                                                                            y1="-539.5032"
                                                                            x2="7.0168"
                                                                            y2="-537.5029"
                                                                            gradientTransform="matrix(1 0 0 -1 0 -478)"
                                                                        >
                                                                            <stop
                                                                                offset={0}
                                                                                style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                            />
                                                                            <stop
                                                                                offset={1}
                                                                                style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                            />
                                                                        </linearGradient>
                                                                        <path
                                                                            d="M67.68,78.23
				c-0.51,0-1.01-0.25-1.31-0.71L45.71,45.89c-0.47-0.73-0.27-1.7,0.46-2.17c0.72-0.47,1.7-0.27,2.17,0.45l20.66,31.63
				c0.47,0.73,0.27,1.7-0.46,2.17C68.28,78.15,67.98,78.23,67.68,78.23z"
                                                                            style={{
                                                                                fill:
                                                                                    'url("#beta-lottery-beta-lottery-SVGID_00000129910757956017329580000017900895015019016891_")'
                                                                            }}
                                                                        />
                                                                        <linearGradient
                                                                            id="beta-lottery-beta-lottery-SVGID_00000122697254249977193720000003472746197799008427_"
                                                                            gradientUnits="userSpaceOnUse"
                                                                            x1="81.3246"
                                                                            y1="-558.3865"
                                                                            x2="6.5119"
                                                                            y2="-556.3862"
                                                                            gradientTransform="matrix(1 0 0 -1 0 -478)"
                                                                        >
                                                                            <stop
                                                                                offset={0}
                                                                                style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                            />
                                                                            <stop
                                                                                offset={1}
                                                                                style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                            />
                                                                        </linearGradient>
                                                                        <path
                                                                            d="M77.51,85.16H65.82
				c-2.77,0-5.03-2.26-5.03-5.03c0-2.77,2.26-5.03,5.03-5.03h11.68c2.77,0,5.03,2.26,5.03,5.03C82.53,82.9,80.28,85.16,77.51,85.16z
				 M65.82,78.23c-1.04,0-1.89,0.85-1.89,1.89c0,1.05,0.85,1.9,1.89,1.9h11.68c1.04,0,1.89-0.85,1.89-1.9
				c0-1.04-0.85-1.89-1.89-1.89H65.82z"
                                                                            style={{
                                                                                fill:
                                                                                    'url("#beta-lottery-beta-lottery-SVGID_00000122697254249977193720000003472746197799008427_")'
                                                                            }}
                                                                        />
                                                                    </g>
                                                                </g>
                                                                <linearGradient
                                                                    id="beta-lottery-beta-lottery-SVGID_00000046299376215152253890000012069345275087221124_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="82.5041"
                                                                    y1="-514.2748"
                                                                    x2="7.6914"
                                                                    y2="-512.2744"
                                                                    gradientTransform="matrix(1 0 0 -1 0 -478)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M22.78,65.5c-0.5,0-0.99-0.19-1.36-0.58
		L9.47,52.45c-0.33-0.35-0.52-0.82-0.52-1.3V26.31c0-0.5,0.2-0.97,0.54-1.33L28.97,5.4c0.36-0.36,0.83-0.56,1.33-0.56h29.4
		c0.5,0,0.98,0.2,1.33,0.56l19.44,19.59c0.35,0.35,0.54,0.83,0.54,1.33v24.83c0,0.48-0.18,0.95-0.52,1.3L68.68,64.85
		c-0.72,0.75-1.91,0.78-2.66,0.06c-0.75-0.72-0.78-1.91-0.06-2.66l11.31-11.87v-23.3L58.92,8.6H31.09L12.71,27.09v23.3l11.43,11.93
		c0.72,0.75,0.69,1.94-0.06,2.66C23.72,65.33,23.25,65.5,22.78,65.5z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-lottery-beta-lottery-SVGID_00000046299376215152253890000012069345275087221124_")'
                                                                    }}
                                                                />
                                                                <linearGradient
                                                                    id="beta-lottery-beta-lottery-SVGID_00000037654783362258426890000001904125096283214466_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="81.5843"
                                                                    y1="-548.6761"
                                                                    x2="6.7715"
                                                                    y2="-546.6757"
                                                                    gradientTransform="matrix(1 0 0 -1 0 -478)"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    d="M59.7,72.61H30.3
		c-0.48,0-0.94-0.18-1.29-0.51l-2.26-2.12c-0.76-0.71-0.79-1.9-0.08-2.66c0.71-0.76,1.9-0.8,2.66-0.08l1.71,1.61h27.9l1.59-1.5
		c0.75-0.71,1.94-0.68,2.66,0.08c0.71,0.75,0.68,1.94-0.08,2.66l-2.14,2.01C60.64,72.43,60.18,72.61,59.7,72.61z"
                                                                    style={{
                                                                        fill:
                                                                            'url("#beta-lottery-beta-lottery-SVGID_00000037654783362258426890000001904125096283214466_")'
                                                                    }}
                                                                />
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <p className="sb-name">ล็อตเตอรี่</p>
                                        </div>
                                        <div className="menu " style={{ cursor: 'pointer' }} onClick={(e) => { this.setState({ isMenuOpen: false }); this.checkurl(e, '/'); }}>
                                            <div className="icon-sb">
                                                <svg
                                                    width={100}
                                                    height={100}
                                                    viewBox="0 0 26 29"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <g>
                                                        <path
                                                            classname="st0"
                                                            d="M15.7995 1.12778C21.2352 2.61714 25 7.57459 25 13.2767L25.0211 13.2874C25.0211 18.3193 22.0812 22.8299 17.5127 24.8405L18.2001 26.5214C18.3376 26.8618 18.3058 27.2342 18.1049 27.532C17.904 27.8299 17.5761 28.0108 17.2166 28.0108H7.81514C7.45558 28.0108 7.12775 27.8299 6.92682 27.532C6.72589 27.2342 6.68359 26.8512 6.82107 26.5214L7.50846 24.8299C2.93993 22.8193 0 18.3086 0 13.2767C0 7.56395 3.7648 2.61714 9.18993 1.12778C9.09475 0.893739 9.1159 0.63842 9.24281 0.415016C9.39086 0.159697 9.65524 0.0107604 9.95135 0.0107604H15.0381C15.3342 0.0107604 15.5986 0.159697 15.7466 0.415016C15.8735 0.63842 15.8947 0.893739 15.7995 1.12778ZM13.97 1.22353H11.0406C10.8714 1.22353 10.7657 1.40438 10.8503 1.55331L12.3202 4.11714C12.3942 4.26608 12.6058 4.26608 12.6904 4.11714L14.1603 1.55331C14.2449 1.40438 14.1392 1.22353 13.97 1.22353ZM16.3917 26.4895C16.4552 26.4895 16.4975 26.4363 16.4975 26.4363V26.4469C16.508 26.4257 16.5292 26.3831 16.508 26.3299L16.1062 25.3512C15.2602 25.6065 14.3824 25.7661 13.4941 25.8405C12.775 25.8937 12.1827 25.8831 11.5588 25.8405C10.6282 25.7661 9.75042 25.5959 8.9044 25.3405L8.50254 26.3193C8.48139 26.3725 8.50254 26.415 8.51311 26.4363C8.53426 26.4576 8.56599 26.4895 8.61887 26.4895H16.3917ZM16.0956 23.7554C17.4598 23.2767 18.6865 22.564 19.7441 21.6278L13.7479 15.5852C14.192 15.3405 14.5516 14.9788 14.7948 14.532L20.791 20.5746C22.3773 18.7448 23.3291 16.4363 23.4877 14.0214H14.9958C15.0592 13.7874 15.1121 13.532 15.1121 13.2767C15.1121 13.0214 15.0698 12.7661 14.9958 12.532H23.4877C23.3291 10.1171 22.3773 7.80863 20.791 5.97885L14.7948 12.0214C14.5516 11.5746 14.192 11.2129 13.7479 10.9682L19.7441 4.92565C18.401 3.7448 16.783 2.90438 15.0381 2.48948L13.2403 5.62778V10.7661C13.0076 10.7022 12.7538 10.6491 12.5 10.6491C12.2462 10.6491 11.9924 10.6916 11.7597 10.7661V5.62778L9.96193 2.48948C8.217 2.90438 6.59898 3.7448 5.25592 4.92565L11.2521 10.9682C10.808 11.2129 10.4484 11.5746 10.2052 12.0214L4.20897 5.97885C2.62267 7.80863 1.6709 10.1171 1.51227 12.532H10.0148C9.95135 12.7661 9.89848 13.0214 9.89848 13.2767C9.89848 13.532 9.94078 13.7874 10.0148 14.0214H1.52284C1.68147 16.4363 2.63325 18.7448 4.21954 20.5746L10.2157 14.532C10.459 14.9788 10.8185 15.3405 11.2627 15.5852L5.2665 21.6278C6.32403 22.564 7.55076 23.2874 8.91497 23.7554C9.0736 23.8193 9.23223 23.8725 9.40144 23.915C9.57064 23.9682 9.73985 24.0108 9.90905 24.0533C9.96722 24.064 10.0227 24.0773 10.0783 24.0905C10.1338 24.1038 10.1893 24.1171 10.2475 24.1278C10.3203 24.1411 10.3931 24.1555 10.4662 24.1699C10.6267 24.2015 10.7889 24.2335 10.956 24.2554L11.0935 24.2767C11.1795 24.2846 11.2641 24.2939 11.3473 24.3031C11.4889 24.3187 11.6264 24.3338 11.7597 24.3405V15.798C11.9924 15.8618 12.2462 15.915 12.5 15.915C12.7538 15.915 13.0076 15.8725 13.2403 15.798V24.3405C13.3108 24.3335 13.3813 24.3275 13.4518 24.3216C13.5928 24.3098 13.7338 24.298 13.8748 24.2767L14.0334 24.2554C14.2766 24.2235 14.5093 24.181 14.742 24.1278C14.8583 24.1065 14.9746 24.0852 15.0909 24.0533C15.2602 24.0108 15.4188 23.9682 15.588 23.915L16.0956 23.7554ZM12.5 11.8618C11.728 11.8618 11.1041 12.5001 11.1041 13.2767C11.1041 14.064 11.728 14.6916 12.5 14.6916C13.272 14.6916 13.8959 14.064 13.8959 13.2767C13.8959 12.4895 13.272 11.8618 12.5 11.8618Z"
                                                            fill="url(#paint0_linear_310_23)"
                                                        />
                                                        <defs xmlns="http://www.w3.org/2000/svg">
                                                            <linearGradient
                                                                id="paint0_linear_310_23"
                                                                x1={0}
                                                                y1="28.0107"
                                                                x2={25}
                                                                y2="28.0107"
                                                                gradientUnits="userSpaceOnUse"
                                                            >
                                                                <stop stopColor="#0A5EBD" />
                                                                <stop offset={1} stopColor="#05A8C2" />
                                                            </linearGradient>
                                                        </defs>
                                                    </g>
                                                </svg>
                                            </div>
                                            <p className="sb-name">วงล้อนำโชค</p>
                                        </div>
                                        <div className="menu" style={{ cursor: 'pointer' }} onClick={(e) => { this.setState({ isMenuOpen: false }); this.checkurl(e, '/'); }}>
                                            <div className="icon-sb">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    viewBox="0 0 23.2611 23.2611"
                                                    className="beta-more More"
                                                    width="100%"
                                                    height="100%"
                                                    id=""
                                                    prefix=""
                                                >
                                                    <style
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                "\n.beta-more .st0{fill:url(#beta-more-SVGID_1_);}\n\t .beta-more .st1{fill:url(#beta-more-SVGID_2_);}\n\t .beta-more .st2{fill:url(#beta-more-SVGID_3_);}\n\t .beta-more .st3{fill:url(#beta-more-SVGID_4_);}\n  "
                                                        }}
                                                    />
                                                    <g className="beta-more">
                                                        <g>
                                                            <g>
                                                                <linearGradient
                                                                    id="beta-more-SVGID_1_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="23.19677"
                                                                    y1="11.26008"
                                                                    x2="-0.00012"
                                                                    y2="12.00304"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    className="st0"
                                                                    d="M11.63076,0.00043c-6.41339,0-11.6308,5.2171-11.6308,11.63007c0,6.41308,5.21741,11.63013,11.6308,11.63013
		c6.41296,0,11.63043-5.21704,11.63043-11.63013C23.26119,5.21753,18.04372,0.00043,11.63076,0.00043z M11.63076,21.82092
		c-5.6192,0-10.19043-4.57153-10.19043-10.19043c0-5.61884,4.57123-10.19037,10.19043-10.19037
		c5.61914,0,10.19074,4.57153,10.19074,10.19037C21.82149,17.24939,17.2499,21.82092,11.63076,21.82092z"
                                                                />
                                                                <linearGradient
                                                                    id="beta-more-SVGID_2_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="23.19224"
                                                                    y1="11.11866"
                                                                    x2="-0.00465"
                                                                    y2="11.86162"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    className="st1"
                                                                    d="M7.21065,10.43573c-0.65991,0-1.19495,0.53503-1.19495,1.19501c0,0.65955,0.53503,1.19458,1.19495,1.19458
		c0.65961,0,1.19464-0.53503,1.19464-1.19458C8.40529,10.97076,7.87026,10.43573,7.21065,10.43573z"
                                                                />
                                                                <linearGradient
                                                                    id="beta-more-SVGID_3_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="23.19677"
                                                                    y1="11.26008"
                                                                    x2="-0.00012"
                                                                    y2="12.00304"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    className="st2"
                                                                    d="M11.63076,10.43573c-0.65991,0-1.19501,0.53503-1.19501,1.19501c0,0.65955,0.5351,1.19458,1.19501,1.19458
		c0.65955,0,1.19458-0.53503,1.19458-1.19458C12.82534,10.97076,12.2903,10.43573,11.63076,10.43573z"
                                                                />
                                                                <linearGradient
                                                                    id="beta-more-SVGID_4_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="23.2013"
                                                                    y1="11.4015"
                                                                    x2="0.0044"
                                                                    y2="12.14446"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    className="st3"
                                                                    d="M16.0508,10.43573c-0.65991,0-1.19495,0.53503-1.19495,1.19501c0,0.65955,0.53503,1.19458,1.19495,1.19458
		c0.65961,0,1.19458-0.53503,1.19458-1.19458C17.24538,10.97076,16.71041,10.43573,16.0508,10.43573z"
                                                                />
                                                            </g>
                                                        </g>
                                                    </g>
                                                </svg>
                                            </div>
                                            <p className="sb-name">เพิ่มเติม</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="standard-button-container ">
                                    <button
                                        id=""
                                        className="standard-submit-form-button"
                                        data-button-category="submit"
                                        type="submit"
                                        onClick={() => window.location.href = '/logout'}
                                    >
                                        <span>ลงชื่อออก</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-right">
                            <div>
                                <div>
                                    <svg
                                        className="he2B3fr5m1nuf12b56a4"
                                        width={27}
                                        height={5}
                                        viewBox="0 0 27 5"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g
                                            id="he2B3fr5m1nuf12b56a4_Layer_1"
                                            clipPath="url(#he2B3fr5m1nuf12b56a4_clip0_2835_15573)"
                                        >
                                            <path
                                                id="he2B3fr5m1nuf12b56a4_Vector"
                                                d="M2.09305 4.66102C3.24901 4.66102 4.1861 3.72393 4.1861 2.56797C4.1861 1.41201 3.24901 0.474915 2.09305 0.474915C0.937091 0.474915 0 1.41201 0 2.56797C0 3.72393 0.937091 4.66102 2.09305 4.66102Z"
                                                fill="#8697A2"
                                            />
                                            <path
                                                id="he2B3fr5m1nuf12b56a4_he2B3fr5m1nuf12b56a4_Vector_2"
                                                d="M13.25 4.66102C14.406 4.66102 15.3431 3.72393 15.3431 2.56797C15.3431 1.41201 14.406 0.474915 13.25 0.474915C12.094 0.474915 11.157 1.41201 11.157 2.56797C11.157 3.72393 12.094 4.66102 13.25 4.66102Z"
                                                fill="#8697A2"
                                            />
                                            <path
                                                id="he2B3fr5m1nuf12b56a4_he2B3fr5m1nuf12b56a4_Vector_3"
                                                d="M24.407 4.66102C25.5629 4.66102 26.5 3.72393 26.5 2.56797C26.5 1.41201 25.5629 0.474915 24.407 0.474915C23.251 0.474915 22.3139 1.41201 22.3139 2.56797C22.3139 3.72393 23.251 4.66102 24.407 4.66102Z"
                                                fill="#8697A2"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="he2B3fr5m1nuf12b56a4_clip0_2835_15573">
                                                <rect
                                                    width="26.5"
                                                    height="4.19509"
                                                    fill="white"
                                                    transform="translate(0 0.474915)"
                                                />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </nav>
                </header>

                <div
                    className="standard-normal-font-size body-content-container m-settings-page mobileTopMargin"
                    data-radium="true"
                    style={{ marginTop: 59 }}
                >
                  <div className="deposit-progress-bar-container">
  <div className="account-info-container">
    <div className="account-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 17.28567 23.59276"
        className="beta-profile"
        width="100%"
        height="100%"
        id=""
        prefix=""
      >
        <g className="beta-profile">
          <g>
            <g>
              <path
                d="M2.7136,23.59256c-1.49661,0-2.714-1.21739-2.714-2.714v-0.59097c0-4.49253,3.55439-7.62975,8.64356-7.62975
		c5.08851,0,8.64291,3.13722,8.64291,7.62975v0.59097c0,1.49661-1.21739,2.714-2.714,2.714H2.7136z M8.64316,13.94322
		c-4.40147,0-7.35855,2.5496-7.35855,6.34437v0.59097c0,0.78814,0.64151,1.42896,1.429,1.42896h11.85846
		c0.78749,0,1.429-0.64082,1.429-1.42896v-0.59097C16.00106,16.49282,13.04398,13.94322,8.64316,13.94322z"
              />
              <path
                d="M8.64316,13.9258c-3.83965,0-6.9628-3.12316-6.9628-6.9628s3.12316-6.9628,6.9628-6.9628
		c3.83899,0,6.96215,3.12316,6.96215,6.9628S12.48215,13.9258,8.64316,13.9258z M8.64316,1.28588
		c-3.1305,0-5.67777,2.54693-5.67777,5.67712c0,3.1305,2.54727,5.67746,5.67777,5.67746c3.12984,0,5.67712-2.54696,5.67712-5.67746
		C14.32028,3.83281,11.773,1.28588,8.64316,1.28588z"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
    <span className="account-name">bobo35561c</span>
  </div>
  <div className="account-grade-container">
    <div className="account-group-container">
      <span
        className=" lazy-load-image-background opacity lazy-load-image-loaded"
        style={{ color: "transparent", display: "inline-block" }}
      >
        <img
          loading="lazy"
          src="/build/web/igame-index-lobby-wm/img/nav-profile-img.png"
          className="group-img"
          alt=""
        />
      </span>
      <p className="group-level">Normal</p>
    </div>
    <div className="account-leaderboard-container">
      <div className="icon-leaderboard-svg">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 23.78551 22.50142"
          className="beta-leaderboard"
          width="100%"
          height="100%"
          id=""
          prefix=""
        >
          <style
            dangerouslySetInnerHTML={{
              __html: "\n.beta-leaderboard .st0{fill:#0691C0;}\n  "
            }}
          />
          <g className="beta-leaderboard">
            <g>
              <g>
                <g>
                  <path
                    className="st0"
                    d="M20.26612,17.64887c1.31785,0,2.38991,1.07274,2.38991,2.39059v0.07166
      c0,1.31781-1.07206,2.3899-2.38991,2.3899H3.52006c-1.31785,0-2.3899-1.07209-2.3899-2.3899v-0.07166
      c0-1.31785,1.07206-2.39059,2.3899-2.39059H20.26612z M20.26612,21.19589c0.598,0,1.08482-0.48681,1.08482-1.08478v-0.07166
      c0-0.59865-0.48682-1.08546-1.08482-1.08546H3.52006c-0.59865,0-1.08546,0.48681-1.08546,1.08546v0.07166
      c0,0.59797,0.48681,1.08478,1.08546,1.08478H20.26612z"
                  />
                </g>
                <path
                  className="st0"
                  d="M23.49642,3.76839c-0.2377-0.1694-0.55645-0.1694-0.79483,0L16.25639,8.35l-3.7432-7.95789
  c-0.00469-0.00936-0.01138-0.01738-0.01608-0.02678c-0.01138-0.02143-0.0241-0.04217-0.03751-0.06295
  c-0.01203-0.01807-0.02479-0.0348-0.03816-0.05156c-0.01406-0.01738-0.0288-0.03346-0.04488-0.04886
  c-0.01673-0.01677-0.03346-0.03281-0.05222-0.04755c-0.01539-0.01272-0.03147-0.0241-0.0482-0.03548
  c-0.02143-0.01474-0.04354-0.02815-0.06699-0.04018c-0.00867-0.0047-0.01539-0.01073-0.02475-0.01474
  c-0.00871-0.00401-0.01742-0.00603-0.02612-0.00936c-0.0241-0.01005-0.0482-0.01875-0.07299-0.02613
  c-0.0194-0.00535-0.03885-0.01073-0.05894-0.01474c-0.02277-0.00466-0.04618-0.00737-0.06963-0.01005
  c-0.02074-0.00199-0.04217-0.00333-0.06294-0.00333c-0.02277,0-0.04554,0.00134-0.0683,0.00401
  c-0.02143,0.00199-0.04286,0.0047-0.06428,0.00871c-0.02143,0.00466-0.04286,0.01005-0.06428,0.01673
  c-0.02277,0.00669-0.04419,0.01406-0.06631,0.02345c-0.01005,0.00401-0.02006,0.006-0.0301,0.0107
  c-0.01005,0.0047-0.0181,0.01138-0.02815,0.01673c-0.02074,0.01073-0.04018,0.02277-0.05959,0.03552
  c-0.01875,0.01272-0.03751,0.02609-0.05492,0.04083c-0.01605,0.01341-0.03079,0.02746-0.04618,0.04217
  c-0.01741,0.01742-0.0335,0.03483-0.04889,0.05359c-0.01272,0.01539-0.0241,0.03147-0.03548,0.04755
  c-0.01406,0.02143-0.02746,0.04351-0.03953,0.06627c-0.00466,0.00871-0.0107,0.01608-0.01539,0.02544L7.52914,8.35L1.08329,3.76839
  c-0.23838-0.1694-0.55713-0.1694-0.79486,0c-0.2377,0.1694-0.34216,0.47073-0.2605,0.75067l4.32848,13.83025
  c0.08708,0.29934,0.36095,0.49353,0.65759,0.49353c0.06363,0,0.12857-0.00871,0.19285-0.02746
  c0.36363-0.10649,0.57187-0.48681,0.46607-0.85044L1.89687,6.02904l5.50569,3.91401c0.16608,0.11784,0.37501,0.156,0.57187,0.10447
  c0.19618-0.05156,0.35958-0.1875,0.44598-0.37165l3.47269-7.38067l3.47136,7.38067
  c0.08637,0.18414,0.24977,0.32008,0.44663,0.37165c0.19621,0.05153,0.40511,0.01337,0.57119-0.10447l5.50569-3.91401
  l-3.77536,11.9359c-0.10649,0.36363,0.10244,0.74395,0.46607,0.85044c0.06429,0.01875,0.12857,0.02746,0.19217,0.02746
  c0.29732,0,0.57054-0.19419,0.65824-0.49353l4.32848-13.83025C23.83927,4.23912,23.73481,3.93779,23.49642,3.76839z"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
      <p className="leaderboard-desc">&gt;100</p>
    </div>
  </div>
</div>

                       <MobileWalletSection
                        loginstate={loginstate}
                        balance={balance}
                        checkcredit={this.state.checkcredit}
                        showMemberAction={this.state.showMemberAction}
                        onRefresh={(e) => this.recheccredit(e)}
                        onToggleMemberAction={() => this.setState({ showMemberAction: !this.state.showMemberAction })}
                        onDeposit={() => this.props.navigate('/deposit')}
                        onWithdraw={() => this.props.navigate('/withdraw')}
                        onStatement={() => this.props.navigate('/statement')}
                        onMessage={() => window.location.href = '/manager/message'}
                    />

                    <div className="_mobile-banner-wrapper_l0ga8_49" style={{}}>
                        <div className="slick-slider slick-initialized" dir="ltr">
                            <div className="slick-list">
                                <div
                                    className="slick-track"
                                    style={{
                                        opacity: 1,
                                        transform: "translate3d(-920px, 0px, 0px)",
                                        width: 2300
                                    }}
                                >
                                    <div
                                        data-index={-1}
                                        tabIndex={-1}
                                        className="slick-slide slick-cloned"
                                        aria-hidden="true"
                                        style={{ width: 460 }}
                                    >
                                        <div>
                                            <div
                                                className="_banner-container_l0ga8_1"
                                                tabIndex={-1}
                                                style={{ width: "100%", display: "inline-block" }}
                                            >
                                                <img
                                                    loading="lazy"
                                                    src="https://s3.newworld.center/image/f11e9374-90db-45b4-a971-2b6d474fe100.webp"
                                                    className="_banner-img_l0ga8_14"
                                                    alt="banner-img"
                                                />
                                                <div className="_banner-content_l0ga8_5 ">
                                                    <p className="_banner-title_l0ga8_18" />
                                                    <div className="_banner-desc_l0ga8_25" />
                                                </div>
                                                <div>
                                                    <div />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        data-index={0}
                                        className="slick-slide"
                                        tabIndex={-1}
                                        aria-hidden="true"
                                        style={{ outline: "none", width: 460 }}
                                    >
                                        <div>
                                            <div
                                                className="_banner-container_l0ga8_1"
                                                tabIndex={-1}
                                                style={{ width: "100%", display: "inline-block" }}
                                            >
                                                <img
                                                    loading="lazy"
                                                    src="/build/web/igame-index-lobby-wm/img/banner20250411034116314.webp"
                                                    className="_banner-img_l0ga8_14"
                                                    alt="banner-img"
                                                />
                                                <div className="_banner-content_l0ga8_5 ">
                                                    <p className="_banner-title_l0ga8_18" />
                                                    <div className="_banner-desc_l0ga8_25" />
                                                </div>
                                                <div>
                                                    <div />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        data-index={1}
                                        className="slick-slide slick-active slick-current"
                                        tabIndex={-1}
                                        aria-hidden="false"
                                        style={{ outline: "none", width: 460 }}
                                    >
                                        <div>
                                            <div
                                                className="_banner-container_l0ga8_1"
                                                tabIndex={-1}
                                                style={{ width: "100%", display: "inline-block" }}
                                            >
                                                <img
                                                    loading="lazy"
                                                    src="https://s3.newworld.center/image/f11e9374-90db-45b4-a971-2b6d474fe100.webp"
                                                    className="_banner-img_l0ga8_14"
                                                    alt="banner-img"
                                                />
                                                <div className="_banner-content_l0ga8_5 ">
                                                    <p className="_banner-title_l0ga8_18" />
                                                    <div className="_banner-desc_l0ga8_25" />
                                                </div>
                                                <div>
                                                    <div />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        data-index={2}
                                        tabIndex={-1}
                                        className="slick-slide slick-cloned"
                                        aria-hidden="true"
                                        style={{ width: 460 }}
                                    >
                                        <div>
                                            <div
                                                className="_banner-container_l0ga8_1"
                                                tabIndex={-1}
                                                style={{ width: "100%", display: "inline-block" }}
                                            >
                                                <img
                                                    loading="lazy"
                                                    src="/build/web/igame-index-lobby-wm/img/banner20250411034116314.webp"
                                                    className="_banner-img_l0ga8_14"
                                                    alt="banner-img"
                                                />
                                                <div className="_banner-content_l0ga8_5 ">
                                                    <p className="_banner-title_l0ga8_18" />
                                                    <div className="_banner-desc_l0ga8_25" />
                                                </div>
                                                <div>
                                                    <div />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        data-index={3}
                                        tabIndex={-1}
                                        className="slick-slide slick-cloned"
                                        aria-hidden="true"
                                        style={{ width: 460 }}
                                    >
                                        <div>
                                            <div
                                                className="_banner-container_l0ga8_1"
                                                tabIndex={-1}
                                                style={{ width: "100%", display: "inline-block" }}
                                            >
                                                <img
                                                    loading="lazy"
                                                    src="https://s3.newworld.center/image/f11e9374-90db-45b4-a971-2b6d474fe100.webp"
                                                    className="_banner-img_l0ga8_14"
                                                    alt="banner-img"
                                                />
                                                <div className="_banner-content_l0ga8_5 ">
                                                    <p className="_banner-title_l0ga8_18" />
                                                    <div className="_banner-desc_l0ga8_25" />
                                                </div>
                                                <div>
                                                    <div />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="_dotsContainer_l0ga8_31">
                                <button className="_dots_l0ga8_31 " aria-label="slide 1 bullet" />
                                <button
                                    className="_dots_l0ga8_31 _active_l0ga8_45"
                                    aria-label="slide 2 bullet"
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        className="m-deposit-landing-container"
                        id="beta-deposit-landing"
                        style={{}}
                    >
                        <div className="standard-tab-container categorized-deposit-tab-container">
                            <div className="deposit-tab-header" id="deposit-tab-header">
                                <div
                                    className="_tabHeaderContainer_9c2z1_1 tab-header-container"
                                    id="deposit-tab-header-container"
                                >
                                    <div className={`_tabHeaderTitle_1ivtf_1 tab-header-title${this.state.tabselect === 1 ? ' _active_1ivtf_22' : ''}`} id="" onClick={(e) => this.checktab(e, 1)} style={{ cursor: 'pointer' }}>
                                        <span className="_titleContent_1ivtf_35">ฝากปกติ </span>
                                        <div>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                viewBox="0 0 50 50"
                                                className=""
                                                width="100%"
                                                height="100%"
                                                id=""
                                                prefix=""
                                            >
                                                <style
                                                    dangerouslySetInnerHTML={{
                                                        __html: "\n.beta-time .st0{fill:#FFFFFF;}\n  "
                                                    }}
                                                />
                                                <g className="beta-time">
                                                    <g>
                                                        <g>
                                                            <path
                                                                className="st0"
                                                                d="M2,23.65158c0.1175-0.87102,0.19916-1.74864,0.3582-2.612c1.1885-6.45181,4.53026-11.51159,9.94045-15.19425
		c3.12622-2.12799,6.60665-3.34789,10.36359-3.72999c3.53803-0.35984,6.98579,0.0968,10.32738,1.32413
		c2.23645,0.82142,4.28395,1.98315,6.17352,3.42953c0.77756,0.59519,1.04475,1.45981,0.70655,2.30254
		c-0.32626,0.81299-1.11409,1.31346-2.0078,1.16727c-0.39272-0.06424-0.79627-0.26959-1.12037-0.51095
		c-1.57022-1.16938-3.24706-2.13469-5.08684-2.81195c-2.93472-1.08032-5.95841-1.40826-9.05486-1.03026
		c-3.64452,0.4449-6.89575,1.85869-9.71448,4.19108c-3.59903,2.97807-5.89846,6.77189-6.73211,11.38651
		c-0.77844,4.309-0.20764,8.46179,1.88919,12.31697c2.97153,5.46339,7.52628,8.87722,13.67674,9.98228
		c5.02639,0.90311,9.72781-0.09441,13.94996-2.96727c4.47654-3.04596,7.26182-7.26511,8.20888-12.62465
		c0.69103-3.91062,0.18037-7.68375-1.44854-11.31205c-0.19428-0.43274-0.32899-0.9507-0.29488-1.41471
		c0.06151-0.83694,0.7527-1.47695,1.53258-1.59702c0.90474-0.1393,1.72884,0.25099,2.08213,1.12539
		c0.55323,1.36923,1.14592,2.74019,1.51273,4.16429c2.95651,11.47819-3.20293,23.21241-14.31344,27.34687
		c-2.00207,0.74501-4.07021,1.19953-6.2043,1.34409c-0.13172,0.00891-0.26123,0.05036-0.39177,0.07667
		c-0.89862,0-1.79723,0-2.69585,0c-0.11555-0.02539-0.23003-0.06578-0.34679-0.07401
		c-3.5829-0.25267-6.93555-1.27527-9.99791-3.1431c-5.98343-3.6495-9.66006-8.92505-10.95368-15.82955
		C2.19675,28.09532,2.11742,27.21781,2,26.34743C2,25.44881,2,24.5502,2,23.65158z"
                                                            />
                                                            <path
                                                                className="st0"
                                                                d="M26.91534,23.08875c0.2366,0,0.4121-0.00001,0.58761,0c2.30527,0.0001,4.61057,0.00579,6.91581-0.00281
		c0.77932-0.00291,1.40857,0.26281,1.81262,0.9453c0.76842,1.29793-0.14344,2.85426-1.70533,2.87173
		c-2.18525,0.02444-4.37096,0.00696-6.55648,0.00725c-0.94307,0.00012-1.88624,0.00877-2.82917-0.00249
		c-1.27536-0.01521-2.04057-0.77013-2.04301-2.04651c-0.00838-4.38599-0.00785-8.77202,0.00019-13.15801
		c0.00207-1.13007,0.65748-1.88282,1.70136-2.01426c0.92218-0.11612,1.79491,0.46277,2.03776,1.38416
		c0.07105,0.26958,0.07516,0.56213,0.07554,0.8442c0.00472,3.51778,0.0031,7.03557,0.00311,10.55336
		C26.91535,22.64898,26.91534,22.82731,26.91534,23.08875z"
                                                            />
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        </div>
                                        <span className="_titleContent_1ivtf_35"> 5 นาที</span>
                                    </div>
                                    <div
                                        className={`_tabHeaderTitle_1ivtf_1 tab-header-title${this.state.tabselect === 2 ? ' _active_1ivtf_22' : ''}`}
                                        id="tab_header_active"
                                        onClick={(e) => this.checktab(e, 2)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <span className="_titleContent_1ivtf_35">ฝากคริปโต </span>
                                        <div>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                viewBox="0 0 50 50"
                                                className=""
                                                width="100%"
                                                height="100%"
                                                id=""
                                                prefix=""
                                            >
                                                <style
                                                    dangerouslySetInnerHTML={{
                                                        __html: "\n.beta-time .st0{fill:#FFFFFF;}\n  "
                                                    }}
                                                />
                                                <g className="beta-time">
                                                    <g>
                                                        <g>
                                                            <path
                                                                className="st0"
                                                                d="M2,23.65158c0.1175-0.87102,0.19916-1.74864,0.3582-2.612c1.1885-6.45181,4.53026-11.51159,9.94045-15.19425
		c3.12622-2.12799,6.60665-3.34789,10.36359-3.72999c3.53803-0.35984,6.98579,0.0968,10.32738,1.32413
		c2.23645,0.82142,4.28395,1.98315,6.17352,3.42953c0.77756,0.59519,1.04475,1.45981,0.70655,2.30254
		c-0.32626,0.81299-1.11409,1.31346-2.0078,1.16727c-0.39272-0.06424-0.79627-0.26959-1.12037-0.51095
		c-1.57022-1.16938-3.24706-2.13469-5.08684-2.81195c-2.93472-1.08032-5.95841-1.40826-9.05486-1.03026
		c-3.64452,0.4449-6.89575,1.85869-9.71448,4.19108c-3.59903,2.97807-5.89846,6.77189-6.73211,11.38651
		c-0.77844,4.309-0.20764,8.46179,1.88919,12.31697c2.97153,5.46339,7.52628,8.87722,13.67674,9.98228
		c5.02639,0.90311,9.72781-0.09441,13.94996-2.96727c4.47654-3.04596,7.26182-7.26511,8.20888-12.62465
		c0.69103-3.91062,0.18037-7.68375-1.44854-11.31205c-0.19428-0.43274-0.32899-0.9507-0.29488-1.41471
		c0.06151-0.83694,0.7527-1.47695,1.53258-1.59702c0.90474-0.1393,1.72884,0.25099,2.08213,1.12539
		c0.55323,1.36923,1.14592,2.74019,1.51273,4.16429c2.95651,11.47819-3.20293,23.21241-14.31344,27.34687
		c-2.00207,0.74501-4.07021,1.19953-6.2043,1.34409c-0.13172,0.00891-0.26123,0.05036-0.39177,0.07667
		c-0.89862,0-1.79723,0-2.69585,0c-0.11555-0.02539-0.23003-0.06578-0.34679-0.07401
		c-3.5829-0.25267-6.93555-1.27527-9.99791-3.1431c-5.98343-3.6495-9.66006-8.92505-10.95368-15.82955
		C2.19675,28.09532,2.11742,27.21781,2,26.34743C2,25.44881,2,24.5502,2,23.65158z"
                                                            />
                                                            <path
                                                                className="st0"
                                                                d="M26.91534,23.08875c0.2366,0,0.4121-0.00001,0.58761,0c2.30527,0.0001,4.61057,0.00579,6.91581-0.00281
		c0.77932-0.00291,1.40857,0.26281,1.81262,0.9453c0.76842,1.29793-0.14344,2.85426-1.70533,2.87173
		c-2.18525,0.02444-4.37096,0.00696-6.55648,0.00725c-0.94307,0.00012-1.88624,0.00877-2.82917-0.00249
		c-1.27536-0.01521-2.04057-0.77013-2.04301-2.04651c-0.00838-4.38599-0.00785-8.77202,0.00019-13.15801
		c0.00207-1.13007,0.65748-1.88282,1.70136-2.01426c0.92218-0.11612,1.79491,0.46277,2.03776,1.38416
		c0.07105,0.26958,0.07516,0.56213,0.07554,0.8442c0.00472,3.51778,0.0031,7.03557,0.00311,10.55336
		C26.91535,22.64898,26.91534,22.82731,26.91534,23.08875z"
                                                            />
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                        </div>
                                        <span className="_titleContent_1ivtf_35"> 1-15 นาที</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.state.tabselect === 2 && <div className="deposit-label-offline-bank-container">
                            <div className="deposit-label-offline-bank ">
                                <label className="_transactionTitle_hzg77_1 standard-mandatory transaction-title standard-label" style={{ color: '#e2e8f0' }}>
                                    ตัวเลือกฝากเงิน
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        viewBox="0 0 90 90"
                                        className="transaction-title-icon"
                                        width="100%"
                                        height="100%"
                                        id=""
                                        prefix=""
                                    >
                                        <g className="D-referral-important">
                                            <path d="M45,0C20.1,0,0,20.1,0,45c0,24.9,20.1,45,45,45c24.9,0,45-20.1,45-45C90,20.1,69.9,0,45,0z M50.6,70.9 c0,3.1-2.5,5.6-5.6,5.6s-5.6-2.5-5.6-5.6V36.2c0-3.1,2.5-5.6,5.6-5.6s5.6,2.5,5.6,5.6V70.9z M45,24.7c-3.1,0-5.6-2.5-5.6-5.6 c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6C50.6,22.2,48.1,24.7,45,24.7z" />
                                        </g>
                                    </svg>
                                </label>
                                <div className="deposit-label-offline-bank-icons">
                                    <div className="reTrigger_step_button" id="needHelpBtn">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="36px"
                                            height="36px"
                                            viewBox="0 0 36 36"
                                            version="1.1"
                                        >
                                            <g id="surface1">
                                                <path d="M 18.191406 0.164062 C 8.378906 0.164062 0.378906 7.667969 0.378906 16.90625 C 0.378906 19.964844 1.257812 22.949219 2.933594 25.542969 L 3.054688 25.75 L -0.00390625 34.285156 L 9.378906 31.460938 L 9.578125 31.5625 C 12.191406 32.933594 15.175781 33.644531 18.191406 33.644531 C 28.019531 33.644531 36 26.140625 36 16.90625 C 36 7.667969 28.019531 0.164062 18.191406 0.164062 Z M 17.976562 26.113281 C 17.207031 26.113281 16.589844 25.53125 16.589844 24.800781 C 16.589844 24.074219 17.207031 23.488281 17.976562 23.488281 C 18.742188 23.488281 19.359375 24.074219 19.359375 24.800781 C 19.359375 25.53125 18.742188 26.113281 17.976562 26.113281 Z M 23.789062 13.714844 C 23.480469 14.585938 22.773438 15.140625 21.3125 16.699219 C 20.160156 17.925781 19.144531 18.871094 19.066406 20.460938 C 19.035156 21.160156 18.621094 21.65625 17.789062 21.582031 C 17.050781 21.523438 16.730469 20.851562 16.730469 20.226562 C 16.730469 18.070312 17.730469 16.976562 18.789062 15.855469 C 20.175781 14.398438 21.3125 13.65625 21.359375 12.5625 C 21.40625 11.324219 20.449219 10.203125 18.390625 10.085938 C 16.359375 9.984375 14.636719 11.238281 14.390625 13.101562 C 14.300781 13.726562 13.808594 14.195312 13.128906 14.136719 C 12.46875 14.078125 11.945312 13.523438 11.976562 12.882812 C 12.285156 9.75 15.113281 7.726562 18.480469 7.898438 C 22.171875 8.074219 24.757812 10.914062 23.789062 13.699219 Z M 23.789062 13.714844 " />
                                            </g>
                                        </svg>
                                        <span>รหัสผ่านไม่สามารถเหมือนกับชื่อผู้ใช้ของคุณได้</span>
                                    </div>
                                </div>
                            </div>
                        </div>}
                        {/* ── ฝากปกติ content (tabselect === 1) ── */}
                        {this.state.tabselect === 1 && (
                            <div className="standard-content-container" style={{ padding: '16px 20px' }}>
                                {/* บัญชีของคุณ */}
                                <div style={{ marginBottom: 14 }}>
                                    <label style={{ color: '#aab4be', fontSize: 13, marginBottom: 6, display: 'block' }}>บัญชีของคุณ</label>
                                    <div style={{ background: '#1a2236', border: '1px solid #2a3448', borderRadius: 10, padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12 }}>
                                        {accnumberx && accnumberx.bank_abbrev && (
                                            <img
                                                src={`/build/web/igame-index-lobby-wm/img/${accnumberx.bank_abbrev}.png`}
                                                alt={accnumberx.bank_abbrev}
                                                style={{ width: 38, height: 38, borderRadius: 8 }}
                                                onError={e => { e.target.style.display = 'none'; }}
                                            />
                                        )}
                                        <div>
                                            <div style={{ color: '#fff', fontWeight: 600, fontSize: 15 }}>
                                                {accnumberx ? accnumberx.bank_abbrev : ''} {accnumberx ? accnumberx.accnumber : ''}
                                            </div>
                                            <div style={{ color: '#aab4be', fontSize: 12 }}>{firstname} {this.state.lastname}</div>
                                        </div>
                                    </div>
                                </div>
                                {/* เลือกธนาคาร */}
                                <div style={{ marginBottom: 14 }}>
                                    <label style={{ color: '#aab4be', fontSize: 13, marginBottom: 6, display: 'block' }}>เลือกธนาคาร</label>
                                    {mainacc != null && (
                                        <div style={{ background: '#1a2236', border: '2px solid #f97316', borderRadius: 10, padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
                                            <img
                                                src={mainacc.img_path || `/build/web/igame-index-lobby-wm/img/${mainacc.bank_abbrev}.png`}
                                                alt={mainacc.bank_abbrev}
                                                style={{ width: 38, height: 38, borderRadius: 8 }}
                                                onError={e => { e.target.style.display = 'none'; }}
                                            />
                                            <div style={{ flex: 1 }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                    <span style={{ color: '#fff', fontWeight: 600, fontSize: 15 }}>{mainacc.fullname_th || mainacc.bank_abbrev}</span>
                                                    <span style={{ background: '#22c55e', color: '#fff', fontSize: 10, borderRadius: 4, padding: '1px 6px' }}>ออนไลน์</span>
                                                </div>
                                                <div style={{ color: '#e2e8f0', fontSize: 14, fontWeight: 500, marginTop: 2 }}>
                                                    {mainacc.accnumber && mainacc.accnumber.length >= 12
                                                        ? `${mainacc.accnumber.substring(0, 3)}-${mainacc.accnumber.substring(3, 9)}-${mainacc.accnumber.substring(9, 12)}`
                                                        : mainacc.accnumber}
                                                </div>
                                                <div style={{ color: '#aab4be', fontSize: 12 }}>{mainacc.first_name_en} {mainacc.last_name_en}</div>
                                            </div>
                                            <button
                                                onClick={() => { navigator.clipboard.writeText(mainacc.accnumber); }}
                                                style={{ background: '#f97316', border: 'none', color: '#fff', borderRadius: 8, padding: '6px 12px', fontSize: 13, cursor: 'pointer', fontWeight: 600, whiteSpace: 'nowrap' }}
                                            >
                                                คัดลอก
                                            </button>
                                        </div>
                                    )}
                                </div>
                                {/* จำนวนเงิน */}
                                <div style={{ marginBottom: 14 }}>
                                    <label style={{ color: '#aab4be', fontSize: 13, marginBottom: 6, display: 'block' }}>จำนวนเงินที่ต้องการฝาก</label>
                                    <input
                                        type="number"
                                        placeholder="ระบุจำนวนเงิน"
                                        value={this.state.depositamount}
                                        onChange={this.onChangexdep}
                                        style={{ width: '100%', background: '#1a2236', border: '1px solid #2a3448', borderRadius: 10, padding: '12px 16px', color: '#fff', fontSize: 15, boxSizing: 'border-box', outline: 'none' }}
                                    />
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 10 }}>
                                        {[100, 300, 500, 1000, 3000, 5000].map(amt => (
                                            <button
                                                key={amt}
                                                onClick={() => this.setState({ depositamount: amt })}
                                                style={{ flex: '1 0 28%', background: '#2a3448', border: '1px solid #3a4560', color: '#fff', borderRadius: 8, padding: '8px 0', fontSize: 14, cursor: 'pointer' }}
                                            >
                                                {amt.toLocaleString()}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                                {/* หมายเหตุ */}
                                <div style={{ background: '#1a2236', border: '1px solid #2a3448', borderRadius: 10, padding: '10px 14px', marginBottom: 14, color: '#60a5fa', fontSize: 13 }}>
                                    กรุณาโอนเงินจากบัญชีของคุณที่ลงทะเบียนไว้เท่านั้น แล้วกดยืนยันหลังโอนเสร็จ
                                </div>
                                <button
                                    className="btn w-100"
                                    onClick={(e) => this.confirmdeposit(e, 1)}
                                    style={{ background: 'linear-gradient(135deg,#f97316,#ea580c)', color: '#fff', border: 'none', borderRadius: 10, padding: '13px 0', fontWeight: 700, fontSize: 16, cursor: 'pointer', width: '100%' }}
                                >
                                    ยืนยันการฝากเงิน
                                </button>
                            </div>
                        )}

                        {/* ── ฝากคริปโต content (tabselect === 2) ── */}
                        {this.state.tabselect === 2 && (
                            <>
                                <div className="deposit-tab-container" id="deposit-option-container">
                                    <div className="standard-tab transaction-option" id="transaction-option">
                                        <div>
                                            <div
                                                className="_transactionOptionTabHeader_ktmyr_1 transaction-option-tab-header _active_ktmyr_44"
                                                data-tutorialkey-selected="CT"
                                                data-tutorialkey="CT"
                                            >
                                                <div className="_transactionOptionImageContainer_ktmyr_30 transaction-option-image-container image-container">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        viewBox="0 0 50 50"
                                                        className="beta-option-CT"
                                                        width="100%"
                                                        height="100%"
                                                        id=""
                                                        prefix=""
                                                    >
                                                        <style
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                    "\n.beta-option-CT .st0{fill:url(#beta-option-CT-SVGID_1_);}\n\t .beta-option-CT .st1{fill:url(#beta-option-CT-SVGID_2_);}\n  "
                                                            }}
                                                        />
                                                        <g className="beta-option-CT">
                                                            <g>
                                                                <linearGradient
                                                                    id="beta-option-CT-SVGID_1_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1={0}
                                                                    y1="24.9989"
                                                                    x2={50}
                                                                    y2="24.9989"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    className="st0"
                                                                    d="M25,50C11.2,50,0,38.8,0,25C0,11.2,11.2,0,25,0c13.8,0,25,11.2,25,25C50,38.8,38.8,50,25,50z M25,3.1
	C12.9,3.1,3.1,12.9,3.1,25c0,12.1,9.8,21.9,21.9,21.9c12.1,0,21.9-9.8,21.9-21.9C46.9,12.9,37.1,3.1,25,3.1z"
                                                                />
                                                                <linearGradient
                                                                    id="beta-option-CT-SVGID_2_"
                                                                    gradientUnits="userSpaceOnUse"
                                                                    x1="11.8836"
                                                                    y1="24.9983"
                                                                    x2="36.8998"
                                                                    y2="24.9983"
                                                                >
                                                                    <stop
                                                                        offset={0}
                                                                        style={{ stopColor: "rgb(9, 94, 189)" }}
                                                                    />
                                                                    <stop
                                                                        offset={1}
                                                                        style={{ stopColor: "rgb(4, 169, 194)" }}
                                                                    />
                                                                </linearGradient>
                                                                <path
                                                                    className="st1"
                                                                    d="M24.5,41.3c-0.1,0-0.1,0-0.2,0l-2.7-0.7c-0.2,0-0.4-0.2-0.5-0.3c-0.1-0.2-0.1-0.4-0.1-0.6L22,36
	c-0.2-0.1-0.5-0.1-0.7-0.2l-0.9,3.7c0,0.2-0.2,0.4-0.3,0.5c-0.2,0.1-0.4,0.1-0.6,0.1l-2.7-0.7c-0.4-0.1-0.6-0.5-0.5-0.9l0.9-3.8l0,0
	c-0.4-0.1-0.8-0.2-1.2-0.3l-3.5-0.9c-0.2-0.1-0.4-0.2-0.5-0.4s-0.1-0.4,0-0.6l1.3-3.1c0.1-0.3,0.5-0.5,0.9-0.4
	c0.8,0.2,1.6,0.4,1.8,0.5c0,0,0.1,0,0.1,0c0.2,0,0.2,0,0.3-0.2l1.8-7c0-0.1,0-0.1,0.1-0.2c0.1-0.4,0.7-2.7,1.2-4.8
	c0-0.3-0.1-0.6-0.7-0.7c0,0-0.1,0-0.1,0c-0.2-0.1-1.1-0.3-1.8-0.4c-0.2,0-0.4-0.2-0.5-0.3s-0.1-0.4-0.1-0.6l0.7-2.9
	c0-0.2,0.2-0.4,0.3-0.5c0.2-0.1,0.4-0.1,0.6-0.1l3.7,0.9c0,0,0.1,0,0.1,0c0.3,0.1,0.6,0.1,0.9,0.2l0.9-3.7c0.1-0.4,0.5-0.6,0.9-0.5
	l2.7,0.7c0.4,0.1,0.6,0.5,0.5,0.9l-0.9,3.6c0.2,0.1,0.5,0.1,0.7,0.2l0.9-3.6c0-0.2,0.2-0.4,0.3-0.5c0.2-0.1,0.4-0.1,0.6-0.1l2.7,0.7
	c0.2,0,0.4,0.2,0.5,0.3c0.1,0.2,0.1,0.4,0.1,0.6l-0.9,3.8c2,0.7,5.9,2.6,5.3,6.8c-0.3,1.9-1.1,3.2-2.5,4c2,1.6,2.5,3.8,1.5,6.6
	c-1.7,4.8-5.7,4.9-9.7,4.3l-0.9,3.8C25.1,41.1,24.8,41.3,24.5,41.3z M22.7,39.3l1.2,0.3l0.9-3.7c0.1-0.4,0.5-0.6,0.9-0.6
	c5.1,1,7.5,0.1,8.7-3.2c0.9-2.7,0.3-4.4-2.1-5.6c-0.3-0.1-0.4-0.4-0.4-0.8c0-0.3,0.3-0.6,0.6-0.6c1.7-0.4,2.6-1.5,2.9-3.3
	c0,0,0,0,0,0c0.4-2.4-1.1-4.1-4.9-5.4c-0.4-0.1-0.6-0.5-0.5-0.9l0.9-3.7l-1.2-0.3l-0.9,3.6c-0.1,0.4-0.5,0.6-0.9,0.5
	c-0.7-0.2-1.4-0.3-2.1-0.5c-0.2,0-0.4-0.2-0.5-0.3s-0.1-0.4-0.1-0.6l0.9-3.6l-1.2-0.3L23.9,14c-0.1,0.4-0.5,0.6-0.9,0.5
	c-0.6-0.1-1.2-0.3-1.7-0.4c0,0-0.1,0-0.1,0l-2.9-0.7l-0.4,1.4c0.6,0.1,1,0.2,1.2,0.3c1.2,0.3,1.9,1.2,1.8,2.3c0,0,0,0.1,0,0.1
	c-0.8,3.4-1.1,4.6-1.3,5.1l-1.8,7c0,0,0,0.1,0,0.1c-0.4,0.9-1.2,1.3-2.1,1.1l0,0c-0.3,0-0.7-0.2-1.4-0.3l-0.7,1.7l2.7,0.7
	c0.4,0.1,0.8,0.2,1.2,0.3l0.8,0.2c0.4,0.1,0.6,0.5,0.5,0.9l-0.9,3.8l1.2,0.3l0.9-3.7c0-0.2,0.2-0.4,0.3-0.5c0.2-0.1,0.4-0.1,0.6-0.1
	c0.7,0.2,1.4,0.4,2.1,0.6c0.4,0.1,0.6,0.5,0.5,0.9L22.7,39.3z M26.6,33.3c-1.7,0-3.5-0.5-4.6-0.8l-0.5-0.1c-0.2,0-0.4-0.2-0.5-0.3
	c-0.1-0.2-0.1-0.4-0.1-0.6l1.5-5.9c0.1-0.4,0.5-0.6,0.9-0.5c0.2,0,0.4,0.1,0.6,0.1c1.9,0.4,5.2,1.2,6.4,3.1c0.5,0.7,0.6,1.6,0.4,2.5
	c-0.2,0.9-0.7,1.5-1.4,2C28.5,33.2,27.6,33.3,26.6,33.3z M22.5,31.1c1.6,0.4,4.5,1.1,5.9,0.3c0.4-0.2,0.6-0.6,0.7-1c0,0,0,0,0,0
	c0.1-0.5,0.1-0.9-0.2-1.3c-0.9-1.4-3.8-2.1-5.4-2.4L22.5,31.1z M27.8,24.5c-1.4,0-2.8-0.4-3.8-0.6l-0.4-0.1
	c-0.4-0.1-0.6-0.5-0.5-0.9l1.3-5.4c0-0.2,0.2-0.4,0.3-0.5c0.2-0.1,0.4-0.1,0.6-0.1c0.1,0,0.3,0.1,0.5,0.1c1.6,0.4,4.2,0.9,5.3,2.7
	c0.4,0.7,0.6,1.5,0.3,2.4l0,0c-0.2,0.8-0.7,1.5-1.4,1.9C29.5,24.4,28.6,24.5,27.8,24.5z M24.7,22.5c1.3,0.3,3.5,0.9,4.7,0.2
	c0.4-0.2,0.6-0.5,0.7-1c0.1-0.5,0.1-0.9-0.2-1.2c-0.7-1.1-2.9-1.7-4.2-1.9L24.7,22.5z M30.8,21.9L30.8,21.9L30.8,21.9z"
                                                                />
                                                            </g>
                                                        </g>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div className="_transactionOptionTitle_ktmyr_69 transaction-option-title">
                                                คริปโต
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="standard-content-container">
                                    <div className="m-standard-transaction-container m-deposit-crypto-container">
                                        <div className="standard-form-container m-transaction-form">
                                            <div
                                                className="standard-form-field bank-detail-field"
                                                name="transaction-form-bank"
                                                id="transaction-form-bank"
                                            >
                                                <div className="bank-detail-label-wrapper">
                                                    <label className="_transactionTitle_hzg77_1 standard-mandatory transaction-title standard-label" style={{ color: '#e2e8f0' }}>
                                                        เลือกเครือข่าย
                                                    </label>
                                                </div>
                                                <div className="standard-form-field bank-select-deposit-container">
                                                    <div className="standard-form-field-wrapper  ">
                                                        <div
                                                            id="dropdownBtn"
                                                            className="standard-select _selectBankOption_1t44k_16  "
                                                            style={{ color: '#e2e8f0', background: '#1a2236', border: '1px solid #2a3448', borderRadius: 8, padding: '10px 14px' }}
                                                        >
                                                            กรุณาเลือก
                                                            <span className="standard-select-arrow " />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="m-transaction-note-section">
                                        <div className="transaction-notes-container">
                                            <div className="notes-modal">
                                                <div className="note-info-detail" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )} {/* end ฝากคริปโต */}

                        <div className="recent-transaction">
                            <div className="_recentTransactionContainer_yt0gb_1 recent-transaction-container">
                                <div className="_dropdownTitle_uxqg3_1 recent-transaction-title" style={{ color: '#e2e8f0' }}>
                                    ธุรกรรมล่าสุดของฉัน
                                    <div id="dropdown-arrow" className="_dropdownArrow_uxqg3_21 ">
                                        <svg
                                            className="hAror96dp3eww1cc5ooafn7dr4"
                                            width={17}
                                            height={17}
                                            viewBox="0 0 17 17"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g id="hAror96dp3eww1cc5ooafn7dr4_dropdown">
                                                <path
                                                    id="hAror96dp3eww1cc5ooafn7dr4_Vector"
                                                    d="M14.5444 7.10467C14.5444 7.38307 14.4409 7.66252 14.235 7.87536L9.56017 12.7069C9.30038 12.9766 8.95498 13.1228 8.5885 13.1228C8.22093 13.1228 7.87662 12.9744 7.6178 12.7058L2.94304 7.87536C2.53005 7.44963 2.53005 6.75865 2.94304 6.33181C3.35604 5.90502 4.02568 5.90502 4.43759 6.33181L8.5885 10.6219L12.7394 6.33181C13.1523 5.90502 13.821 5.90502 14.235 6.33181C14.4409 6.5447 14.5444 6.82415 14.5444 7.10467Z"
                                                    fill="#61757E"
                                                />
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                                <div
                                    id="recent-transaction-table-container"
                                    className="_recentTransactionTableContainer_yt0gb_5 "
                                >
                                    <table className="_recentTransactionTable_yt0gb_5 recent-transaction-table" style={{ color: '#e2e8f0', width: '100%' }}>
                                        <thead>
                                            <tr className="_recentTransactionRow_yt0gb_14 recent-transaction-row" style={{ color: '#aab4be' }}>
                                                <th>วันที่โอนเงิน</th>
                                                <th>จำนวนเงิน</th>
                                                <th>สถานะ</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="_emptyRecord_yt0gb_39 empty-record">
                                                <td colSpan={4} style={{ color: '#aab4be', textAlign: 'center', padding: '20px 0' }}>ยังไม่มีรายการ</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className="_viewMore_yt0gb_43 view-more">
                                        <span style={{ color: '#f97316', cursor: 'pointer' }}>อ่านเพิ่มเติม </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    <Navmenu />
            </>
        );

    }
}
export default withRouter(App);
